/* istanbul ignore file: this code is auto generated */
/* eslint-disable */
import { GraphQLClient } from 'graphql-request';
import { RequestInit } from 'graphql-request/dist/types.dom';
import { useMutation, useQuery, UseMutationOptions, UseQueryOptions } from 'react-query';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };

function fetcher<TData, TVariables extends { [key: string]: any }>(client: GraphQLClient, query: string, variables?: TVariables, requestHeaders?: RequestInit['headers']) {
  return async (): Promise<TData> => client.request({
    document: query,
    variables,
    requestHeaders
  });
}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Base64Bytes: any;
  Date: any;
  Datetime: any;
  PositiveInt: any;
};

export type AddConnectionInput = {
  endpoint: Scalars['String'];
  internalEndpoint?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  org_domain?: InputMaybe<Scalars['String']>;
  /** Scope for SSO token exchange when authenticating via org SSO */
  ssoTokenExchangeScope?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
  useBrowserAuth?: InputMaybe<Scalars['Boolean']>;
  useSSO?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
};

export type AddInvitationResult = {
  __typename?: 'AddInvitationResult';
  email: Scalars['String'];
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type AddInvitationsResponse = {
  __typename?: 'AddInvitationsResponse';
  error?: Maybe<Scalars['String']>;
  results?: Maybe<Array<AddInvitationResult>>;
};

export type AddMyOrgConnectionInput = {
  endpoint: Scalars['String'];
  internalEndpoint?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  org_domain: Scalars['String'];
  token?: InputMaybe<Scalars['String']>;
  username: Scalars['String'];
};

export type AddOrganizationInput = {
  admins?: InputMaybe<Array<Scalars['String']>>;
  description?: InputMaybe<Scalars['String']>;
  domain: Scalars['String'];
  name: Scalars['String'];
};

export type AddOrganizationResult = {
  __typename?: 'AddOrganizationResult';
  invitationResults?: Maybe<Array<AddInvitationResult>>;
  organization?: Maybe<Organization>;
};

export type AddSsoConnectionInput = {
  connection_name: Scalars['String'];
  internalEndpoint?: InputMaybe<Scalars['String']>;
  provider_name: Scalars['String'];
  stardog_endpoint: Scalars['String'];
};

export type ApiToken = {
  __typename?: 'ApiToken';
  created: Scalars['Datetime'];
  expires: Scalars['Datetime'];
  id: Scalars['ID'];
  last_used?: Maybe<Scalars['Datetime']>;
  name?: Maybe<Scalars['String']>;
  prefix: Scalars['String'];
};

/** ArchivedCloud, represents an archived Stardog Cloud instance */
export type ArchivedCloud = {
  __typename?: 'ArchivedCloud';
  bi_endpoint?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['String']>;
  customer_ref?: Maybe<Scalars['String']>;
  endpoint?: Maybe<Scalars['String']>;
  flavor?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  payment_ref?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
};

export type AzureProvider = {
  __typename?: 'AzureProvider';
  customerName: Scalars['String'];
};

export type BillingSession = {
  __typename?: 'BillingSession';
  session_id?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type BillingSessionInput = {
  name?: InputMaybe<Scalars['String']>;
};

export type CancelCloudInput = {
  cloud_id: Scalars['String'];
  connection_id: Scalars['String'];
};

export type CheckoutLineItem = {
  flavor: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  quantity?: InputMaybe<Scalars['Int']>;
};

export type CloudCleanupInput = {
  cloudName?: InputMaybe<Scalars['String']>;
  userName?: InputMaybe<Scalars['String']>;
};

/**
 * A single access entry on a personal cloud connection being previewed for a
 * move into a public organization. Covers access shared in either shape:
 * accepted user-level grants, pending connection invitations, and legacy
 * endpoint ("cloud") invitations, merged per email.
 */
export type CloudConnectionMoveAccess = {
  __typename?: 'CloudConnectionMoveAccess';
  accepted?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  is_cloud_owner?: Maybe<Scalars['Boolean']>;
  owns_separate_connection?: Maybe<Scalars['Boolean']>;
  stardog_roles?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type CloudConnectionMoveAccessInput = {
  email: Scalars['String'];
  organization_role: Scalars['String'];
};

/** Preview of moving a personal cloud connection into a public organization. */
export type CloudConnectionMovePreview = {
  __typename?: 'CloudConnectionMovePreview';
  access?: Maybe<Array<Maybe<CloudConnectionMoveAccess>>>;
  connection_id?: Maybe<Scalars['ID']>;
  connection_name?: Maybe<Scalars['String']>;
  eligible?: Maybe<Scalars['Boolean']>;
  endpoint?: Maybe<Scalars['String']>;
  ineligible_reason?: Maybe<Scalars['String']>;
  other_connections?: Maybe<Array<Maybe<Scalars['String']>>>;
  source_org_name?: Maybe<Scalars['String']>;
};

/** Whether a moved connection is usable by all org members or only the migrated users. */
export enum CloudConnectionMoveVisibility {
  OrgWide = 'ORG_WIDE',
  Restricted = 'RESTRICTED'
}

/** Filters for the cloud report query */
export type CloudFilters = {
  flavor?: InputMaybe<Scalars['String']>;
  ownerInactiveDays?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

/** Stardog Cloud Flavor and Size info */
export type CloudFlavor = {
  __typename?: 'CloudFlavor';
  disk?: Maybe<Scalars['String']>;
  iops?: Maybe<Scalars['Float']>;
  is_cluster?: Maybe<Scalars['Boolean']>;
  memory?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nodes?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  vcpus?: Maybe<Scalars['Float']>;
};

export type CloudInvitationInput = {
  email: Scalars['String'];
  endpoint: Scalars['String'];
  role: Scalars['String'];
};

/** Cloud report data with filtered results and statistics */
export type CloudReportData = {
  __typename?: 'CloudReportData';
  clouds?: Maybe<Array<Maybe<StardogCloud>>>;
  queueCounts?: Maybe<QueueCounts>;
  stats?: Maybe<CloudReportStats>;
};

/** Statistics for the cloud report */
export type CloudReportStats = {
  __typename?: 'CloudReportStats';
  resultCount?: Maybe<Scalars['Int']>;
  resultInactiveCount?: Maybe<Scalars['Int']>;
  totalAllocated?: Maybe<Scalars['Int']>;
  totalInactive?: Maybe<Scalars['Int']>;
};

/** A staff-only live SDU total for one cloud. Failures are isolated per cloud. */
export type CloudSduLifetime = {
  __typename?: 'CloudSduLifetime';
  cloudId: Scalars['ID'];
  status: CloudSduStatus;
  totalUnitsConsumed?: Maybe<Scalars['Float']>;
};

export enum CloudSduStatus {
  Error = 'ERROR',
  Ok = 'OK',
  Unavailable = 'UNAVAILABLE'
}

/** A live daily Stardog Unit total used by the employee cloud report CSV download. */
export type CloudSduUsageRecord = {
  __typename?: 'CloudSduUsageRecord';
  date: Scalars['String'];
  totalUnitsConsumed: Scalars['Float'];
};

/**
 * A single access entry on the source connection being transferred to another
 * user. `carried_access` entries move to the destination connection; `other_access`
 * entries are shown for context only and are left as-is.
 */
export type CloudTransferAccess = {
  __typename?: 'CloudTransferAccess';
  accepted?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  stardog_roles?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/**
 * Preview of transferring a cloud's personal connection to another user.
 * Loaded when the dialog opens (independent of the chosen target user):
 * the source connection, eligibility, the access that will be carried over
 * (the source connection's own grants + pending invites), and read-only context
 * for everything else pointed at the endpoint that is left as-is.
 */
export type CloudTransferPreview = {
  __typename?: 'CloudTransferPreview';
  /** Access on the source connection that will move to the destination. */
  carried_access?: Maybe<Array<Maybe<CloudTransferAccess>>>;
  connection_id?: Maybe<Scalars['ID']>;
  connection_name?: Maybe<Scalars['String']>;
  eligible?: Maybe<Scalars['Boolean']>;
  endpoint?: Maybe<Scalars['String']>;
  ineligible_reason?: Maybe<Scalars['String']>;
  /** Access via other personal connections at the endpoint, shown for context and left as-is. */
  other_access?: Maybe<Array<Maybe<CloudTransferAccess>>>;
  /** Other connections pointed at the endpoint, shown for context and left as-is. */
  other_connections?: Maybe<Array<Maybe<Scalars['String']>>>;
  source_org_name?: Maybe<Scalars['String']>;
};

/**
 * Result of resolving a transfer target user: whether the user exists and their
 * eligible destination connection(s) to the cloud's endpoint. No candidates means
 * a new personal connection will be created for them.
 */
export type CloudTransferTarget = {
  __typename?: 'CloudTransferTarget';
  candidates?: Maybe<Array<Maybe<CloudTransferTargetConnection>>>;
  user_exists?: Maybe<Scalars['Boolean']>;
};

/**
 * An eligible destination connection for the target user (a personal connection
 * to the cloud's endpoint).
 */
export type CloudTransferTargetConnection = {
  __typename?: 'CloudTransferTargetConnection';
  connection_id?: Maybe<Scalars['ID']>;
  connection_name?: Maybe<Scalars['String']>;
};

/** Saved Connection info for a Stardog instance */
export type Connection = {
  __typename?: 'Connection';
  access?: Maybe<ConnectionAccess>;
  cloud?: Maybe<StardogCloud>;
  dashboard?: Maybe<Scalars['String']>;
  endpoint: Scalars['String'];
  id: Scalars['ID'];
  index: Scalars['Int'];
  internalEndpoint?: Maybe<Scalars['String']>;
  isAllocating?: Maybe<Scalars['Boolean']>;
  isStardogCloud?: Maybe<Scalars['Boolean']>;
  isStardogFree?: Maybe<Scalars['Boolean']>;
  isWaitingForPayment?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  organization?: Maybe<Organization>;
  shouldShowDesigner?: Maybe<Scalars['Boolean']>;
  /** SSO provider information (only present for SSO connections) */
  ssoProvider?: Maybe<SsoProviderInfo>;
  /** Scope for SSO token exchange when authenticating via org SSO */
  ssoTokenExchangeScope?: Maybe<Scalars['String']>;
  stripeSubscription?: Maybe<PurchaseSession>;
  stripeSubscriptionOrder?: Maybe<ProvisionedOrder>;
  token?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  /** @deprecated useBrowserAuth is deprecated. Check if username and token are empty to determine if browser authentication is used. */
  useBrowserAuth?: Maybe<Scalars['Boolean']>;
  useConnectionSSO?: Maybe<Scalars['Boolean']>;
  useSSO?: Maybe<Scalars['Boolean']>;
  username?: Maybe<Scalars['String']>;
  /**
   * Whether this connection authenticates members via org SSO token exchange.
   * Set by Stardog ops at provisioning time.
   */
  usesOrgSso?: Maybe<Scalars['Boolean']>;
};

/** Connection access record granting access to a user or organization */
export type ConnectionAccess = {
  __typename?: 'ConnectionAccess';
  connection?: Maybe<Connection>;
  id: Scalars['ID'];
  organization?: Maybe<Organization>;
  organization_is_enabled?: Maybe<Scalars['Boolean']>;
  stardog_roles?: Maybe<Array<Maybe<Scalars['String']>>>;
  user?: Maybe<User>;
  user_is_private?: Maybe<Scalars['Boolean']>;
};

/** Connection invitation for granting access to a user for a personal connection */
export type ConnectionInvitation = {
  __typename?: 'ConnectionInvitation';
  accepted?: Maybe<Scalars['Boolean']>;
  connection_roles?: Maybe<Array<Scalars['String']>>;
  created?: Maybe<Scalars['Datetime']>;
  email: Scalars['String'];
  expired?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
};

/**
 * Input for creating connection invitations.
 * Connection must belong to a personal organization.
 */
export type ConnectionInvitationsInput = {
  connection_id: Scalars['ID'];
  connection_roles?: InputMaybe<Array<Scalars['String']>>;
  emails: Array<Scalars['String']>;
};

export type CreateApiTokenInput = {
  app_id?: InputMaybe<Scalars['ID']>;
  /** Days until the token expires, from 1 to 360. */
  expires_days: Scalars['PositiveInt'];
  name: Scalars['String'];
};

export type CreateApiTokenResult = {
  __typename?: 'CreateApiTokenResult';
  secret: Scalars['String'];
};

/** Input for creating a Microsoft Entra SSO configuration */
export type CreateOrganizationMicrosoftEntraSsoConfigInput = {
  /** OAuth client ID from Microsoft Entra */
  clientId: Scalars['String'];
  /** OAuth client secret from Microsoft Entra */
  clientSecret: Scalars['String'];
  /** OIDC discovery endpoint URL (.well-known/openid-configuration) */
  discoveryUrl: Scalars['String'];
  /** Whether to end the user's IDP session on logout (RP-Initiated Logout) */
  idpLogoutEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Whether SSO login is enabled (defaults to true) */
  isEnabled?: InputMaybe<Scalars['Boolean']>;
};

/** Input for creating an Okta SSO configuration */
export type CreateOrganizationOktaSsoConfigInput = {
  /** OAuth client ID from Okta */
  clientId: Scalars['String'];
  /** OAuth client secret from Okta */
  clientSecret: Scalars['String'];
  /** OIDC discovery endpoint URL (.well-known/openid-configuration) */
  discoveryUrl: Scalars['String'];
  /** Whether to end the user's IDP session on logout (RP-Initiated Logout) */
  idpLogoutEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Whether SSO login is enabled (defaults to true) */
  isEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Authorization server audience (required for Okta token exchange) */
  oktaAuthorizationServerAudience: Scalars['String'];
  /** Client ID for the backend API Services app (for OBO token exchange) */
  oktaBackendClientId: Scalars['String'];
  /** Client secret for the backend API Services app */
  oktaBackendClientSecret: Scalars['String'];
};

export type CreateVoiceboxAppInput = {
  connection_id: Scalars['String'];
  database?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  named_graphs?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  reasoning?: InputMaybe<Scalars['Boolean']>;
};

export type CustomerSsoSettings = {
  __typename?: 'CustomerSsoSettings';
  azureProviders: Array<Maybe<AzureProvider>>;
  oktaProviders: Array<Maybe<OktaProvider>>;
  pingProviders: Array<Maybe<PingProvider>>;
};

export type DeleteApiTokenInput = {
  app_id?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
};

export type DeleteConnectionInput = {
  id: Scalars['ID'];
  org_domain?: InputMaybe<Scalars['String']>;
};

export type DeleteInvitationResult = {
  __typename?: 'DeleteInvitationResult';
  error?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  success: Scalars['Boolean'];
};

export type DeleteInvitationsResponse = {
  __typename?: 'DeleteInvitationsResponse';
  error?: Maybe<Scalars['String']>;
  results?: Maybe<Array<DeleteInvitationResult>>;
};

export type DeleteMyOrgConnectionInput = {
  id: Scalars['ID'];
  org_domain: Scalars['String'];
};

/** Generic deletion response type to handle reporting success. */
export type DeletionResponse = {
  __typename?: 'DeletionResponse';
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type DesignerProject = {
  __typename?: 'DesignerProject';
  connection_id?: Maybe<Scalars['String']>;
  content: Scalars['Base64Bytes'];
  created_at: Scalars['Datetime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  org_domain?: Maybe<Scalars['String']>;
  owner: User;
  roles: Array<DesignerProjectRole>;
  updated_at: Scalars['Datetime'];
};

export type DesignerProjectInvitation = {
  __typename?: 'DesignerProjectInvitation';
  accepted_at?: Maybe<Scalars['Datetime']>;
  created_at: Scalars['Datetime'];
  id: Scalars['ID'];
  invitee: User;
  is_accepted: Scalars['Boolean'];
  project: DesignerProject;
  role: DesignerProjectRoleChoices;
  updated_at: Scalars['Datetime'];
};

export type DesignerProjectRole = {
  __typename?: 'DesignerProjectRole';
  created_at: Scalars['Datetime'];
  id: Scalars['ID'];
  project: DesignerProject;
  role: DesignerProjectRoleChoices;
  updated_at: Scalars['Datetime'];
  user: User;
};

export enum DesignerProjectRoleChoices {
  Editor = 'EDITOR',
  Viewer = 'VIEWER'
}

export type EditApiTokenInput = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

export type EditConnectionInput = {
  endpoint?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  internalEndpoint?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  org_domain?: InputMaybe<Scalars['String']>;
  /** Scope for SSO token exchange when authenticating via org SSO */
  ssoTokenExchangeScope?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
  useBrowserAuth?: InputMaybe<Scalars['Boolean']>;
  useSSO?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
};

export type EditMyOrgConnectionInput = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  org_domain: Scalars['String'];
  token?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

export type EditOrganizationInput = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type EditVoiceboxConversationInput = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

/** Example Configuration for jwt.yaml and stardog.properties */
export type ExampleConfig = {
  __typename?: 'ExampleConfig';
  id: Scalars['ID'];
  jwt_config: Scalars['String'];
  properties: Scalars['String'];
};

export type GenerateVoiceboxResponseReportInput = {
  connectionId: Scalars['ID'];
  endDate: Scalars['Date'];
  startDate: Scalars['Date'];
};

/** Generic response type to handle reporting success. */
export type GenericResponse = {
  __typename?: 'GenericResponse';
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Grafana settings generate Grafana dashboard URLs */
export type GrafanaDashboardSettings = {
  __typename?: 'GrafanaDashboardSettings';
  id: Scalars['String'];
  slug: Scalars['String'];
};

/**
 * Invitation to join a Stardog Cloud instance, connection, or organization.
 *
 * Three mutually exclusive invitation types:
 * - Cloud invitation: Legacy invitation to a cloud instance (endpoint + role)
 * - Connection invitation: Grants access to a connection owned by a personal organization
 * - Organization invitation: Invites user to join a public organization as a member
 */
export type Invitation = {
  __typename?: 'Invitation';
  accepted?: Maybe<Scalars['Boolean']>;
  connection?: Maybe<InvitationConnection>;
  connection_roles?: Maybe<Array<Scalars['String']>>;
  created?: Maybe<Scalars['Datetime']>;
  email?: Maybe<Scalars['String']>;
  endpoint?: Maybe<Scalars['String']>;
  existing_user?: Maybe<InvitationUser>;
  expires?: Maybe<Scalars['Datetime']>;
  id?: Maybe<Scalars['ID']>;
  organization?: Maybe<InvitationOrganization>;
  organization_role?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  sender?: Maybe<InvitationUser>;
};

export type InvitationConnection = {
  __typename?: 'InvitationConnection';
  endpoint: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type InvitationFlagInput = {
  id: Scalars['ID'];
};

export type InvitationOrganization = {
  __typename?: 'InvitationOrganization';
  domain?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type InvitationUser = {
  __typename?: 'InvitationUser';
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
};

export type ItemCount = {
  __typename?: 'ItemCount';
  count?: Maybe<Scalars['Int']>;
};

export type LogoutSsoConnectionInput = {
  connection_id: Scalars['String'];
};

export type MarketplaceSettings = {
  __typename?: 'MarketplaceSettings';
  marketplaceDatabase: Scalars['String'];
  marketplaceEndpoint: Scalars['String'];
  marketplacePassword: Scalars['String'];
  marketplaceUsername: Scalars['String'];
};

export type ModifyConnectionAccessResponse = {
  __typename?: 'ModifyConnectionAccessResponse';
  error?: Maybe<Scalars['String']>;
  results?: Maybe<Array<ModifyConnectionAccessResult>>;
};

export type ModifyConnectionAccessResult = {
  __typename?: 'ModifyConnectionAccessResult';
  email: Scalars['String'];
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type MoveCloudConnectionToOrgInput = {
  add_current_user?: InputMaybe<Scalars['Boolean']>;
  cloud_id: Scalars['ID'];
  /** When true, create the org connection and its access but leave the existing personal connection(s) in place so users can swap over gradually and don't lose access. Clean up the leftovers later via the org-connection cleanup tool. */
  keep_source?: InputMaybe<Scalars['Boolean']>;
  selected: Array<CloudConnectionMoveAccessInput>;
  target_org: Scalars['String'];
  visibility: CloudConnectionMoveVisibility;
};

export type MoveCloudConnectionToOrgResponse = {
  __typename?: 'MoveCloudConnectionToOrgResponse';
  connection_id?: Maybe<Scalars['ID']>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Root Mutation Type */
export type Mutation = {
  __typename?: 'Mutation';
  /** Accept an incoming Designer project invitation. */
  acceptDesignerProjectInvitation: Scalars['ID'];
  acceptInvitation?: Maybe<GenericResponse>;
  addCloudInvitation?: Maybe<GenericResponse>;
  addConnection?: Maybe<Connection>;
  addConnectionInvitations?: Maybe<AddInvitationsResponse>;
  addMyOrganizationConnection?: Maybe<Connection>;
  addOrganization?: Maybe<AddOrganizationResult>;
  addOrganizationInvitations?: Maybe<AddInvitationsResponse>;
  addSSOConnection?: Maybe<SsoConnectionRedirectResponse>;
  addShare?: Maybe<Share>;
  archiveDesignerProject: Scalars['ID'];
  cancelCloud?: Maybe<GenericResponse>;
  changeDesignerProjectRole: Scalars['ID'];
  checkoutCart?: Maybe<BillingSession>;
  createApiToken?: Maybe<CreateApiTokenResult>;
  createDesignerProject: Scalars['ID'];
  /**
   * Create Microsoft Entra SSO configuration for an organization.
   * Requires admin or owner role. Organization must have is_sso_allowed=True.
   */
  createOrganizationMicrosoftEntraSSOConfig?: Maybe<OrganizationMicrosoftEntraSsoConfig>;
  /**
   * Create Okta SSO configuration for an organization.
   * Requires admin or owner role. Organization must have is_sso_allowed=True.
   */
  createOrganizationOktaSSOConfig?: Maybe<OrganizationOktaSsoConfig>;
  createVoiceboxApp?: Maybe<GenericResponse>;
  deleteAccount?: Maybe<DeletionResponse>;
  deleteApiToken?: Maybe<GenericResponse>;
  deleteCloud?: Maybe<DeletionResponse>;
  deleteConnection?: Maybe<DeletionResponse>;
  deleteInvitations?: Maybe<DeleteInvitationsResponse>;
  deleteMyOrganizationConnection?: Maybe<DeletionResponse>;
  deleteOrganization?: Maybe<GenericResponse>;
  /**
   * Delete SSO configuration for an organization.
   * Requires admin or owner role.
   */
  deleteOrganizationSSOConfig?: Maybe<GenericResponse>;
  deleteVoiceboxApp?: Maybe<GenericResponse>;
  deleteVoiceboxConversation?: Maybe<GenericResponse>;
  editApiToken?: Maybe<GenericResponse>;
  editConnection?: Maybe<Connection>;
  editMyOrganizationConnection?: Maybe<Connection>;
  editOrganization?: Maybe<Organization>;
  editVoiceboxConversation?: Maybe<GenericResponse>;
  generateConfiguration?: Maybe<ExampleConfig>;
  getStripeSessionUrl?: Maybe<BillingSession>;
  leaveOrganization?: Maybe<GenericResponse>;
  logoutSSOConnection?: Maybe<GenericResponse>;
  moveCloudConnectionToOrg?: Maybe<MoveCloudConnectionToOrgResponse>;
  reauthenticateSSOConnection?: Maybe<SsoConnectionRedirectResponse>;
  removeMySharedConnection?: Maybe<GenericResponse>;
  removeOrganizationMembers?: Maybe<OrganizationMembersResponse>;
  removePartnerConnection?: Maybe<GenericResponse>;
  renameDesignerProject: Scalars['ID'];
  renameMySharedConnection?: Maybe<GenericResponse>;
  resendEmail?: Maybe<GenericResponse>;
  resolveOrphanedConnections?: Maybe<ResolveOrphanedConnectionsResponse>;
  restoreDesignerProject: Scalars['ID'];
  /** Revoke an outgoing Designer project invitation, or reject an invitation sent to you. */
  revokeDesignerProjectInvitation: Scalars['ID'];
  /** Revoke a given role, or leave a role given to you. */
  revokeDesignerProjectRole: Scalars['ID'];
  revokeMemberConnectionRoles?: Maybe<ModifyConnectionAccessResponse>;
  revokePersonalConnectionAccess?: Maybe<ModifyConnectionAccessResponse>;
  /**
   * Send a Designer project invitation.
   *
   * (you cannot send an invitation to someone who already has a role)
   */
  sendDesignerProjectInvitation: Scalars['ID'];
  setMemberConnectionRoles?: Maybe<ModifyConnectionAccessResponse>;
  setOrganizationConnectionVisibility?: Maybe<GenericResponse>;
  trackEvent?: Maybe<GenericResponse>;
  transferCloudToUser?: Maybe<TransferCloudToUserResponse>;
  transferOrganizationOwnership?: Maybe<GenericResponse>;
  /**
   * Unlink the current user's account from an organization's SSO.
   *
   * This removes the OrganizationMemberIdentity record, which means:
   * - The user can no longer log in via the organization's SSO
   * - The user remains a member of the organization (membership is NOT affected)
   * - The user can still log in via their primary provider (e.g., Auth0)
   * - The user can re-link their account later via the SSO linking flow
   */
  unlinkOrganizationSso?: Maybe<GenericResponse>;
  updateDesignerProject: Scalars['ID'];
  updateOrganizationMembersRole?: Maybe<OrganizationMembersResponse>;
  /**
   * Update Microsoft Entra SSO configuration for an organization.
   * Requires admin or owner role.
   */
  updateOrganizationMicrosoftEntraSSOConfig?: Maybe<OrganizationMicrosoftEntraSsoConfig>;
  /**
   * Update Okta SSO configuration for an organization.
   * Requires admin or owner role.
   */
  updateOrganizationOktaSSOConfig?: Maybe<OrganizationOktaSsoConfig>;
  updatePartnerConnection?: Maybe<GenericResponse>;
  updatePersonalConnectionAccess?: Maybe<ModifyConnectionAccessResponse>;
  updateProfile?: Maybe<User>;
  updateUserFeatures?: Maybe<User>;
  updateVoiceboxApp?: Maybe<GenericResponse>;
  upgradeCloud?: Maybe<BillingSession>;
  verifyInvitation?: Maybe<GenericResponse>;
};


/** Root Mutation Type */
export type MutationAcceptDesignerProjectInvitationArgs = {
  invitation_id: Scalars['ID'];
};


/** Root Mutation Type */
export type MutationAcceptInvitationArgs = {
  input: InvitationFlagInput;
};


/** Root Mutation Type */
export type MutationAddCloudInvitationArgs = {
  input: CloudInvitationInput;
};


/** Root Mutation Type */
export type MutationAddConnectionArgs = {
  input: AddConnectionInput;
};


/** Root Mutation Type */
export type MutationAddConnectionInvitationsArgs = {
  input: ConnectionInvitationsInput;
};


/** Root Mutation Type */
export type MutationAddMyOrganizationConnectionArgs = {
  input: AddMyOrgConnectionInput;
};


/** Root Mutation Type */
export type MutationAddOrganizationArgs = {
  input: AddOrganizationInput;
};


/** Root Mutation Type */
export type MutationAddOrganizationInvitationsArgs = {
  input: OrganizationInvitationsInput;
};


/** Root Mutation Type */
export type MutationAddSsoConnectionArgs = {
  input: AddSsoConnectionInput;
};


/** Root Mutation Type */
export type MutationAddShareArgs = {
  input: ShareInput;
};


/** Root Mutation Type */
export type MutationArchiveDesignerProjectArgs = {
  project_id: Scalars['ID'];
};


/** Root Mutation Type */
export type MutationCancelCloudArgs = {
  input: CancelCloudInput;
};


/** Root Mutation Type */
export type MutationChangeDesignerProjectRoleArgs = {
  role: DesignerProjectRoleChoices;
  role_id: Scalars['ID'];
};


/** Root Mutation Type */
export type MutationCheckoutCartArgs = {
  addOns?: InputMaybe<Array<InputMaybe<CheckoutLineItem>>>;
  item: CheckoutLineItem;
};


/** Root Mutation Type */
export type MutationCreateApiTokenArgs = {
  input: CreateApiTokenInput;
};


/** Root Mutation Type */
export type MutationCreateDesignerProjectArgs = {
  connection_id?: InputMaybe<Scalars['String']>;
  content: Scalars['Base64Bytes'];
  name: Scalars['String'];
  org_domain?: InputMaybe<Scalars['String']>;
};


/** Root Mutation Type */
export type MutationCreateOrganizationMicrosoftEntraSsoConfigArgs = {
  domain: Scalars['String'];
  input: CreateOrganizationMicrosoftEntraSsoConfigInput;
};


/** Root Mutation Type */
export type MutationCreateOrganizationOktaSsoConfigArgs = {
  domain: Scalars['String'];
  input: CreateOrganizationOktaSsoConfigInput;
};


/** Root Mutation Type */
export type MutationCreateVoiceboxAppArgs = {
  input: CreateVoiceboxAppInput;
};


/** Root Mutation Type */
export type MutationDeleteApiTokenArgs = {
  input: DeleteApiTokenInput;
};


/** Root Mutation Type */
export type MutationDeleteCloudArgs = {
  input: CloudCleanupInput;
};


/** Root Mutation Type */
export type MutationDeleteConnectionArgs = {
  input: DeleteConnectionInput;
};


/** Root Mutation Type */
export type MutationDeleteInvitationsArgs = {
  ids: Array<Scalars['ID']>;
};


/** Root Mutation Type */
export type MutationDeleteMyOrganizationConnectionArgs = {
  input: DeleteMyOrgConnectionInput;
};


/** Root Mutation Type */
export type MutationDeleteOrganizationArgs = {
  org_domain: Scalars['String'];
};


/** Root Mutation Type */
export type MutationDeleteOrganizationSsoConfigArgs = {
  domain: Scalars['String'];
};


/** Root Mutation Type */
export type MutationDeleteVoiceboxAppArgs = {
  id: Scalars['ID'];
};


/** Root Mutation Type */
export type MutationDeleteVoiceboxConversationArgs = {
  conversation_id: Scalars['ID'];
};


/** Root Mutation Type */
export type MutationEditApiTokenArgs = {
  input: EditApiTokenInput;
};


/** Root Mutation Type */
export type MutationEditConnectionArgs = {
  input: EditConnectionInput;
};


/** Root Mutation Type */
export type MutationEditMyOrganizationConnectionArgs = {
  input: EditMyOrgConnectionInput;
};


/** Root Mutation Type */
export type MutationEditOrganizationArgs = {
  input: EditOrganizationInput;
  org_domain: Scalars['String'];
};


/** Root Mutation Type */
export type MutationEditVoiceboxConversationArgs = {
  input: EditVoiceboxConversationInput;
};


/** Root Mutation Type */
export type MutationGenerateConfigurationArgs = {
  endpoint: Scalars['String'];
};


/** Root Mutation Type */
export type MutationLeaveOrganizationArgs = {
  org_domain: Scalars['String'];
};


/** Root Mutation Type */
export type MutationLogoutSsoConnectionArgs = {
  input: LogoutSsoConnectionInput;
};


/** Root Mutation Type */
export type MutationMoveCloudConnectionToOrgArgs = {
  input: MoveCloudConnectionToOrgInput;
};


/** Root Mutation Type */
export type MutationReauthenticateSsoConnectionArgs = {
  input: ReauthenticateSsoConnectionInput;
};


/** Root Mutation Type */
export type MutationRemoveMySharedConnectionArgs = {
  input: RemoveMySharedConnectionInput;
};


/** Root Mutation Type */
export type MutationRemoveOrganizationMembersArgs = {
  emails: Array<Scalars['String']>;
  org_domain: Scalars['String'];
};


/** Root Mutation Type */
export type MutationRemovePartnerConnectionArgs = {
  input: RemovePartnerConnectionInput;
};


/** Root Mutation Type */
export type MutationRenameDesignerProjectArgs = {
  name: Scalars['String'];
  project_id: Scalars['ID'];
};


/** Root Mutation Type */
export type MutationRenameMySharedConnectionArgs = {
  input: RenameMySharedConnectionInput;
};


/** Root Mutation Type */
export type MutationResolveOrphanedConnectionsArgs = {
  input: ResolveOrphanedConnectionsInput;
};


/** Root Mutation Type */
export type MutationRestoreDesignerProjectArgs = {
  project_id: Scalars['ID'];
};


/** Root Mutation Type */
export type MutationRevokeDesignerProjectInvitationArgs = {
  invitation_id?: InputMaybe<Scalars['ID']>;
};


/** Root Mutation Type */
export type MutationRevokeDesignerProjectRoleArgs = {
  role_id: Scalars['ID'];
};


/** Root Mutation Type */
export type MutationRevokeMemberConnectionRolesArgs = {
  input: RevokeMemberConnectionRolesInput;
};


/** Root Mutation Type */
export type MutationRevokePersonalConnectionAccessArgs = {
  input: RevokePersonalConnectionAccessInput;
};


/** Root Mutation Type */
export type MutationSendDesignerProjectInvitationArgs = {
  invitee_id: Scalars['ID'];
  project_id: Scalars['ID'];
  role: DesignerProjectRoleChoices;
};


/** Root Mutation Type */
export type MutationSetMemberConnectionRolesArgs = {
  input: SetMemberConnectionRolesInput;
};


/** Root Mutation Type */
export type MutationSetOrganizationConnectionVisibilityArgs = {
  input: SetOrgConnectionVisibilityInput;
};


/** Root Mutation Type */
export type MutationTrackEventArgs = {
  input: TrackEventInput;
};


/** Root Mutation Type */
export type MutationTransferCloudToUserArgs = {
  input: TransferCloudToUserInput;
};


/** Root Mutation Type */
export type MutationTransferOrganizationOwnershipArgs = {
  email: Scalars['String'];
  org_domain: Scalars['String'];
};


/** Root Mutation Type */
export type MutationUnlinkOrganizationSsoArgs = {
  domain: Scalars['String'];
};


/** Root Mutation Type */
export type MutationUpdateDesignerProjectArgs = {
  connection_id?: InputMaybe<Scalars['String']>;
  content: Scalars['Base64Bytes'];
  name?: InputMaybe<Scalars['String']>;
  org_domain?: InputMaybe<Scalars['String']>;
  project_id: Scalars['ID'];
};


/** Root Mutation Type */
export type MutationUpdateOrganizationMembersRoleArgs = {
  emails: Array<Scalars['String']>;
  new_role: Scalars['String'];
  org_domain: Scalars['String'];
};


/** Root Mutation Type */
export type MutationUpdateOrganizationMicrosoftEntraSsoConfigArgs = {
  domain: Scalars['String'];
  input: UpdateOrganizationMicrosoftEntraSsoConfigInput;
};


/** Root Mutation Type */
export type MutationUpdateOrganizationOktaSsoConfigArgs = {
  domain: Scalars['String'];
  input: UpdateOrganizationOktaSsoConfigInput;
};


/** Root Mutation Type */
export type MutationUpdatePartnerConnectionArgs = {
  input: UpdatePartnerConnectionInput;
};


/** Root Mutation Type */
export type MutationUpdatePersonalConnectionAccessArgs = {
  input: UpdatePersonalConnectionAccessInput;
};


/** Root Mutation Type */
export type MutationUpdateProfileArgs = {
  input?: InputMaybe<ProfileInput>;
};


/** Root Mutation Type */
export type MutationUpdateUserFeaturesArgs = {
  input: UserFeaturesInput;
  user_id: Scalars['ID'];
};


/** Root Mutation Type */
export type MutationUpdateVoiceboxAppArgs = {
  input: UpdateVoiceboxAppInput;
};


/** Root Mutation Type */
export type MutationUpgradeCloudArgs = {
  connectionId: Scalars['ID'];
  item: CheckoutLineItem;
};


/** Root Mutation Type */
export type MutationVerifyInvitationArgs = {
  input: InvitationFlagInput;
};

/**
 * An Auth0 auth token stored for the user, do not add secret values here such as
 * refresh_token or client_id.
 */
export type OAuthToken = {
  __typename?: 'OAuthToken';
  access_token?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  id_token?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
  user: User;
};

export type OktaProvider = {
  __typename?: 'OktaProvider';
  customerName: Scalars['String'];
};

/**
 * Cleanup view for an organization connection that was created by a move:
 * the leftover personal connections to the same endpoint, plus the org members
 * who cannot reach the connection through the org yet.
 */
export type OrgConnectionCleanupPreview = {
  __typename?: 'OrgConnectionCleanupPreview';
  connection_id?: Maybe<Scalars['ID']>;
  connection_name?: Maybe<Scalars['String']>;
  endpoint?: Maybe<Scalars['String']>;
  is_org_connection?: Maybe<Scalars['Boolean']>;
  org_domain?: Maybe<Scalars['String']>;
  org_members_without_access?: Maybe<Array<Maybe<Scalars['String']>>>;
  org_name?: Maybe<Scalars['String']>;
  orphaned?: Maybe<Array<Maybe<OrphanedCloudConnection>>>;
};

export enum OrgType {
  Personal = 'PERSONAL',
  Public = 'PUBLIC'
}

export type Organization = {
  __typename?: 'Organization';
  description?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** Whether this organization can configure SSO (premium feature) */
  isSsoAllowed?: Maybe<Scalars['Boolean']>;
  /**
   * When true, the member list is hidden from ordinary members and only visible
   * to admins and owners.
   */
  membersHiddenFromMembers?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  orgType?: Maybe<OrgType>;
  owner?: Maybe<User>;
  role?: Maybe<Scalars['String']>;
  /** SSO configuration for this organization (null if not configured) */
  ssoConfig?: Maybe<OrganizationSsoConfig>;
  /** Current user's SSO identity link status for this organization */
  ssoIdentity?: Maybe<OrganizationSsoIdentity>;
};

export type OrganizationInvitation = {
  __typename?: 'OrganizationInvitation';
  accepted?: Maybe<Scalars['Boolean']>;
  created?: Maybe<Scalars['Datetime']>;
  email: Scalars['String'];
  expired?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  organization_role: Scalars['String'];
};

/** Input for specifying connection access with optional Stardog roles. */
export type OrganizationInvitationsConnectionAccessInput = {
  connection_id: Scalars['ID'];
  stardog_roles?: InputMaybe<Array<Scalars['String']>>;
};

/**
 * Input for creating organization invitations.
 * Organization must be a public organization.
 */
export type OrganizationInvitationsInput = {
  connection_access?: InputMaybe<Array<OrganizationInvitationsConnectionAccessInput>>;
  emails: Array<Scalars['String']>;
  organization_domain: Scalars['String'];
  organization_role: Scalars['String'];
};

export type OrganizationMember = {
  __typename?: 'OrganizationMember';
  role: Scalars['String'];
  user: User;
};

export type OrganizationMemberResult = {
  __typename?: 'OrganizationMemberResult';
  email: Scalars['String'];
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type OrganizationMembersResponse = {
  __typename?: 'OrganizationMembersResponse';
  error?: Maybe<Scalars['String']>;
  results?: Maybe<Array<OrganizationMemberResult>>;
};

/** Microsoft Entra SSO configuration for an organization. */
export type OrganizationMicrosoftEntraSsoConfig = OrganizationSsoConfig & {
  __typename?: 'OrganizationMicrosoftEntraSSOConfig';
  clientId: Scalars['String'];
  createdAt: Scalars['Datetime'];
  discoveryUrl: Scalars['String'];
  hasClientSecret: Scalars['Boolean'];
  id: Scalars['ID'];
  idpLogoutEnabled: Scalars['Boolean'];
  isEnabled: Scalars['Boolean'];
  loginUrl: Scalars['String'];
  postLogoutRedirectUri: Scalars['String'];
  providerType: SsoProviderType;
  redirectUri: Scalars['String'];
  updatedAt: Scalars['Datetime'];
};

/**
 * Result of resolving a target organization for a connection move: whether it is
 * a valid public org plus its current members.
 */
export type OrganizationMoveTarget = {
  __typename?: 'OrganizationMoveTarget';
  members?: Maybe<Array<Maybe<OrganizationMoveTargetMember>>>;
  name?: Maybe<Scalars['String']>;
  valid?: Maybe<Scalars['Boolean']>;
};

/** A current member of a public organization, used by the move "check org" step. */
export type OrganizationMoveTargetMember = {
  __typename?: 'OrganizationMoveTargetMember';
  email?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
};

/** Okta SSO configuration for an organization. */
export type OrganizationOktaSsoConfig = OrganizationSsoConfig & {
  __typename?: 'OrganizationOktaSSOConfig';
  clientId: Scalars['String'];
  createdAt: Scalars['Datetime'];
  discoveryUrl: Scalars['String'];
  hasClientSecret: Scalars['Boolean'];
  /** Whether a backend client secret is configured */
  hasOktaBackendClientSecret: Scalars['Boolean'];
  id: Scalars['ID'];
  idpLogoutEnabled: Scalars['Boolean'];
  isEnabled: Scalars['Boolean'];
  loginUrl: Scalars['String'];
  /** Authorization server audience for token exchange */
  oktaAuthorizationServerAudience: Scalars['String'];
  /** Client ID for the backend API Services app (for OBO token exchange) */
  oktaBackendClientId: Scalars['String'];
  postLogoutRedirectUri: Scalars['String'];
  providerType: SsoProviderType;
  redirectUri: Scalars['String'];
  updatedAt: Scalars['Datetime'];
};

/**
 * Base SSO configuration interface for an organization.
 * Allows organization members to log in via the organization's identity provider.
 */
export type OrganizationSsoConfig = {
  clientId: Scalars['String'];
  createdAt: Scalars['Datetime'];
  discoveryUrl: Scalars['String'];
  /** Whether a client secret is configured (never exposes the actual secret) */
  hasClientSecret: Scalars['Boolean'];
  id: Scalars['ID'];
  /** Whether logging out also ends the user's IDP session (RP-Initiated Logout) */
  idpLogoutEnabled: Scalars['Boolean'];
  /** Whether SSO login is currently enabled for this organization */
  isEnabled: Scalars['Boolean'];
  /** Organization-specific login URL */
  loginUrl: Scalars['String'];
  /** URI the IDP redirects to after ending the user's session */
  postLogoutRedirectUri: Scalars['String'];
  providerType: SsoProviderType;
  /** Redirect URI to configure in your identity provider's redirect URI whitelist */
  redirectUri: Scalars['String'];
  updatedAt: Scalars['Datetime'];
};

/**
 * Represents the current user's SSO identity link to an organization.
 * This is the connection between a user's Stardog Cloud account and their
 * identity in the organization's SSO provider (Okta, Microsoft Entra).
 */
export type OrganizationSsoIdentity = {
  __typename?: 'OrganizationSSOIdentity';
  /** The user's identity subject from the SSO provider (only if linked) */
  idpSubject?: Maybe<Scalars['String']>;
  /** Whether the current user has linked their account to this org's SSO */
  isLinked: Scalars['Boolean'];
  /** When the identity was linked (only if linked) */
  linkedAt?: Maybe<Scalars['Datetime']>;
};

/**
 * A leftover personal connection pointing at the same endpoint as an
 * organization connection that has already been created for the cloud.
 */
export type OrphanedCloudConnection = {
  __typename?: 'OrphanedCloudConnection';
  connection_id?: Maybe<Scalars['ID']>;
  connection_name?: Maybe<Scalars['String']>;
  /** The owner can already reach the endpoint through the organization connection. */
  has_org_access?: Maybe<Scalars['Boolean']>;
  /** The owner is already a member of the organization. */
  is_org_member?: Maybe<Scalars['Boolean']>;
  owner_email?: Maybe<Scalars['String']>;
  stardog_roles?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export enum OrphanedConnectionAction {
  Leave = 'LEAVE',
  Migrate = 'MIGRATE',
  Remove = 'REMOVE'
}

export type OrphanedConnectionActionInput = {
  action: OrphanedConnectionAction;
  connection_id: Scalars['ID'];
  /** Membership role to assign when action is MIGRATE and the owner is not yet a member (they are auto-added as an active member). Ignored for existing members. */
  organization_role?: InputMaybe<Scalars['String']>;
};

/** To page through response. */
export type PagingInput = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** Databricks Partner Information */
export type PartnerConnectionDetail = {
  __typename?: 'PartnerConnectionDetail';
  cluster_id?: Maybe<Scalars['String']>;
  connection_id?: Maybe<Scalars['String']>;
  databricks_connection_name?: Maybe<Scalars['String']>;
  databricks_personal_token_id?: Maybe<Scalars['String']>;
  databricks_workspace_id?: Maybe<Scalars['String']>;
  http_path?: Maybe<Scalars['String']>;
  is_configured_resources?: Maybe<Scalars['Boolean']>;
  jdbc_url?: Maybe<Scalars['String']>;
  stardog_server_connection?: Maybe<Connection>;
  user_email?: Maybe<Scalars['String']>;
  user_first_name?: Maybe<Scalars['String']>;
  workspace_url?: Maybe<Scalars['String']>;
};

export type PingProvider = {
  __typename?: 'PingProvider';
  customerName: Scalars['String'];
};

export type ProfileInput = {
  best_describes_company: Scalars['String'];
  best_describes_role: Scalars['String'];
  company: Scalars['String'];
  familiarity_with_kgs: Scalars['String'];
  first_name: Scalars['String'];
  industry: Scalars['String'];
  last_name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  use_case: Scalars['String'];
};

export type ProvisionedOrder = {
  __typename?: 'ProvisionedOrder';
  payment_system?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  trial_days_remaining?: Maybe<Scalars['Int']>;
  trial_days_total?: Maybe<Scalars['Int']>;
};

export type PurchaseSession = {
  __typename?: 'PurchaseSession';
  isExpired?: Maybe<Scalars['Boolean']>;
  isWaitingForPayment?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/** Root Query Type */
export type Query = {
  __typename?: 'Query';
  apiTokenCount?: Maybe<ItemCount>;
  checkCloudQueue?: Maybe<QueueCounts>;
  customerSsoSettings?: Maybe<CustomerSsoSettings>;
  generateConnectionToken?: Maybe<OAuthToken>;
  /** @deprecated Use generateConnectionToken instead. */
  generateToken?: Maybe<OAuthToken>;
  /** Generate an endpoint-scoped Voicebox response report for download. */
  generateVoiceboxResponseReport: VoiceboxResponseReportDownload;
  getCloudConnectionMovePreview?: Maybe<CloudConnectionMovePreview>;
  getCloudReport?: Maybe<CloudReportData>;
  getCloudSduLifetime: Array<CloudSduLifetime>;
  getCloudSduUsage: Array<CloudSduUsageRecord>;
  getCloudTransferPreview?: Maybe<CloudTransferPreview>;
  getCloudTransferTarget?: Maybe<CloudTransferTarget>;
  getConnectionById?: Maybe<Connection>;
  getConnectionByIndex?: Maybe<Connection>;
  /** Retrieve a single Designer project. */
  getDesignerProject: DesignerProject;
  /** List both incoming and outgoing Designer project invitations. */
  getDesignerProjectInvitations: Array<DesignerProjectInvitation>;
  /** List all Designer projects you own, as well as any projects shared with you. */
  getDesignerProjects: Array<DesignerProject>;
  getInvitation?: Maybe<Invitation>;
  getOrgConnectionCleanupPreview?: Maybe<OrgConnectionCleanupPreview>;
  getOrganization?: Maybe<Organization>;
  getOrganizationInvitations?: Maybe<Array<Maybe<OrganizationInvitation>>>;
  getOrganizationMembers?: Maybe<Array<Maybe<OrganizationMember>>>;
  getOrganizationMoveTarget?: Maybe<OrganizationMoveTarget>;
  getSSOConnectionRegistry?: Maybe<Array<Maybe<SsoConnectionRegistration>>>;
  getShareByShortHash?: Maybe<Share>;
  getStardogCloud?: Maybe<StardogCloud>;
  getStripePrices?: Maybe<Array<Maybe<StripePrice>>>;
  getStripeSubscriptionOrder?: Maybe<ProvisionedOrder>;
  getTotalUnitUsage?: Maybe<TotalUnitUsage>;
  getUnitUsage?: Maybe<Array<Maybe<UnitUsageRecord>>>;
  getUser?: Maybe<User>;
  getUserArchivedClouds?: Maybe<Array<Maybe<ArchivedCloud>>>;
  getUserClouds?: Maybe<Array<Maybe<StardogCloud>>>;
  getUserConnections?: Maybe<Array<Maybe<Connection>>>;
  getUserCurrentPartnerConnection?: Maybe<PartnerConnectionDetail>;
  getUserSearchDetails?: Maybe<UserSearchDetails>;
  /** Retrieve a single Voicebox conversation for the authenticated user by the conversation id. */
  getVoiceboxConversation?: Maybe<VoiceboxConversation>;
  grafanaHighLevelDashboardSettings?: Maybe<GrafanaDashboardSettings>;
  listApiTokens?: Maybe<Array<Maybe<ApiToken>>>;
  listConnections?: Maybe<Array<Maybe<Connection>>>;
  listConnectionsByEndpoint?: Maybe<Array<Maybe<Connection>>>;
  listDefaultOrganizationConnectionsAccess?: Maybe<Array<Maybe<ConnectionAccess>>>;
  listInactiveClouds?: Maybe<Array<Maybe<StardogCloud>>>;
  listOrganizationConnectionAccess?: Maybe<Array<Maybe<ConnectionAccess>>>;
  listOrganizations?: Maybe<Array<Maybe<Organization>>>;
  listStardogCloud?: Maybe<Array<Maybe<StardogCloud>>>;
  listUserConnectionAccess?: Maybe<Array<Maybe<ConnectionAccess>>>;
  listUserConnectionInvitations?: Maybe<Array<Maybe<ConnectionInvitation>>>;
  /** Retrieve Voicebox Applications owned by the authenticated user. */
  listVoiceboxApps?: Maybe<Array<Maybe<VoiceboxApp>>>;
  /**
   * Retrieve Voicebox conversations for the authenticated user, ordered by creation date, with the newest first.
   * Use PagingInput to paginate. If PagingInput is omitted, all conversations are returned.
   * Designer conversations will only be returned if include_designer is set to true.
   * Use connection_id to filter by connection_id, if no connection_id is provided, all conversations are returned.
   */
  listVoiceboxConversations?: Maybe<Array<Maybe<VoiceboxConversation>>>;
  marketplaceSettings?: Maybe<MarketplaceSettings>;
  profile?: Maybe<User>;
  searchUsers?: Maybe<Array<Maybe<User>>>;
  settings: Settings;
  userPartnerConnections?: Maybe<Array<Maybe<PartnerConnectionDetail>>>;
  /**
   * Get the amount of total Voicebox conversation's an authenticated user. May be helpful in conjunction with listVoiceboxConversations
   * to page through all conversations.
   */
  voiceboxConversationCount?: Maybe<ItemCount>;
};


/** Root Query Type */
export type QueryApiTokenCountArgs = {
  app_id?: InputMaybe<Scalars['ID']>;
};


/** Root Query Type */
export type QueryGenerateConnectionTokenArgs = {
  connectionId: Scalars['ID'];
  forceRefresh?: InputMaybe<Scalars['Boolean']>;
};


/** Root Query Type */
export type QueryGenerateTokenArgs = {
  endpoint: Scalars['String'];
};


/** Root Query Type */
export type QueryGenerateVoiceboxResponseReportArgs = {
  input: GenerateVoiceboxResponseReportInput;
};


/** Root Query Type */
export type QueryGetCloudConnectionMovePreviewArgs = {
  cloud_id: Scalars['ID'];
};


/** Root Query Type */
export type QueryGetCloudReportArgs = {
  filters?: InputMaybe<CloudFilters>;
};


/** Root Query Type */
export type QueryGetCloudSduLifetimeArgs = {
  cloud_ids: Array<Scalars['ID']>;
};


/** Root Query Type */
export type QueryGetCloudSduUsageArgs = {
  cloud_id: Scalars['ID'];
};


/** Root Query Type */
export type QueryGetCloudTransferPreviewArgs = {
  cloud_id: Scalars['ID'];
};


/** Root Query Type */
export type QueryGetCloudTransferTargetArgs = {
  cloud_id: Scalars['ID'];
  email: Scalars['String'];
};


/** Root Query Type */
export type QueryGetConnectionByIdArgs = {
  id: Scalars['String'];
  org_domain?: InputMaybe<Scalars['String']>;
};


/** Root Query Type */
export type QueryGetConnectionByIndexArgs = {
  index: Scalars['Int'];
  org_domain?: InputMaybe<Scalars['String']>;
};


/** Root Query Type */
export type QueryGetDesignerProjectArgs = {
  project_id: Scalars['ID'];
};


/** Root Query Type */
export type QueryGetInvitationArgs = {
  id: Scalars['ID'];
};


/** Root Query Type */
export type QueryGetOrgConnectionCleanupPreviewArgs = {
  cloud_id: Scalars['ID'];
};


/** Root Query Type */
export type QueryGetOrganizationArgs = {
  org_domain?: InputMaybe<Scalars['String']>;
};


/** Root Query Type */
export type QueryGetOrganizationInvitationsArgs = {
  org_domain?: InputMaybe<Scalars['String']>;
};


/** Root Query Type */
export type QueryGetOrganizationMembersArgs = {
  org_domain?: InputMaybe<Scalars['String']>;
};


/** Root Query Type */
export type QueryGetOrganizationMoveTargetArgs = {
  domain: Scalars['String'];
};


/** Root Query Type */
export type QueryGetShareByShortHashArgs = {
  shortHash: Scalars['String'];
};


/** Root Query Type */
export type QueryGetStardogCloudArgs = {
  pk: Scalars['String'];
};


/** Root Query Type */
export type QueryGetStripeSubscriptionOrderArgs = {
  cloudId: Scalars['ID'];
};


/** Root Query Type */
export type QueryGetTotalUnitUsageArgs = {
  connectionId?: InputMaybe<Scalars['ID']>;
  org_domain?: InputMaybe<Scalars['String']>;
};


/** Root Query Type */
export type QueryGetUnitUsageArgs = {
  connectionId?: InputMaybe<Scalars['ID']>;
  endDate?: InputMaybe<Scalars['Date']>;
  modules?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  org_domain?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Date']>;
  timeGrain?: InputMaybe<TimeGrain>;
};


/** Root Query Type */
export type QueryGetUserArgs = {
  user_id: Scalars['String'];
};


/** Root Query Type */
export type QueryGetUserArchivedCloudsArgs = {
  user_id: Scalars['String'];
};


/** Root Query Type */
export type QueryGetUserCloudsArgs = {
  user_id: Scalars['String'];
};


/** Root Query Type */
export type QueryGetUserConnectionsArgs = {
  user_id: Scalars['String'];
};


/** Root Query Type */
export type QueryGetUserSearchDetailsArgs = {
  filters?: InputMaybe<UserSearchFiltersInput>;
  token: Scalars['String'];
};


/** Root Query Type */
export type QueryGetVoiceboxConversationArgs = {
  conversation_id: Scalars['String'];
};


/** Root Query Type */
export type QueryListApiTokensArgs = {
  app_id?: InputMaybe<Scalars['ID']>;
  paging?: InputMaybe<PagingInput>;
};


/** Root Query Type */
export type QueryListConnectionsArgs = {
  org_domain?: InputMaybe<Scalars['String']>;
};


/** Root Query Type */
export type QueryListConnectionsByEndpointArgs = {
  endpoint: Scalars['String'];
  org_domain?: InputMaybe<Scalars['String']>;
};


/** Root Query Type */
export type QueryListDefaultOrganizationConnectionsAccessArgs = {
  org_domain: Scalars['String'];
};


/** Root Query Type */
export type QueryListInactiveCloudsArgs = {
  flavor?: InputMaybe<Scalars['String']>;
};


/** Root Query Type */
export type QueryListOrganizationConnectionAccessArgs = {
  id: Scalars['ID'];
  org_domain: Scalars['String'];
};


/** Root Query Type */
export type QueryListStardogCloudArgs = {
  inactive_days?: InputMaybe<Scalars['Int']>;
};


/** Root Query Type */
export type QueryListUserConnectionAccessArgs = {
  id: Scalars['ID'];
};


/** Root Query Type */
export type QueryListUserConnectionInvitationsArgs = {
  id: Scalars['ID'];
};


/** Root Query Type */
export type QueryListVoiceboxConversationsArgs = {
  filterInput?: InputMaybe<VoiceboxConversationsFilterInput>;
  paging?: InputMaybe<PagingInput>;
};


/** Root Query Type */
export type QuerySearchUsersArgs = {
  filters?: InputMaybe<UserSearchFiltersInput>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  token: Scalars['String'];
};


/** Root Query Type */
export type QueryVoiceboxConversationCountArgs = {
  filterInput?: InputMaybe<VoiceboxConversationsFilterInput>;
};

/** Contains the counts of available cloud resources to sell. */
export type QueueCounts = {
  __typename?: 'QueueCounts';
  medium_count?: Maybe<Scalars['Float']>;
  micro_count?: Maybe<Scalars['Float']>;
  small_count?: Maybe<Scalars['Float']>;
  small_vbx_count?: Maybe<Scalars['Float']>;
};

/** Quota limits and usage for a given user. */
export type Quota = {
  __typename?: 'Quota';
  available?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

export type ReauthenticateSsoConnectionInput = {
  connection_id: Scalars['String'];
};

export type RemoveMySharedConnectionInput = {
  connectionId: Scalars['ID'];
};

export type RemovePartnerConnectionInput = {
  connection_id: Scalars['String'];
};

export type RenameMySharedConnectionInput = {
  connectionId: Scalars['ID'];
  name: Scalars['String'];
};

export type ResolveOrphanedConnectionsInput = {
  actions: Array<OrphanedConnectionActionInput>;
  /** The organization connection whose leftover personal connections are being cleaned up. */
  connection_id: Scalars['ID'];
};

export type ResolveOrphanedConnectionsResponse = {
  __typename?: 'ResolveOrphanedConnectionsResponse';
  left?: Maybe<Scalars['Int']>;
  migrated?: Maybe<Scalars['Int']>;
  removed?: Maybe<Scalars['Int']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type RevokeMemberConnectionRolesInput = {
  connectionId: Scalars['ID'];
  emails: Array<Scalars['String']>;
  org_domain: Scalars['String'];
};

export type RevokePersonalConnectionAccessInput = {
  connectionId: Scalars['ID'];
  emails: Array<Scalars['String']>;
};

export type SsoConnectionRedirectResponse = {
  __typename?: 'SSOConnectionRedirectResponse';
  redirect_url: Scalars['String'];
};

export type SsoConnectionRegistration = {
  __typename?: 'SSOConnectionRegistration';
  display_provider_name: Scalars['String'];
  provider_name: Scalars['String'];
  stardog_endpoint?: Maybe<Scalars['String']>;
  stardog_internal_endpoint?: Maybe<Scalars['String']>;
};

/** SSO provider types supported for organization SSO configuration */
export enum SsoProviderType {
  MicrosoftEntra = 'MICROSOFT_ENTRA',
  Okta = 'OKTA'
}

export type SetMemberConnectionRolesInput = {
  connectionId: Scalars['ID'];
  emails: Array<Scalars['String']>;
  org_domain: Scalars['String'];
  stardog_roles?: InputMaybe<Array<Scalars['String']>>;
};

export type SetOrgConnectionVisibilityInput = {
  connectionId: Scalars['ID'];
  org_domain: Scalars['String'];
  organization_is_enabled: Scalars['Boolean'];
  stardog_roles?: InputMaybe<Array<Scalars['String']>>;
};

/** Settings, these are settings that control the front end display */
export type Settings = {
  __typename?: 'Settings';
  auth0Auth: Scalars['Boolean'];
  azureAuth: Scalars['Boolean'];
  baseURL: Scalars['String'];
  copyConnectionTokenButtonEnabled: Scalars['Boolean'];
  dataMarketplace: Scalars['Boolean'];
  designerVersion: Scalars['String'];
  duoAuth: Scalars['Boolean'];
  explorerVersion: Scalars['String'];
  friendlyName: Scalars['String'];
  googleAuth: Scalars['Boolean'];
  homeFooterLinks: Scalars['Boolean'];
  kerberosAuth: Scalars['Boolean'];
  oktaAuth: Scalars['Boolean'];
  openidAuth: Scalars['Boolean'];
  pingAuth: Scalars['Boolean'];
  portal: Scalars['Boolean'];
  requireSsoConnections: Scalars['Boolean'];
  sharedUserAuth: Scalars['Boolean'];
  stardogEndpoint: Scalars['String'];
  studioVersion: Scalars['String'];
};

/** Share URL, short urls for sharing */
export type Share = {
  __typename?: 'Share';
  connection_id?: Maybe<Scalars['String']>;
  endpoint?: Maybe<Scalars['String']>;
  expiration?: Maybe<Scalars['Datetime']>;
  last_accessed?: Maybe<Scalars['Datetime']>;
  lookup_count?: Maybe<Scalars['Int']>;
  org_domain?: Maybe<Scalars['String']>;
  service?: Maybe<Scalars['String']>;
  short_url?: Maybe<Scalars['String']>;
  target_path?: Maybe<Scalars['String']>;
  timestamp?: Maybe<Scalars['Datetime']>;
};

export type ShareInput = {
  connection_id?: InputMaybe<Scalars['String']>;
  endpoint?: InputMaybe<Scalars['String']>;
  expires: Scalars['Int'];
  org_domain?: InputMaybe<Scalars['String']>;
  service: Scalars['String'];
  target_path: Scalars['String'];
};

/** SSO provider information for a connection */
export type SsoProviderInfo = {
  __typename?: 'SsoProviderInfo';
  /** The OAuth client ID stored on this connection */
  clientId?: Maybe<Scalars['String']>;
  /** Whether the stored client_id matches a registered SSO provider */
  isValid: Scalars['Boolean'];
  /** The unique identifier portion of the provider name (e.g., 'devenv' from 'devenv-azure') */
  providerName?: Maybe<Scalars['String']>;
  /** The provider type (e.g., 'azure', 'okta', 'ping') */
  providerType?: Maybe<Scalars['String']>;
};

/** Stardog Cloud, represents an instance of Cloud that is owned by the user */
export type StardogCloud = {
  __typename?: 'StardogCloud';
  bi_endpoint?: Maybe<Scalars['String']>;
  cleanup_available?: Maybe<Scalars['Boolean']>;
  connection_in_personal_org?: Maybe<Scalars['Boolean']>;
  created?: Maybe<Scalars['String']>;
  days_to_cleanup?: Maybe<Scalars['Int']>;
  days_to_inactive?: Maybe<Scalars['Int']>;
  endpoint?: Maybe<Scalars['String']>;
  flavor?: Maybe<CloudFlavor>;
  id?: Maybe<Scalars['ID']>;
  move_available?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  notification_date?: Maybe<Scalars['String']>;
  owner?: Maybe<User>;
  payment_ref?: Maybe<Scalars['String']>;
  price_ref?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  transfer_available?: Maybe<Scalars['Boolean']>;
  updated?: Maybe<Scalars['String']>;
  validation?: Maybe<Array<Maybe<Scalars['String']>>>;
};

/** Stripe Customer: If the user is a paying customer */
export type StripeCustomer = {
  __typename?: 'StripeCustomer';
  cloud_quota?: Maybe<Quota>;
  customer_id?: Maybe<Scalars['String']>;
  is_cloud_quota_breached?: Maybe<Scalars['Boolean']>;
};

export type StripePrice = {
  __typename?: 'StripePrice';
  amount?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  nickname?: Maybe<Scalars['String']>;
  product_info?: Maybe<StripeProduct>;
  stardog_billing_type?: Maybe<Scalars['String']>;
  stardog_flavor?: Maybe<Scalars['String']>;
};

export type StripeProduct = {
  __typename?: 'StripeProduct';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  metadata?: Maybe<StripeProductMetadata>;
  name?: Maybe<Scalars['String']>;
};

export type StripeProductMetadata = {
  __typename?: 'StripeProductMetadata';
  flavor?: Maybe<Scalars['String']>;
};

export type SystemVoiceboxMessageContext = {
  __typename?: 'SystemVoiceboxMessageContext';
  actions?: Maybe<Array<Maybe<VoicboxSystemMessageAction>>>;
  followup_examples?: Maybe<Array<Maybe<Scalars['String']>>>;
  id: Scalars['ID'];
  message_type?: Maybe<Scalars['String']>;
  pending?: Maybe<Scalars['Boolean']>;
  request_id?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export enum TimeGrain {
  Day = 'day',
  Month = 'month',
  Quarter = 'quarter',
  Total = 'total',
  Week = 'week'
}

/** Total units consumed for all time, optionally filtered to a single connection */
export type TotalUnitUsage = {
  __typename?: 'TotalUnitUsage';
  totalUnitsConsumed: Scalars['Float'];
};

export type TrackEventInput = {
  client_type?: InputMaybe<Scalars['String']>;
  event: Scalars['String'];
  properties?: InputMaybe<Scalars['String']>;
};

/**
 * How to handle a single carried-access entry when transferring: reassign it to
 * the destination connection (CARRY) or remove it entirely (DROP).
 */
export enum TransferAccessAction {
  Carry = 'CARRY',
  Drop = 'DROP'
}

export type TransferAccessActionInput = {
  action: TransferAccessAction;
  email: Scalars['String'];
};

export type TransferCloudToUserInput = {
  /** Per-email handling for the source connection's access. Emails not listed default to CARRY. */
  access_actions?: InputMaybe<Array<TransferAccessActionInput>>;
  cloud_id: Scalars['ID'];
  /** Required only when the target user has more than one eligible connection. */
  destination_connection_id?: InputMaybe<Scalars['ID']>;
  target_user_email: Scalars['String'];
  /** When true, also set the cloud's owner to the target user (defaults false). */
  transfer_owner?: InputMaybe<Scalars['Boolean']>;
};

export type TransferCloudToUserResponse = {
  __typename?: 'TransferCloudToUserResponse';
  connection_id?: Maybe<Scalars['ID']>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Usage record for a specific time period, module, and endpoint */
export type UnitUsageRecord = {
  __typename?: 'UnitUsageRecord';
  date?: Maybe<Scalars['String']>;
  endpoint: Scalars['String'];
  module: Scalars['String'];
  month?: Maybe<Scalars['Int']>;
  quarter?: Maybe<Scalars['Int']>;
  remarks?: Maybe<Scalars['String']>;
  totalUnitsConsumed: Scalars['Float'];
  week?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['Int']>;
};

/** Input for updating a Microsoft Entra SSO configuration */
export type UpdateOrganizationMicrosoftEntraSsoConfigInput = {
  /** OAuth client ID */
  clientId?: InputMaybe<Scalars['String']>;
  /** OAuth client secret (only updated if provided) */
  clientSecret?: InputMaybe<Scalars['String']>;
  /** OIDC discovery endpoint URL */
  discoveryUrl?: InputMaybe<Scalars['String']>;
  /** Whether to end the user's IDP session on logout (RP-Initiated Logout) */
  idpLogoutEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Whether SSO login is enabled */
  isEnabled?: InputMaybe<Scalars['Boolean']>;
};

/** Input for updating an Okta SSO configuration */
export type UpdateOrganizationOktaSsoConfigInput = {
  /** OAuth client ID */
  clientId?: InputMaybe<Scalars['String']>;
  /** OAuth client secret (only updated if provided) */
  clientSecret?: InputMaybe<Scalars['String']>;
  /** OIDC discovery endpoint URL */
  discoveryUrl?: InputMaybe<Scalars['String']>;
  /** Whether to end the user's IDP session on logout (RP-Initiated Logout) */
  idpLogoutEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Whether SSO login is enabled */
  isEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Authorization server audience */
  oktaAuthorizationServerAudience?: InputMaybe<Scalars['String']>;
  /** Client ID for the backend API Services app (for OBO token exchange) */
  oktaBackendClientId?: InputMaybe<Scalars['String']>;
  /** Client secret for the backend API Services app (only updated if provided) */
  oktaBackendClientSecret?: InputMaybe<Scalars['String']>;
};

export type UpdatePartnerConnectionInput = {
  connection_id: Scalars['String'];
  databricks_connection_name: Scalars['String'];
  stardog_connection_id: Scalars['String'];
};

export type UpdatePersonalConnectionAccessInput = {
  connectionId: Scalars['ID'];
  emails: Array<Scalars['String']>;
  stardog_roles?: InputMaybe<Array<Scalars['String']>>;
};

export type UpdateVoiceboxAppInput = {
  database?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  model?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  named_graphs?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  reasoning?: InputMaybe<Scalars['Boolean']>;
};

/**
 * The user model, this represents a user from Auth0. Only fields defined here
 * are exposed in the possible GraphQL responses.
 */
export type User = {
  __typename?: 'User';
  best_describes_company?: Maybe<Scalars['String']>;
  best_describes_role?: Maybe<Scalars['String']>;
  can_manage_orgs?: Maybe<Scalars['Boolean']>;
  can_provision_cloud?: Maybe<Scalars['Boolean']>;
  company?: Maybe<Scalars['String']>;
  date_joined?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  familiarity_with_kgs?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  has_stardog_free?: Maybe<Scalars['Boolean']>;
  has_updated_profile?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  industry?: Maybe<Scalars['String']>;
  is_authenticated?: Maybe<Scalars['Boolean']>;
  is_blocked_email?: Maybe<Scalars['Boolean']>;
  is_collaboration_enabled?: Maybe<Scalars['Boolean']>;
  is_databricks_user?: Maybe<Scalars['Boolean']>;
  is_designer_storage_enabled?: Maybe<Scalars['Boolean']>;
  is_ephemeral?: Maybe<Scalars['Boolean']>;
  /**
   * Whether the current session was established via a legacy customer SSO
   * provider (a pre-organization "bring your own IdP" login). Used by the
   * frontend to selectively surface the legacy customer SSO toggle in a
   * personal workspace while users are migrated to organization SSO.
   */
  is_legacy_customer_sso?: Maybe<Scalars['Boolean']>;
  is_partner_user?: Maybe<Scalars['Boolean']>;
  is_staff?: Maybe<Scalars['Boolean']>;
  is_static_voicebox?: Maybe<Scalars['Boolean']>;
  /** @deprecated is_studio_voicebox_enabled is deprecated. Use is_voicebox_enabled instead. */
  is_studio_voicebox_enabled?: Maybe<Scalars['Boolean']>;
  is_superuser?: Maybe<Scalars['Boolean']>;
  is_verified?: Maybe<Scalars['Boolean']>;
  is_voicebox_api_access_enabled?: Maybe<Scalars['Boolean']>;
  is_voicebox_enabled?: Maybe<Scalars['Boolean']>;
  is_voicebox_four_enabled?: Maybe<Scalars['Boolean']>;
  is_voicebox_powered_suggestions_enabled?: Maybe<Scalars['Boolean']>;
  is_voicebox_think_mode_enabled?: Maybe<Scalars['Boolean']>;
  /** @deprecated is_voicebox_three_enabled is deprecated. Use is_voicebox_think_mode_enabled instead. */
  is_voicebox_three_enabled?: Maybe<Scalars['Boolean']>;
  last_login?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  needs_stardog_free?: Maybe<Scalars['Boolean']>;
  phone?: Maybe<Scalars['String']>;
  stripe_customer?: Maybe<StripeCustomer>;
  sub?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  use_case?: Maybe<Scalars['String']>;
  userflow_signature?: Maybe<Scalars['String']>;
  username: Scalars['String'];
};

export type UserFeaturesInput = {
  is_collaboration_enabled?: InputMaybe<Scalars['Boolean']>;
  is_designer_storage_enabled?: InputMaybe<Scalars['Boolean']>;
  is_static_voicebox?: InputMaybe<Scalars['Boolean']>;
  is_voicebox_api_access_enabled?: InputMaybe<Scalars['Boolean']>;
  is_voicebox_enabled?: InputMaybe<Scalars['Boolean']>;
  is_voicebox_four_enabled?: InputMaybe<Scalars['Boolean']>;
};

export type UserSearchDetails = {
  __typename?: 'UserSearchDetails';
  total?: Maybe<Scalars['Int']>;
};

export type UserSearchFiltersInput = {
  is_designer_storage_enabled?: InputMaybe<Scalars['Boolean']>;
  is_staff?: InputMaybe<Scalars['Boolean']>;
  is_voicebox_api_access_enabled?: InputMaybe<Scalars['Boolean']>;
  is_voicebox_enabled?: InputMaybe<Scalars['Boolean']>;
};

export type UserVoiceboxMessageContext = {
  __typename?: 'UserVoiceboxMessageContext';
  app?: Maybe<Scalars['String']>;
  connection_id?: Maybe<Scalars['String']>;
  database?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  model?: Maybe<Scalars['String']>;
  named_graphs?: Maybe<Array<Maybe<Scalars['String']>>>;
  reasoning?: Maybe<Scalars['Boolean']>;
  think_mode?: Maybe<Scalars['String']>;
};

export type VoicboxSystemMessageAction = {
  __typename?: 'VoicboxSystemMessageAction';
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type VoiceboxApp = {
  __typename?: 'VoiceboxApp';
  connection_id: Scalars['String'];
  database?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  model?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  named_graphs?: Maybe<Array<Maybe<Scalars['String']>>>;
  reasoning?: Maybe<Scalars['Boolean']>;
};

/** A user's conversation with Voicebox */
export type VoiceboxConversation = {
  __typename?: 'VoiceboxConversation';
  created?: Maybe<Scalars['Datetime']>;
  /** The first message in the conversation that was sent by the user. */
  first_user_message?: Maybe<VoiceboxMessage>;
  id: Scalars['ID'];
  /** The last message in the conversation that was sent by the user. */
  last_user_message?: Maybe<VoiceboxMessage>;
  /** Message history ordered oldest to newest. */
  message_history?: Maybe<Array<Maybe<VoiceboxMessage>>>;
  name?: Maybe<Scalars['String']>;
  /** user message count */
  number_user_messages?: Maybe<Scalars['Int']>;
  updated?: Maybe<Scalars['Datetime']>;
};

export type VoiceboxConversationsFilterInput = {
  connection_id?: InputMaybe<Scalars['String']>;
  include_designer?: InputMaybe<Scalars['Boolean']>;
};

/** A Message within a Voicebox conversation. */
export type VoiceboxMessage = {
  __typename?: 'VoiceboxMessage';
  comment?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['Datetime']>;
  id: Scalars['ID'];
  score?: Maybe<Scalars['Float']>;
  sender?: Maybe<Scalars['String']>;
  system_message_context?: Maybe<SystemVoiceboxMessageContext>;
  user_message_context?: Maybe<UserVoiceboxMessageContext>;
};

export type VoiceboxResponseReportDownload = {
  __typename?: 'VoiceboxResponseReportDownload';
  csv: Scalars['String'];
  filename: Scalars['String'];
};

export type AcceptInvitationMutationVariables = Exact<{
  input: InvitationFlagInput;
}>;


export type AcceptInvitationMutation = { __typename?: 'Mutation', acceptInvitation?: { __typename?: 'GenericResponse', success: boolean, error?: string | null } | null };

export type AddCloudInvitationMutationVariables = Exact<{
  input: CloudInvitationInput;
}>;


export type AddCloudInvitationMutation = { __typename?: 'Mutation', addCloudInvitation?: { __typename?: 'GenericResponse', success: boolean, error?: string | null } | null };

export type AddConnectionInvitationsMutationVariables = Exact<{
  input: ConnectionInvitationsInput;
}>;


export type AddConnectionInvitationsMutation = { __typename?: 'Mutation', addConnectionInvitations?: { __typename?: 'AddInvitationsResponse', error?: string | null, results?: Array<{ __typename?: 'AddInvitationResult', email: string, success: boolean, error?: string | null }> | null } | null };

export type AddConnectionMutationVariables = Exact<{
  input: AddConnectionInput;
}>;


export type AddConnectionMutation = { __typename?: 'Mutation', addConnection?: { __typename?: 'Connection', id: string, index: number, name: string, endpoint: string, internalEndpoint?: string | null, username?: string | null, token?: string | null, useBrowserAuth?: boolean | null, useSSO?: boolean | null } | null };

export type AddMyOrganizationConnectionMutationVariables = Exact<{
  input: AddMyOrgConnectionInput;
}>;


export type AddMyOrganizationConnectionMutation = { __typename?: 'Mutation', addMyOrganizationConnection?: { __typename?: 'Connection', id: string, index: number, name: string, endpoint: string, internalEndpoint?: string | null, username?: string | null, token?: string | null, useBrowserAuth?: boolean | null, useSSO?: boolean | null } | null };

export type AddOrganizationInvitationsMutationVariables = Exact<{
  input: OrganizationInvitationsInput;
}>;


export type AddOrganizationInvitationsMutation = { __typename?: 'Mutation', addOrganizationInvitations?: { __typename?: 'AddInvitationsResponse', error?: string | null, results?: Array<{ __typename?: 'AddInvitationResult', email: string, success: boolean, error?: string | null }> | null } | null };

export type AddOrganizationMutationVariables = Exact<{
  input: AddOrganizationInput;
}>;


export type AddOrganizationMutation = { __typename?: 'Mutation', addOrganization?: { __typename?: 'AddOrganizationResult', organization?: { __typename?: 'Organization', id: string, name: string, description?: string | null, domain?: string | null, role?: string | null } | null, invitationResults?: Array<{ __typename?: 'AddInvitationResult', email: string, success: boolean, error?: string | null }> | null } | null };

export type AddSsoConnectionMutationVariables = Exact<{
  input: AddSsoConnectionInput;
}>;


export type AddSsoConnectionMutation = { __typename?: 'Mutation', addSSOConnection?: { __typename?: 'SSOConnectionRedirectResponse', redirect_url: string } | null };

export type CancelCloudMutationVariables = Exact<{
  input: CancelCloudInput;
}>;


export type CancelCloudMutation = { __typename?: 'Mutation', cancelCloud?: { __typename?: 'GenericResponse', success: boolean, error?: string | null } | null };

export type CheckoutCartMutationVariables = Exact<{
  item: CheckoutLineItem;
  addOns?: InputMaybe<Array<InputMaybe<CheckoutLineItem>> | InputMaybe<CheckoutLineItem>>;
}>;


export type CheckoutCartMutation = { __typename?: 'Mutation', checkoutCart?: { __typename?: 'BillingSession', url?: string | null } | null };

export type CreateApiTokenMutationVariables = Exact<{
  input: CreateApiTokenInput;
}>;


export type CreateApiTokenMutation = { __typename?: 'Mutation', createApiToken?: { __typename?: 'CreateApiTokenResult', secret: string } | null };

export type CreateOrganizationMicrosoftEntraSsoConfigMutationVariables = Exact<{
  domain: Scalars['String'];
  input: CreateOrganizationMicrosoftEntraSsoConfigInput;
}>;


export type CreateOrganizationMicrosoftEntraSsoConfigMutation = { __typename?: 'Mutation', createOrganizationMicrosoftEntraSSOConfig?: { __typename?: 'OrganizationMicrosoftEntraSSOConfig', id: string, providerType: SsoProviderType, discoveryUrl: string, clientId: string, hasClientSecret: boolean, isEnabled: boolean, idpLogoutEnabled: boolean, loginUrl: string, redirectUri: string, postLogoutRedirectUri: string, createdAt: any, updatedAt: any } | null };

export type CreateOrganizationOktaSsoConfigMutationVariables = Exact<{
  domain: Scalars['String'];
  input: CreateOrganizationOktaSsoConfigInput;
}>;


export type CreateOrganizationOktaSsoConfigMutation = { __typename?: 'Mutation', createOrganizationOktaSSOConfig?: { __typename?: 'OrganizationOktaSSOConfig', id: string, providerType: SsoProviderType, discoveryUrl: string, clientId: string, hasClientSecret: boolean, isEnabled: boolean, idpLogoutEnabled: boolean, loginUrl: string, redirectUri: string, postLogoutRedirectUri: string, oktaAuthorizationServerAudience: string, oktaBackendClientId: string, hasOktaBackendClientSecret: boolean, createdAt: any, updatedAt: any } | null };

export type CreateVoiceboxAppMutationVariables = Exact<{
  input: CreateVoiceboxAppInput;
}>;


export type CreateVoiceboxAppMutation = { __typename?: 'Mutation', createVoiceboxApp?: { __typename?: 'GenericResponse', success: boolean, error?: string | null } | null };

export type DeleteAccountMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteAccountMutation = { __typename?: 'Mutation', deleteAccount?: { __typename?: 'DeletionResponse', success: boolean, error?: string | null } | null };

export type DeleteApiTokenMutationVariables = Exact<{
  input: DeleteApiTokenInput;
}>;


export type DeleteApiTokenMutation = { __typename?: 'Mutation', deleteApiToken?: { __typename?: 'GenericResponse', success: boolean, error?: string | null } | null };

export type DeleteCloudMutationVariables = Exact<{
  input: CloudCleanupInput;
}>;


export type DeleteCloudMutation = { __typename?: 'Mutation', deleteCloud?: { __typename?: 'DeletionResponse', success: boolean, error?: string | null } | null };

export type DeleteConnectionMutationVariables = Exact<{
  input: DeleteConnectionInput;
}>;


export type DeleteConnectionMutation = { __typename?: 'Mutation', deleteConnection?: { __typename?: 'DeletionResponse', success: boolean, error?: string | null } | null };

export type DeleteInvitationsMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type DeleteInvitationsMutation = { __typename?: 'Mutation', deleteInvitations?: { __typename?: 'DeleteInvitationsResponse', error?: string | null, results?: Array<{ __typename?: 'DeleteInvitationResult', id: string, success: boolean, error?: string | null }> | null } | null };

export type DeleteMyOrganizationConnectionMutationVariables = Exact<{
  input: DeleteMyOrgConnectionInput;
}>;


export type DeleteMyOrganizationConnectionMutation = { __typename?: 'Mutation', deleteMyOrganizationConnection?: { __typename?: 'DeletionResponse', success: boolean, error?: string | null } | null };

export type DeleteOrganizationMutationVariables = Exact<{
  org_domain: Scalars['String'];
}>;


export type DeleteOrganizationMutation = { __typename?: 'Mutation', deleteOrganization?: { __typename?: 'GenericResponse', success: boolean, error?: string | null } | null };

export type DeleteOrganizationSsoConfigMutationVariables = Exact<{
  domain: Scalars['String'];
}>;


export type DeleteOrganizationSsoConfigMutation = { __typename?: 'Mutation', deleteOrganizationSSOConfig?: { __typename?: 'GenericResponse', success: boolean, error?: string | null } | null };

export type DeleteVoiceboxAppMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteVoiceboxAppMutation = { __typename?: 'Mutation', deleteVoiceboxApp?: { __typename?: 'GenericResponse', success: boolean, error?: string | null } | null };

export type DeleteVoiceboxConversationMutationVariables = Exact<{
  conversation_id: Scalars['ID'];
}>;


export type DeleteVoiceboxConversationMutation = { __typename?: 'Mutation', deleteVoiceboxConversation?: { __typename?: 'GenericResponse', success: boolean, error?: string | null } | null };

export type EditConnectionMutationVariables = Exact<{
  input: EditConnectionInput;
}>;


export type EditConnectionMutation = { __typename?: 'Mutation', editConnection?: { __typename?: 'Connection', id: string, index: number, name: string, endpoint: string, internalEndpoint?: string | null, username?: string | null, token?: string | null, useBrowserAuth?: boolean | null, useSSO?: boolean | null, ssoTokenExchangeScope?: string | null, usesOrgSso?: boolean | null } | null };

export type EditMyOrganizationConnectionMutationVariables = Exact<{
  input: EditMyOrgConnectionInput;
}>;


export type EditMyOrganizationConnectionMutation = { __typename?: 'Mutation', editMyOrganizationConnection?: { __typename?: 'Connection', id: string, index: number, name: string, endpoint: string, internalEndpoint?: string | null, username?: string | null, token?: string | null, useBrowserAuth?: boolean | null, useSSO?: boolean | null } | null };

export type EditOrganizationMutationVariables = Exact<{
  org_domain: Scalars['String'];
  input: EditOrganizationInput;
}>;


export type EditOrganizationMutation = { __typename?: 'Mutation', editOrganization?: { __typename?: 'Organization', id: string, name: string, description?: string | null, domain?: string | null, role?: string | null } | null };

export type EditVoiceboxConversationMutationVariables = Exact<{
  input: EditVoiceboxConversationInput;
}>;


export type EditVoiceboxConversationMutation = { __typename?: 'Mutation', editVoiceboxConversation?: { __typename?: 'GenericResponse', success: boolean, error?: string | null } | null };

export type GenerateConfigurationMutationVariables = Exact<{
  endpoint: Scalars['String'];
}>;


export type GenerateConfigurationMutation = { __typename?: 'Mutation', generateConfiguration?: { __typename?: 'ExampleConfig', id: string, jwt_config: string, properties: string } | null };

export type GenerateConnectionTokenQueryVariables = Exact<{
  connectionId: Scalars['ID'];
  forceRefresh?: InputMaybe<Scalars['Boolean']>;
}>;


export type GenerateConnectionTokenQuery = { __typename?: 'Query', generateConnectionToken?: { __typename?: 'OAuthToken', access_token?: string | null, user: { __typename?: 'User', username: string } } | null };

export type GenerateTokenQueryVariables = Exact<{
  endpoint: Scalars['String'];
}>;


export type GenerateTokenQuery = { __typename?: 'Query', generateToken?: { __typename?: 'OAuthToken', access_token?: string | null, user: { __typename?: 'User', username: string } } | null };

export type GenerateVoiceboxResponseReportQueryVariables = Exact<{
  input: GenerateVoiceboxResponseReportInput;
}>;


export type GenerateVoiceboxResponseReportQuery = { __typename?: 'Query', generateVoiceboxResponseReport: { __typename?: 'VoiceboxResponseReportDownload', filename: string, csv: string } };

export type GetCloudConnectionMovePreviewQueryVariables = Exact<{
  cloud_id: Scalars['ID'];
}>;


export type GetCloudConnectionMovePreviewQuery = { __typename?: 'Query', getCloudConnectionMovePreview?: { __typename?: 'CloudConnectionMovePreview', eligible?: boolean | null, ineligible_reason?: string | null, other_connections?: Array<string | null> | null, access?: Array<{ __typename?: 'CloudConnectionMoveAccess', email?: string | null, accepted?: boolean | null, owns_separate_connection?: boolean | null, is_cloud_owner?: boolean | null } | null> | null } | null };

export type GetCloudReportQueryVariables = Exact<{
  filters?: InputMaybe<CloudFilters>;
}>;


export type GetCloudReportQuery = { __typename?: 'Query', getCloudReport?: { __typename?: 'CloudReportData', clouds?: Array<{ __typename?: 'StardogCloud', id?: string | null, name?: string | null, status?: string | null, endpoint?: string | null, created?: string | null, connection_in_personal_org?: boolean | null, move_available?: boolean | null, cleanup_available?: boolean | null, transfer_available?: boolean | null, validation?: Array<string | null> | null, flavor?: { __typename?: 'CloudFlavor', name?: string | null } | null, owner?: { __typename?: 'User', username: string, last_login?: string | null } | null } | null> | null, stats?: { __typename?: 'CloudReportStats', totalAllocated?: number | null, totalInactive?: number | null, resultCount?: number | null, resultInactiveCount?: number | null } | null, queueCounts?: { __typename?: 'QueueCounts', micro_count?: number | null, small_vbx_count?: number | null, medium_count?: number | null } | null } | null };

export type GetCloudSduLifetimeQueryVariables = Exact<{
  cloud_ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type GetCloudSduLifetimeQuery = { __typename?: 'Query', getCloudSduLifetime: Array<{ __typename?: 'CloudSduLifetime', cloudId: string, totalUnitsConsumed?: number | null, status: CloudSduStatus }> };

export type GetCloudSduUsageQueryVariables = Exact<{
  cloud_id: Scalars['ID'];
}>;


export type GetCloudSduUsageQuery = { __typename?: 'Query', getCloudSduUsage: Array<{ __typename?: 'CloudSduUsageRecord', date: string, totalUnitsConsumed: number }> };

export type GetCloudTransferPreviewQueryVariables = Exact<{
  cloud_id: Scalars['ID'];
}>;


export type GetCloudTransferPreviewQuery = { __typename?: 'Query', getCloudTransferPreview?: { __typename?: 'CloudTransferPreview', connection_name?: string | null, endpoint?: string | null, eligible?: boolean | null, ineligible_reason?: string | null, other_connections?: Array<string | null> | null, carried_access?: Array<{ __typename?: 'CloudTransferAccess', email?: string | null, stardog_roles?: Array<string | null> | null, accepted?: boolean | null } | null> | null, other_access?: Array<{ __typename?: 'CloudTransferAccess', email?: string | null, stardog_roles?: Array<string | null> | null, accepted?: boolean | null } | null> | null } | null };

export type GetCloudTransferTargetQueryVariables = Exact<{
  cloud_id: Scalars['ID'];
  email: Scalars['String'];
}>;


export type GetCloudTransferTargetQuery = { __typename?: 'Query', getCloudTransferTarget?: { __typename?: 'CloudTransferTarget', user_exists?: boolean | null, candidates?: Array<{ __typename?: 'CloudTransferTargetConnection', connection_id?: string | null, connection_name?: string | null } | null> | null } | null };

export type GetConnectionByIdQueryVariables = Exact<{
  id: Scalars['String'];
  org_domain?: InputMaybe<Scalars['String']>;
}>;


export type GetConnectionByIdQuery = { __typename?: 'Query', connection?: { __typename?: 'Connection', id: string, index: number, name: string, endpoint: string } | null };

export type GetConnectionByIndexQueryVariables = Exact<{
  index: Scalars['Int'];
  org_domain?: InputMaybe<Scalars['String']>;
}>;


export type GetConnectionByIndexQuery = { __typename?: 'Query', connection?: { __typename?: 'Connection', id: string, index: number, name: string, endpoint: string, internalEndpoint?: string | null, username?: string | null, token?: string | null, useBrowserAuth?: boolean | null, useSSO?: boolean | null, useConnectionSSO?: boolean | null, ssoTokenExchangeScope?: string | null, usesOrgSso?: boolean | null, isStardogFree?: boolean | null, isStardogCloud?: boolean | null, isAllocating?: boolean | null, shouldShowDesigner?: boolean | null, cloud?: { __typename?: 'StardogCloud', id?: string | null, flavor?: { __typename?: 'CloudFlavor', name?: string | null } | null, owner?: { __typename?: 'User', id?: string | null, email?: string | null, username: string } | null } | null, access?: { __typename?: 'ConnectionAccess', id: string, stardog_roles?: Array<string | null> | null, organization_is_enabled?: boolean | null, user_is_private?: boolean | null, user?: { __typename?: 'User', id?: string | null, username: string } | null, organization?: { __typename?: 'Organization', id: string, name: string, orgType?: OrgType | null } | null } | null, organization?: { __typename?: 'Organization', id: string, name: string, orgType?: OrgType | null, owner?: { __typename?: 'User', id?: string | null, first_name?: string | null, last_name?: string | null, username: string } | null } | null, stripeSubscription?: { __typename?: 'PurchaseSession', url?: string | null, status?: string | null, isWaitingForPayment?: boolean | null } | null, stripeSubscriptionOrder?: { __typename?: 'ProvisionedOrder', payment_system?: string | null, trial_days_remaining?: number | null, trial_days_total?: number | null } | null, ssoProvider?: { __typename?: 'SsoProviderInfo', isValid: boolean, clientId?: string | null, providerName?: string | null, providerType?: string | null } | null } | null };

export type GetCustomerSsoSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCustomerSsoSettingsQuery = { __typename?: 'Query', customerSsoSettings?: { __typename?: 'CustomerSsoSettings', azureProviders: Array<{ __typename?: 'AzureProvider', customerName: string } | null>, pingProviders: Array<{ __typename?: 'PingProvider', customerName: string } | null>, oktaProviders: Array<{ __typename?: 'OktaProvider', customerName: string } | null> } | null };

export type GetInvitationQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetInvitationQuery = { __typename?: 'Query', getInvitation?: { __typename?: 'Invitation', id?: string | null, email?: string | null, endpoint?: string | null, created?: any | null, expires?: any | null, accepted?: boolean | null, connection?: { __typename?: 'InvitationConnection', id: string, name: string, endpoint: string } | null, organization?: { __typename?: 'InvitationOrganization', id: string, name: string, domain?: string | null } | null, sender?: { __typename?: 'InvitationUser', email?: string | null, first_name?: string | null, last_name?: string | null } | null, existing_user?: { __typename?: 'InvitationUser', email?: string | null, first_name?: string | null, last_name?: string | null } | null } | null };

export type MarketplaceSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type MarketplaceSettingsQuery = { __typename?: 'Query', marketplaceSettings?: { __typename?: 'MarketplaceSettings', marketplaceUsername: string, marketplacePassword: string, marketplaceEndpoint: string, marketplaceDatabase: string } | null };

export type GetOrgConnectionCleanupPreviewQueryVariables = Exact<{
  cloud_id: Scalars['ID'];
}>;


export type GetOrgConnectionCleanupPreviewQuery = { __typename?: 'Query', getOrgConnectionCleanupPreview?: { __typename?: 'OrgConnectionCleanupPreview', connection_id?: string | null, connection_name?: string | null, endpoint?: string | null, org_name?: string | null, org_domain?: string | null, is_org_connection?: boolean | null, org_members_without_access?: Array<string | null> | null, orphaned?: Array<{ __typename?: 'OrphanedCloudConnection', connection_id?: string | null, connection_name?: string | null, owner_email?: string | null, stardog_roles?: Array<string | null> | null, is_org_member?: boolean | null, has_org_access?: boolean | null } | null> | null } | null };

export type GetOrganizationQueryVariables = Exact<{
  org_domain?: InputMaybe<Scalars['String']>;
}>;


export type GetOrganizationQuery = { __typename?: 'Query', getOrganization?: { __typename?: 'Organization', id: string, name: string, description?: string | null, domain?: string | null, role?: string | null, membersHiddenFromMembers?: boolean | null, isSsoAllowed?: boolean | null, ssoConfig?: { __typename?: 'OrganizationMicrosoftEntraSSOConfig', id: string, providerType: SsoProviderType, discoveryUrl: string, clientId: string, hasClientSecret: boolean, isEnabled: boolean, idpLogoutEnabled: boolean, loginUrl: string, redirectUri: string, postLogoutRedirectUri: string, createdAt: any, updatedAt: any } | { __typename?: 'OrganizationOktaSSOConfig', id: string, providerType: SsoProviderType, discoveryUrl: string, clientId: string, hasClientSecret: boolean, isEnabled: boolean, idpLogoutEnabled: boolean, loginUrl: string, redirectUri: string, postLogoutRedirectUri: string, oktaAuthorizationServerAudience: string, oktaBackendClientId: string, hasOktaBackendClientSecret: boolean, createdAt: any, updatedAt: any } | null, ssoIdentity?: { __typename?: 'OrganizationSSOIdentity', isLinked: boolean, idpSubject?: string | null, linkedAt?: any | null } | null } | null };

export type GetOrganizationInvitationsQueryVariables = Exact<{
  org_domain?: InputMaybe<Scalars['String']>;
}>;


export type GetOrganizationInvitationsQuery = { __typename?: 'Query', getOrganizationInvitations?: Array<{ __typename?: 'OrganizationInvitation', id: string, email: string, organization_role: string, created?: any | null, expired?: boolean | null, accepted?: boolean | null } | null> | null };

export type GetOrganizationMembersQueryVariables = Exact<{
  org_domain?: InputMaybe<Scalars['String']>;
}>;


export type GetOrganizationMembersQuery = { __typename?: 'Query', getOrganizationMembers?: Array<{ __typename?: 'OrganizationMember', role: string, user: { __typename?: 'User', id?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null } } | null> | null };

export type GetOrganizationMoveTargetQueryVariables = Exact<{
  domain: Scalars['String'];
}>;


export type GetOrganizationMoveTargetQuery = { __typename?: 'Query', getOrganizationMoveTarget?: { __typename?: 'OrganizationMoveTarget', valid?: boolean | null, members?: Array<{ __typename?: 'OrganizationMoveTargetMember', email?: string | null, role?: string | null } | null> | null } | null };

export type GetProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProductsQuery = { __typename?: 'Query', getStripePrices?: Array<{ __typename?: 'StripePrice', id?: string | null, nickname?: string | null, amount?: string | null, stardog_billing_type?: string | null, product_info?: { __typename?: 'StripeProduct', name?: string | null, description?: string | null, metadata?: { __typename?: 'StripeProductMetadata', flavor?: string | null } | null } | null } | null> | null, checkCloudQueue?: { __typename?: 'QueueCounts', small_count?: number | null, medium_count?: number | null, micro_count?: number | null } | null, profile?: { __typename?: 'User', has_stardog_free?: boolean | null, is_staff?: boolean | null, is_blocked_email?: boolean | null, stripe_customer?: { __typename?: 'StripeCustomer', is_cloud_quota_breached?: boolean | null, cloud_quota?: { __typename?: 'Quota', total?: number | null, available?: number | null } | null } | null } | null };

export type GetSsoConnectionRegistryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSsoConnectionRegistryQuery = { __typename?: 'Query', getSSOConnectionRegistry?: Array<{ __typename?: 'SSOConnectionRegistration', display_provider_name: string, provider_name: string, stardog_endpoint?: string | null, stardog_internal_endpoint?: string | null } | null> | null };

export type GetShareByShortHashQueryVariables = Exact<{
  shortHash: Scalars['String'];
}>;


export type GetShareByShortHashQuery = { __typename?: 'Query', getShareByShortHash?: { __typename?: 'Share', target_path?: string | null, endpoint?: string | null, org_domain?: string | null, connection_id?: string | null, service?: string | null, last_accessed?: any | null } | null };

export type GetStripeSessionUrlMutationVariables = Exact<{ [key: string]: never; }>;


export type GetStripeSessionUrlMutation = { __typename?: 'Mutation', getStripeSessionUrl?: { __typename?: 'BillingSession', url?: string | null } | null };

export type GetTotalUnitUsageQueryVariables = Exact<{
  connectionId?: InputMaybe<Scalars['ID']>;
  org_domain?: InputMaybe<Scalars['String']>;
}>;


export type GetTotalUnitUsageQuery = { __typename?: 'Query', getTotalUnitUsage?: { __typename?: 'TotalUnitUsage', totalUnitsConsumed: number } | null };

export type GetUnitUsageQueryVariables = Exact<{
  connectionId?: InputMaybe<Scalars['ID']>;
  startDate?: InputMaybe<Scalars['Date']>;
  endDate?: InputMaybe<Scalars['Date']>;
  org_domain?: InputMaybe<Scalars['String']>;
  modules?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  timeGrain?: InputMaybe<TimeGrain>;
}>;


export type GetUnitUsageQuery = { __typename?: 'Query', getUnitUsage?: Array<{ __typename?: 'UnitUsageRecord', date?: string | null, year?: number | null, month?: number | null, week?: number | null, quarter?: number | null, module: string, endpoint: string, totalUnitsConsumed: number, remarks?: string | null } | null> | null };

export type GetUserCurrentPartnerConnectionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserCurrentPartnerConnectionQuery = { __typename?: 'Query', profile?: { __typename?: 'User', first_name?: string | null, last_name?: string | null, email?: string | null, username: string } | null, getUserCurrentPartnerConnection?: { __typename?: 'PartnerConnectionDetail', databricks_workspace_id?: string | null, jdbc_url?: string | null, workspace_url?: string | null, user_email?: string | null, connection_id?: string | null, user_first_name?: string | null, is_configured_resources?: boolean | null, databricks_connection_name?: string | null, databricks_personal_token_id?: string | null, cluster_id?: string | null, stardog_server_connection?: { __typename?: 'Connection', name: string, id: string, isStardogCloud?: boolean | null, index: number, endpoint: string } | null } | null };

export type GetUserInfoQueryVariables = Exact<{
  user_id: Scalars['String'];
}>;


export type GetUserInfoQuery = { __typename?: 'Query', getUser?: { __typename?: 'User', company?: string | null, email?: string | null, first_name?: string | null, has_stardog_free?: boolean | null, id?: string | null, is_databricks_user?: boolean | null, is_staff?: boolean | null, is_designer_storage_enabled?: boolean | null, is_voicebox_enabled?: boolean | null, is_static_voicebox?: boolean | null, is_voicebox_api_access_enabled?: boolean | null, is_voicebox_think_mode_enabled?: boolean | null, is_voicebox_powered_suggestions_enabled?: boolean | null, is_voicebox_four_enabled?: boolean | null, is_collaboration_enabled?: boolean | null, is_verified?: boolean | null, is_authenticated?: boolean | null, last_login?: string | null, last_name?: string | null, phone?: string | null, title?: string | null, use_case?: string | null, date_joined?: string | null } | null, getUserConnections?: Array<{ __typename?: 'Connection', id: string, name: string, endpoint: string, useSSO?: boolean | null, type?: string | null } | null> | null, getUserClouds?: Array<{ __typename?: 'StardogCloud', created?: string | null, endpoint?: string | null, id?: string | null, name?: string | null, status?: string | null, region?: string | null, updated?: string | null, payment_ref?: string | null, flavor?: { __typename?: 'CloudFlavor', name?: string | null } | null } | null> | null, getUserArchivedClouds?: Array<{ __typename?: 'ArchivedCloud', created?: string | null, endpoint?: string | null, flavor?: string | null, id?: string | null, name?: string | null, payment_ref?: string | null, region?: string | null } | null> | null, grafanaHighLevelDashboardSettings?: { __typename?: 'GrafanaDashboardSettings', id: string, slug: string } | null };

export type LeaveOrganizationMutationVariables = Exact<{
  org_domain: Scalars['String'];
}>;


export type LeaveOrganizationMutation = { __typename?: 'Mutation', leaveOrganization?: { __typename?: 'GenericResponse', success: boolean, error?: string | null } | null };

export type ListApiTokensQueryVariables = Exact<{
  app_id?: InputMaybe<Scalars['ID']>;
  paging?: InputMaybe<PagingInput>;
}>;


export type ListApiTokensQuery = { __typename?: 'Query', listApiTokens?: Array<{ __typename?: 'ApiToken', created: any, expires: any, id: string, last_used?: any | null, name?: string | null } | null> | null, apiTokenCount?: { __typename?: 'ItemCount', count?: number | null } | null };

export type ListConnectionUsersQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ListConnectionUsersQuery = { __typename?: 'Query', listUserConnectionAccess?: Array<{ __typename?: 'ConnectionAccess', id: string, stardog_roles?: Array<string | null> | null, user?: { __typename?: 'User', id?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null } | null } | null> | null, listUserConnectionInvitations?: Array<{ __typename?: 'ConnectionInvitation', id: string, email: string, connection_roles?: Array<string> | null, created?: any | null, expired?: boolean | null, accepted?: boolean | null } | null> | null };

export type ListConnectionsByEndpointQueryVariables = Exact<{
  endpoint: Scalars['String'];
}>;


export type ListConnectionsByEndpointQuery = { __typename?: 'Query', listConnectionsByEndpoint?: Array<{ __typename?: 'Connection', id: string, index: number, name: string, endpoint: string, username?: string | null, token?: string | null, useBrowserAuth?: boolean | null, useSSO?: boolean | null, isStardogFree?: boolean | null, isStardogCloud?: boolean | null, isAllocating?: boolean | null, cloud?: { __typename?: 'StardogCloud', id?: string | null } | null, stripeSubscription?: { __typename?: 'PurchaseSession', url?: string | null, status?: string | null, isWaitingForPayment?: boolean | null, isExpired?: boolean | null } | null } | null> | null };

export type ListOrganizationConnectionAccessQueryVariables = Exact<{
  id: Scalars['ID'];
  org_domain: Scalars['String'];
}>;


export type ListOrganizationConnectionAccessQuery = { __typename?: 'Query', listOrganizationConnectionAccess?: Array<{ __typename?: 'ConnectionAccess', id: string, stardog_roles?: Array<string | null> | null, organization_is_enabled?: boolean | null, user_is_private?: boolean | null, user?: { __typename?: 'User', id?: string | null, email?: string | null, first_name?: string | null, last_name?: string | null } | null, organization?: { __typename?: 'Organization', id: string, name: string } | null } | null> | null };

export type ListOrganizationConnectionsQueryVariables = Exact<{
  org_domain: Scalars['String'];
}>;


export type ListOrganizationConnectionsQuery = { __typename?: 'Query', listConnections?: Array<{ __typename?: 'Connection', id: string, index: number, name: string, endpoint: string, username?: string | null, token?: string | null, useSSO?: boolean | null, ssoTokenExchangeScope?: string | null, usesOrgSso?: boolean | null, isStardogFree?: boolean | null, isStardogCloud?: boolean | null, access?: { __typename?: 'ConnectionAccess', id: string, stardog_roles?: Array<string | null> | null, organization_is_enabled?: boolean | null, user_is_private?: boolean | null, user?: { __typename?: 'User', id?: string | null, username: string } | null, organization?: { __typename?: 'Organization', id: string, name: string, orgType?: OrgType | null } | null } | null } | null> | null, listDefaultOrganizationConnectionsAccess?: Array<{ __typename?: 'ConnectionAccess', id: string, stardog_roles?: Array<string | null> | null, connection?: { __typename?: 'Connection', id: string } | null } | null> | null };

export type ListOrganizationsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListOrganizationsQuery = { __typename?: 'Query', listOrganizations?: Array<{ __typename?: 'Organization', id: string, name: string, description?: string | null, domain?: string | null, role?: string | null } | null> | null };

export type ListVoiceboxAppsQueryVariables = Exact<{ [key: string]: never; }>;


export type ListVoiceboxAppsQuery = { __typename?: 'Query', listVoiceboxApps?: Array<{ __typename?: 'VoiceboxApp', id: string, name: string, connection_id: string, database?: string | null, model?: string | null, named_graphs?: Array<string | null> | null, reasoning?: boolean | null } | null> | null };

export type ListVoiceboxConversationsQueryVariables = Exact<{
  paging?: InputMaybe<PagingInput>;
  filterInput?: InputMaybe<VoiceboxConversationsFilterInput>;
}>;


export type ListVoiceboxConversationsQuery = { __typename?: 'Query', listVoiceboxConversations?: Array<{ __typename?: 'VoiceboxConversation', id: string, name?: string | null, created?: any | null, number_user_messages?: number | null, first_user_message?: { __typename?: 'VoiceboxMessage', content?: string | null, user_message_context?: { __typename?: 'UserVoiceboxMessageContext', app?: string | null } | null } | null, last_user_message?: { __typename?: 'VoiceboxMessage', content?: string | null, created?: any | null, user_message_context?: { __typename?: 'UserVoiceboxMessageContext', connection_id?: string | null, database?: string | null } | null } | null } | null> | null, voiceboxConversationCount?: { __typename?: 'ItemCount', count?: number | null } | null };

export type MoveCloudConnectionToOrgMutationVariables = Exact<{
  input: MoveCloudConnectionToOrgInput;
}>;


export type MoveCloudConnectionToOrgMutation = { __typename?: 'Mutation', moveCloudConnectionToOrg?: { __typename?: 'MoveCloudConnectionToOrgResponse', success?: boolean | null } | null };

export type ProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfileQuery = { __typename?: 'Query', profile?: { __typename?: 'User', id?: string | null, is_superuser?: boolean | null, can_manage_orgs?: boolean | null, is_staff?: boolean | null, has_updated_profile?: boolean | null, is_ephemeral?: boolean | null, is_authenticated?: boolean | null, is_verified?: boolean | null, is_designer_storage_enabled?: boolean | null, is_voicebox_enabled?: boolean | null, is_static_voicebox?: boolean | null, is_voicebox_api_access_enabled?: boolean | null, is_voicebox_think_mode_enabled?: boolean | null, is_voicebox_powered_suggestions_enabled?: boolean | null, is_voicebox_four_enabled?: boolean | null, is_legacy_customer_sso?: boolean | null, username: string, first_name?: string | null, last_name?: string | null, email?: string | null, company?: string | null, title?: string | null, phone?: string | null, use_case?: string | null, is_databricks_user?: boolean | null, userflow_signature?: string | null, date_joined?: string | null, familiarity_with_kgs?: string | null, best_describes_role?: string | null, industry?: string | null, best_describes_company?: string | null, stripe_customer?: { __typename?: 'StripeCustomer', customer_id?: string | null } | null } | null };

export type ReauthenticateSsoConnectionMutationVariables = Exact<{
  input: ReauthenticateSsoConnectionInput;
}>;


export type ReauthenticateSsoConnectionMutation = { __typename?: 'Mutation', reauthenticateSSOConnection?: { __typename?: 'SSOConnectionRedirectResponse', redirect_url: string } | null };

export type RemoveMySharedConnectionMutationVariables = Exact<{
  input: RemoveMySharedConnectionInput;
}>;


export type RemoveMySharedConnectionMutation = { __typename?: 'Mutation', removeMySharedConnection?: { __typename?: 'GenericResponse', success: boolean, error?: string | null } | null };

export type RemoveOrganizationMembersMutationVariables = Exact<{
  org_domain: Scalars['String'];
  emails: Array<Scalars['String']> | Scalars['String'];
}>;


export type RemoveOrganizationMembersMutation = { __typename?: 'Mutation', removeOrganizationMembers?: { __typename?: 'OrganizationMembersResponse', error?: string | null, results?: Array<{ __typename?: 'OrganizationMemberResult', email: string, success: boolean, error?: string | null }> | null } | null };

export type RemovePartnerConnectionMutationVariables = Exact<{
  input: RemovePartnerConnectionInput;
}>;


export type RemovePartnerConnectionMutation = { __typename?: 'Mutation', removePartnerConnection?: { __typename?: 'GenericResponse', success: boolean, error?: string | null } | null };

export type RenameMySharedConnectionMutationVariables = Exact<{
  input: RenameMySharedConnectionInput;
}>;


export type RenameMySharedConnectionMutation = { __typename?: 'Mutation', renameMySharedConnection?: { __typename?: 'GenericResponse', success: boolean, error?: string | null } | null };

export type ResendEmailMutationVariables = Exact<{ [key: string]: never; }>;


export type ResendEmailMutation = { __typename?: 'Mutation', resendEmail?: { __typename?: 'GenericResponse', success: boolean, error?: string | null } | null };

export type ResolveOrphanedConnectionsMutationVariables = Exact<{
  input: ResolveOrphanedConnectionsInput;
}>;


export type ResolveOrphanedConnectionsMutation = { __typename?: 'Mutation', resolveOrphanedConnections?: { __typename?: 'ResolveOrphanedConnectionsResponse', success?: boolean | null, removed?: number | null, migrated?: number | null, left?: number | null } | null };

export type RevokeMemberConnectionRolesMutationVariables = Exact<{
  input: RevokeMemberConnectionRolesInput;
}>;


export type RevokeMemberConnectionRolesMutation = { __typename?: 'Mutation', revokeMemberConnectionRoles?: { __typename?: 'ModifyConnectionAccessResponse', error?: string | null, results?: Array<{ __typename?: 'ModifyConnectionAccessResult', email: string, error?: string | null, success: boolean }> | null } | null };

export type RevokePersonalConnectionAccessMutationVariables = Exact<{
  input: RevokePersonalConnectionAccessInput;
}>;


export type RevokePersonalConnectionAccessMutation = { __typename?: 'Mutation', revokePersonalConnectionAccess?: { __typename?: 'ModifyConnectionAccessResponse', error?: string | null, results?: Array<{ __typename?: 'ModifyConnectionAccessResult', email: string, error?: string | null, success: boolean }> | null } | null };

export type SavedConnectionsQueryVariables = Exact<{
  org_domain?: InputMaybe<Scalars['String']>;
}>;


export type SavedConnectionsQuery = { __typename?: 'Query', listConnections?: Array<{ __typename?: 'Connection', id: string, index: number, name: string, endpoint: string, internalEndpoint?: string | null, username?: string | null, token?: string | null, useBrowserAuth?: boolean | null, useSSO?: boolean | null, useConnectionSSO?: boolean | null, ssoTokenExchangeScope?: string | null, usesOrgSso?: boolean | null, isStardogFree?: boolean | null, isStardogCloud?: boolean | null, isAllocating?: boolean | null, cloud?: { __typename?: 'StardogCloud', id?: string | null, owner?: { __typename?: 'User', id?: string | null, email?: string | null, username: string } | null, flavor?: { __typename?: 'CloudFlavor', name?: string | null } | null } | null, access?: { __typename?: 'ConnectionAccess', id: string, stardog_roles?: Array<string | null> | null, organization_is_enabled?: boolean | null, user_is_private?: boolean | null, user?: { __typename?: 'User', id?: string | null, username: string } | null, organization?: { __typename?: 'Organization', id: string, name: string, orgType?: OrgType | null } | null } | null, organization?: { __typename?: 'Organization', id: string, name: string, orgType?: OrgType | null, owner?: { __typename?: 'User', id?: string | null, first_name?: string | null, last_name?: string | null, username: string } | null } | null, stripeSubscription?: { __typename?: 'PurchaseSession', url?: string | null, status?: string | null, isWaitingForPayment?: boolean | null, isExpired?: boolean | null } | null, ssoProvider?: { __typename?: 'SsoProviderInfo', isValid: boolean, clientId?: string | null, providerName?: string | null, providerType?: string | null } | null } | null> | null };

export type GetUserSearchResultsQueryVariables = Exact<{
  token: Scalars['String'];
  filters?: InputMaybe<UserSearchFiltersInput>;
  offset: Scalars['Int'];
  limit: Scalars['Int'];
}>;


export type GetUserSearchResultsQuery = { __typename?: 'Query', searchUsers?: Array<{ __typename?: 'User', company?: string | null, email?: string | null, first_name?: string | null, has_stardog_free?: boolean | null, id?: string | null, is_databricks_user?: boolean | null, is_staff?: boolean | null, is_designer_storage_enabled?: boolean | null, is_voicebox_enabled?: boolean | null, is_static_voicebox?: boolean | null, is_voicebox_api_access_enabled?: boolean | null, is_voicebox_think_mode_enabled?: boolean | null, is_voicebox_powered_suggestions_enabled?: boolean | null, is_voicebox_four_enabled?: boolean | null, is_verified?: boolean | null, last_login?: string | null, last_name?: string | null, title?: string | null } | null> | null, getUserSearchDetails?: { __typename?: 'UserSearchDetails', total?: number | null } | null };

export type SetMemberConnectionRolesMutationVariables = Exact<{
  input: SetMemberConnectionRolesInput;
}>;


export type SetMemberConnectionRolesMutation = { __typename?: 'Mutation', setMemberConnectionRoles?: { __typename?: 'ModifyConnectionAccessResponse', error?: string | null, results?: Array<{ __typename?: 'ModifyConnectionAccessResult', email: string, error?: string | null, success: boolean }> | null } | null };

export type SetOrganizationConnectionVisibilityMutationVariables = Exact<{
  input: SetOrgConnectionVisibilityInput;
}>;


export type SetOrganizationConnectionVisibilityMutation = { __typename?: 'Mutation', setOrganizationConnectionVisibility?: { __typename?: 'GenericResponse', success: boolean, error?: string | null } | null };

export type SettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type SettingsQuery = { __typename?: 'Query', settings: { __typename?: 'Settings', auth0Auth: boolean, azureAuth: boolean, baseURL: string, explorerVersion: string, designerVersion: string, friendlyName: string, googleAuth: boolean, kerberosAuth: boolean, oktaAuth: boolean, duoAuth: boolean, pingAuth: boolean, portal: boolean, openidAuth: boolean, sharedUserAuth: boolean, stardogEndpoint: string, studioVersion: string, dataMarketplace: boolean, homeFooterLinks: boolean, copyConnectionTokenButtonEnabled: boolean, requireSsoConnections: boolean } };

export type TrackEventMutationVariables = Exact<{
  input: TrackEventInput;
}>;


export type TrackEventMutation = { __typename?: 'Mutation', trackEvent?: { __typename?: 'GenericResponse', success: boolean, error?: string | null } | null };

export type TransferCloudToUserMutationVariables = Exact<{
  input: TransferCloudToUserInput;
}>;


export type TransferCloudToUserMutation = { __typename?: 'Mutation', transferCloudToUser?: { __typename?: 'TransferCloudToUserResponse', success?: boolean | null } | null };

export type TransferOrganizationOwnershipMutationVariables = Exact<{
  org_domain: Scalars['String'];
  email: Scalars['String'];
}>;


export type TransferOrganizationOwnershipMutation = { __typename?: 'Mutation', transferOrganizationOwnership?: { __typename?: 'GenericResponse', success: boolean, error?: string | null } | null };

export type UpdateOrganizationMembersRoleMutationVariables = Exact<{
  org_domain: Scalars['String'];
  emails: Array<Scalars['String']> | Scalars['String'];
  new_role: Scalars['String'];
}>;


export type UpdateOrganizationMembersRoleMutation = { __typename?: 'Mutation', updateOrganizationMembersRole?: { __typename?: 'OrganizationMembersResponse', error?: string | null, results?: Array<{ __typename?: 'OrganizationMemberResult', email: string, success: boolean, error?: string | null }> | null } | null };

export type UpdateOrganizationMicrosoftEntraSsoConfigMutationVariables = Exact<{
  domain: Scalars['String'];
  input: UpdateOrganizationMicrosoftEntraSsoConfigInput;
}>;


export type UpdateOrganizationMicrosoftEntraSsoConfigMutation = { __typename?: 'Mutation', updateOrganizationMicrosoftEntraSSOConfig?: { __typename?: 'OrganizationMicrosoftEntraSSOConfig', id: string, providerType: SsoProviderType, discoveryUrl: string, clientId: string, hasClientSecret: boolean, isEnabled: boolean, idpLogoutEnabled: boolean, loginUrl: string, redirectUri: string, postLogoutRedirectUri: string, createdAt: any, updatedAt: any } | null };

export type UpdateOrganizationOktaSsoConfigMutationVariables = Exact<{
  domain: Scalars['String'];
  input: UpdateOrganizationOktaSsoConfigInput;
}>;


export type UpdateOrganizationOktaSsoConfigMutation = { __typename?: 'Mutation', updateOrganizationOktaSSOConfig?: { __typename?: 'OrganizationOktaSSOConfig', id: string, providerType: SsoProviderType, discoveryUrl: string, clientId: string, hasClientSecret: boolean, isEnabled: boolean, idpLogoutEnabled: boolean, loginUrl: string, redirectUri: string, postLogoutRedirectUri: string, oktaAuthorizationServerAudience: string, oktaBackendClientId: string, hasOktaBackendClientSecret: boolean, createdAt: any, updatedAt: any } | null };

export type UpdatePartnerConnectionMutationVariables = Exact<{
  input: UpdatePartnerConnectionInput;
}>;


export type UpdatePartnerConnectionMutation = { __typename?: 'Mutation', updatePartnerConnection?: { __typename?: 'GenericResponse', success: boolean, error?: string | null } | null };

export type UpdatePersonalConnectionAccessMutationVariables = Exact<{
  input: UpdatePersonalConnectionAccessInput;
}>;


export type UpdatePersonalConnectionAccessMutation = { __typename?: 'Mutation', updatePersonalConnectionAccess?: { __typename?: 'ModifyConnectionAccessResponse', error?: string | null, results?: Array<{ __typename?: 'ModifyConnectionAccessResult', email: string, success: boolean, error?: string | null }> | null } | null };

export type UpdateProfileMutationVariables = Exact<{
  input: ProfileInput;
}>;


export type UpdateProfileMutation = { __typename?: 'Mutation', updateProfile?: { __typename?: 'User', id?: string | null, username: string, is_authenticated?: boolean | null, title?: string | null, company?: string | null, phone?: string | null, use_case?: string | null, email?: string | null, familiarity_with_kgs?: string | null, best_describes_role?: string | null, industry?: string | null, best_describes_company?: string | null } | null };

export type UpdateUserFeaturesMutationVariables = Exact<{
  user_id: Scalars['ID'];
  input: UserFeaturesInput;
}>;


export type UpdateUserFeaturesMutation = { __typename?: 'Mutation', updateUserFeatures?: { __typename?: 'User', id?: string | null, is_designer_storage_enabled?: boolean | null, is_voicebox_enabled?: boolean | null, is_static_voicebox?: boolean | null, is_voicebox_api_access_enabled?: boolean | null, is_voicebox_four_enabled?: boolean | null, is_collaboration_enabled?: boolean | null } | null };

export type UpdateVoiceboxAppMutationVariables = Exact<{
  input: UpdateVoiceboxAppInput;
}>;


export type UpdateVoiceboxAppMutation = { __typename?: 'Mutation', updateVoiceboxApp?: { __typename?: 'GenericResponse', success: boolean, error?: string | null } | null };

export type UpgradeCloudMutationVariables = Exact<{
  item: CheckoutLineItem;
  connectionId: Scalars['ID'];
}>;


export type UpgradeCloudMutation = { __typename?: 'Mutation', upgradeCloud?: { __typename?: 'BillingSession', url?: string | null } | null };

export type UserPartnerConnectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserPartnerConnectionsQuery = { __typename?: 'Query', profile?: { __typename?: 'User', first_name?: string | null, last_name?: string | null, email?: string | null, username: string } | null, userPartnerConnections?: Array<{ __typename?: 'PartnerConnectionDetail', databricks_workspace_id?: string | null, jdbc_url?: string | null, workspace_url?: string | null, user_email?: string | null, connection_id?: string | null, user_first_name?: string | null, is_configured_resources?: boolean | null, databricks_connection_name?: string | null, databricks_personal_token_id?: string | null, http_path?: string | null, cluster_id?: string | null, stardog_server_connection?: { __typename?: 'Connection', name: string, id: string, isStardogCloud?: boolean | null, index: number, endpoint: string } | null } | null> | null };

export type VerifyInvitationMutationVariables = Exact<{
  input: InvitationFlagInput;
}>;


export type VerifyInvitationMutation = { __typename?: 'Mutation', verifyInvitation?: { __typename?: 'GenericResponse', success: boolean, error?: string | null } | null };


export const AcceptInvitationDocument = `
    mutation acceptInvitation($input: InvitationFlagInput!) {
  acceptInvitation(input: $input) {
    success
    error
  }
}
    `;
export const useAcceptInvitationMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AcceptInvitationMutation, TError, AcceptInvitationMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AcceptInvitationMutation, TError, AcceptInvitationMutationVariables, TContext>(
      ['acceptInvitation'],
      (variables?: AcceptInvitationMutationVariables) => fetcher<AcceptInvitationMutation, AcceptInvitationMutationVariables>(client, AcceptInvitationDocument, variables, headers)(),
      options
    );
export const AddCloudInvitationDocument = `
    mutation addCloudInvitation($input: CloudInvitationInput!) {
  addCloudInvitation(input: $input) {
    success
    error
  }
}
    `;
export const useAddCloudInvitationMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddCloudInvitationMutation, TError, AddCloudInvitationMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddCloudInvitationMutation, TError, AddCloudInvitationMutationVariables, TContext>(
      ['addCloudInvitation'],
      (variables?: AddCloudInvitationMutationVariables) => fetcher<AddCloudInvitationMutation, AddCloudInvitationMutationVariables>(client, AddCloudInvitationDocument, variables, headers)(),
      options
    );
export const AddConnectionInvitationsDocument = `
    mutation addConnectionInvitations($input: ConnectionInvitationsInput!) {
  addConnectionInvitations(input: $input) {
    results {
      email
      success
      error
    }
    error
  }
}
    `;
export const useAddConnectionInvitationsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddConnectionInvitationsMutation, TError, AddConnectionInvitationsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddConnectionInvitationsMutation, TError, AddConnectionInvitationsMutationVariables, TContext>(
      ['addConnectionInvitations'],
      (variables?: AddConnectionInvitationsMutationVariables) => fetcher<AddConnectionInvitationsMutation, AddConnectionInvitationsMutationVariables>(client, AddConnectionInvitationsDocument, variables, headers)(),
      options
    );
export const AddConnectionDocument = `
    mutation addConnection($input: AddConnectionInput!) {
  addConnection(input: $input) {
    id
    index
    name
    endpoint
    internalEndpoint
    username
    token
    useBrowserAuth
    useSSO
  }
}
    `;
export const useAddConnectionMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddConnectionMutation, TError, AddConnectionMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddConnectionMutation, TError, AddConnectionMutationVariables, TContext>(
      ['addConnection'],
      (variables?: AddConnectionMutationVariables) => fetcher<AddConnectionMutation, AddConnectionMutationVariables>(client, AddConnectionDocument, variables, headers)(),
      options
    );
export const AddMyOrganizationConnectionDocument = `
    mutation addMyOrganizationConnection($input: AddMyOrgConnectionInput!) {
  addMyOrganizationConnection(input: $input) {
    id
    index
    name
    endpoint
    internalEndpoint
    username
    token
    useBrowserAuth
    useSSO
  }
}
    `;
export const useAddMyOrganizationConnectionMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddMyOrganizationConnectionMutation, TError, AddMyOrganizationConnectionMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddMyOrganizationConnectionMutation, TError, AddMyOrganizationConnectionMutationVariables, TContext>(
      ['addMyOrganizationConnection'],
      (variables?: AddMyOrganizationConnectionMutationVariables) => fetcher<AddMyOrganizationConnectionMutation, AddMyOrganizationConnectionMutationVariables>(client, AddMyOrganizationConnectionDocument, variables, headers)(),
      options
    );
export const AddOrganizationInvitationsDocument = `
    mutation addOrganizationInvitations($input: OrganizationInvitationsInput!) {
  addOrganizationInvitations(input: $input) {
    results {
      email
      success
      error
    }
    error
  }
}
    `;
export const useAddOrganizationInvitationsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddOrganizationInvitationsMutation, TError, AddOrganizationInvitationsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddOrganizationInvitationsMutation, TError, AddOrganizationInvitationsMutationVariables, TContext>(
      ['addOrganizationInvitations'],
      (variables?: AddOrganizationInvitationsMutationVariables) => fetcher<AddOrganizationInvitationsMutation, AddOrganizationInvitationsMutationVariables>(client, AddOrganizationInvitationsDocument, variables, headers)(),
      options
    );
export const AddOrganizationDocument = `
    mutation addOrganization($input: AddOrganizationInput!) {
  addOrganization(input: $input) {
    organization {
      id
      name
      description
      domain
      role
    }
    invitationResults {
      email
      success
      error
    }
  }
}
    `;
export const useAddOrganizationMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddOrganizationMutation, TError, AddOrganizationMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddOrganizationMutation, TError, AddOrganizationMutationVariables, TContext>(
      ['addOrganization'],
      (variables?: AddOrganizationMutationVariables) => fetcher<AddOrganizationMutation, AddOrganizationMutationVariables>(client, AddOrganizationDocument, variables, headers)(),
      options
    );
export const AddSsoConnectionDocument = `
    mutation addSSOConnection($input: AddSSOConnectionInput!) {
  addSSOConnection(input: $input) {
    redirect_url
  }
}
    `;
export const useAddSsoConnectionMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<AddSsoConnectionMutation, TError, AddSsoConnectionMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<AddSsoConnectionMutation, TError, AddSsoConnectionMutationVariables, TContext>(
      ['addSSOConnection'],
      (variables?: AddSsoConnectionMutationVariables) => fetcher<AddSsoConnectionMutation, AddSsoConnectionMutationVariables>(client, AddSsoConnectionDocument, variables, headers)(),
      options
    );
export const CancelCloudDocument = `
    mutation cancelCloud($input: CancelCloudInput!) {
  cancelCloud(input: $input) {
    success
    error
  }
}
    `;
export const useCancelCloudMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CancelCloudMutation, TError, CancelCloudMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CancelCloudMutation, TError, CancelCloudMutationVariables, TContext>(
      ['cancelCloud'],
      (variables?: CancelCloudMutationVariables) => fetcher<CancelCloudMutation, CancelCloudMutationVariables>(client, CancelCloudDocument, variables, headers)(),
      options
    );
export const CheckoutCartDocument = `
    mutation checkoutCart($item: CheckoutLineItem!, $addOns: [CheckoutLineItem]) {
  checkoutCart(item: $item, addOns: $addOns) {
    url
  }
}
    `;
export const useCheckoutCartMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CheckoutCartMutation, TError, CheckoutCartMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CheckoutCartMutation, TError, CheckoutCartMutationVariables, TContext>(
      ['checkoutCart'],
      (variables?: CheckoutCartMutationVariables) => fetcher<CheckoutCartMutation, CheckoutCartMutationVariables>(client, CheckoutCartDocument, variables, headers)(),
      options
    );
export const CreateApiTokenDocument = `
    mutation createApiToken($input: CreateApiTokenInput!) {
  createApiToken(input: $input) {
    secret
  }
}
    `;
export const useCreateApiTokenMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateApiTokenMutation, TError, CreateApiTokenMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateApiTokenMutation, TError, CreateApiTokenMutationVariables, TContext>(
      ['createApiToken'],
      (variables?: CreateApiTokenMutationVariables) => fetcher<CreateApiTokenMutation, CreateApiTokenMutationVariables>(client, CreateApiTokenDocument, variables, headers)(),
      options
    );
export const CreateOrganizationMicrosoftEntraSsoConfigDocument = `
    mutation createOrganizationMicrosoftEntraSSOConfig($domain: String!, $input: CreateOrganizationMicrosoftEntraSSOConfigInput!) {
  createOrganizationMicrosoftEntraSSOConfig(domain: $domain, input: $input) {
    id
    providerType
    discoveryUrl
    clientId
    hasClientSecret
    isEnabled
    idpLogoutEnabled
    loginUrl
    redirectUri
    postLogoutRedirectUri
    createdAt
    updatedAt
  }
}
    `;
export const useCreateOrganizationMicrosoftEntraSsoConfigMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateOrganizationMicrosoftEntraSsoConfigMutation, TError, CreateOrganizationMicrosoftEntraSsoConfigMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateOrganizationMicrosoftEntraSsoConfigMutation, TError, CreateOrganizationMicrosoftEntraSsoConfigMutationVariables, TContext>(
      ['createOrganizationMicrosoftEntraSSOConfig'],
      (variables?: CreateOrganizationMicrosoftEntraSsoConfigMutationVariables) => fetcher<CreateOrganizationMicrosoftEntraSsoConfigMutation, CreateOrganizationMicrosoftEntraSsoConfigMutationVariables>(client, CreateOrganizationMicrosoftEntraSsoConfigDocument, variables, headers)(),
      options
    );
export const CreateOrganizationOktaSsoConfigDocument = `
    mutation createOrganizationOktaSSOConfig($domain: String!, $input: CreateOrganizationOktaSSOConfigInput!) {
  createOrganizationOktaSSOConfig(domain: $domain, input: $input) {
    id
    providerType
    discoveryUrl
    clientId
    hasClientSecret
    isEnabled
    idpLogoutEnabled
    loginUrl
    redirectUri
    postLogoutRedirectUri
    oktaAuthorizationServerAudience
    oktaBackendClientId
    hasOktaBackendClientSecret
    createdAt
    updatedAt
  }
}
    `;
export const useCreateOrganizationOktaSsoConfigMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateOrganizationOktaSsoConfigMutation, TError, CreateOrganizationOktaSsoConfigMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateOrganizationOktaSsoConfigMutation, TError, CreateOrganizationOktaSsoConfigMutationVariables, TContext>(
      ['createOrganizationOktaSSOConfig'],
      (variables?: CreateOrganizationOktaSsoConfigMutationVariables) => fetcher<CreateOrganizationOktaSsoConfigMutation, CreateOrganizationOktaSsoConfigMutationVariables>(client, CreateOrganizationOktaSsoConfigDocument, variables, headers)(),
      options
    );
export const CreateVoiceboxAppDocument = `
    mutation createVoiceboxApp($input: CreateVoiceboxAppInput!) {
  createVoiceboxApp(input: $input) {
    success
    error
  }
}
    `;
export const useCreateVoiceboxAppMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<CreateVoiceboxAppMutation, TError, CreateVoiceboxAppMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<CreateVoiceboxAppMutation, TError, CreateVoiceboxAppMutationVariables, TContext>(
      ['createVoiceboxApp'],
      (variables?: CreateVoiceboxAppMutationVariables) => fetcher<CreateVoiceboxAppMutation, CreateVoiceboxAppMutationVariables>(client, CreateVoiceboxAppDocument, variables, headers)(),
      options
    );
export const DeleteAccountDocument = `
    mutation deleteAccount {
  deleteAccount {
    success
    error
  }
}
    `;
export const useDeleteAccountMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteAccountMutation, TError, DeleteAccountMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteAccountMutation, TError, DeleteAccountMutationVariables, TContext>(
      ['deleteAccount'],
      (variables?: DeleteAccountMutationVariables) => fetcher<DeleteAccountMutation, DeleteAccountMutationVariables>(client, DeleteAccountDocument, variables, headers)(),
      options
    );
export const DeleteApiTokenDocument = `
    mutation deleteApiToken($input: DeleteApiTokenInput!) {
  deleteApiToken(input: $input) {
    success
    error
  }
}
    `;
export const useDeleteApiTokenMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteApiTokenMutation, TError, DeleteApiTokenMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteApiTokenMutation, TError, DeleteApiTokenMutationVariables, TContext>(
      ['deleteApiToken'],
      (variables?: DeleteApiTokenMutationVariables) => fetcher<DeleteApiTokenMutation, DeleteApiTokenMutationVariables>(client, DeleteApiTokenDocument, variables, headers)(),
      options
    );
export const DeleteCloudDocument = `
    mutation deleteCloud($input: CloudCleanupInput!) {
  deleteCloud(input: $input) {
    success
    error
  }
}
    `;
export const useDeleteCloudMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteCloudMutation, TError, DeleteCloudMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteCloudMutation, TError, DeleteCloudMutationVariables, TContext>(
      ['deleteCloud'],
      (variables?: DeleteCloudMutationVariables) => fetcher<DeleteCloudMutation, DeleteCloudMutationVariables>(client, DeleteCloudDocument, variables, headers)(),
      options
    );
export const DeleteConnectionDocument = `
    mutation deleteConnection($input: DeleteConnectionInput!) {
  deleteConnection(input: $input) {
    success
    error
  }
}
    `;
export const useDeleteConnectionMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteConnectionMutation, TError, DeleteConnectionMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteConnectionMutation, TError, DeleteConnectionMutationVariables, TContext>(
      ['deleteConnection'],
      (variables?: DeleteConnectionMutationVariables) => fetcher<DeleteConnectionMutation, DeleteConnectionMutationVariables>(client, DeleteConnectionDocument, variables, headers)(),
      options
    );
export const DeleteInvitationsDocument = `
    mutation deleteInvitations($ids: [ID!]!) {
  deleteInvitations(ids: $ids) {
    results {
      id
      success
      error
    }
    error
  }
}
    `;
export const useDeleteInvitationsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteInvitationsMutation, TError, DeleteInvitationsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteInvitationsMutation, TError, DeleteInvitationsMutationVariables, TContext>(
      ['deleteInvitations'],
      (variables?: DeleteInvitationsMutationVariables) => fetcher<DeleteInvitationsMutation, DeleteInvitationsMutationVariables>(client, DeleteInvitationsDocument, variables, headers)(),
      options
    );
export const DeleteMyOrganizationConnectionDocument = `
    mutation deleteMyOrganizationConnection($input: DeleteMyOrgConnectionInput!) {
  deleteMyOrganizationConnection(input: $input) {
    success
    error
  }
}
    `;
export const useDeleteMyOrganizationConnectionMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteMyOrganizationConnectionMutation, TError, DeleteMyOrganizationConnectionMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteMyOrganizationConnectionMutation, TError, DeleteMyOrganizationConnectionMutationVariables, TContext>(
      ['deleteMyOrganizationConnection'],
      (variables?: DeleteMyOrganizationConnectionMutationVariables) => fetcher<DeleteMyOrganizationConnectionMutation, DeleteMyOrganizationConnectionMutationVariables>(client, DeleteMyOrganizationConnectionDocument, variables, headers)(),
      options
    );
export const DeleteOrganizationDocument = `
    mutation deleteOrganization($org_domain: String!) {
  deleteOrganization(org_domain: $org_domain) {
    success
    error
  }
}
    `;
export const useDeleteOrganizationMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteOrganizationMutation, TError, DeleteOrganizationMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteOrganizationMutation, TError, DeleteOrganizationMutationVariables, TContext>(
      ['deleteOrganization'],
      (variables?: DeleteOrganizationMutationVariables) => fetcher<DeleteOrganizationMutation, DeleteOrganizationMutationVariables>(client, DeleteOrganizationDocument, variables, headers)(),
      options
    );
export const DeleteOrganizationSsoConfigDocument = `
    mutation deleteOrganizationSSOConfig($domain: String!) {
  deleteOrganizationSSOConfig(domain: $domain) {
    success
    error
  }
}
    `;
export const useDeleteOrganizationSsoConfigMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteOrganizationSsoConfigMutation, TError, DeleteOrganizationSsoConfigMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteOrganizationSsoConfigMutation, TError, DeleteOrganizationSsoConfigMutationVariables, TContext>(
      ['deleteOrganizationSSOConfig'],
      (variables?: DeleteOrganizationSsoConfigMutationVariables) => fetcher<DeleteOrganizationSsoConfigMutation, DeleteOrganizationSsoConfigMutationVariables>(client, DeleteOrganizationSsoConfigDocument, variables, headers)(),
      options
    );
export const DeleteVoiceboxAppDocument = `
    mutation deleteVoiceboxApp($id: ID!) {
  deleteVoiceboxApp(id: $id) {
    success
    error
  }
}
    `;
export const useDeleteVoiceboxAppMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteVoiceboxAppMutation, TError, DeleteVoiceboxAppMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteVoiceboxAppMutation, TError, DeleteVoiceboxAppMutationVariables, TContext>(
      ['deleteVoiceboxApp'],
      (variables?: DeleteVoiceboxAppMutationVariables) => fetcher<DeleteVoiceboxAppMutation, DeleteVoiceboxAppMutationVariables>(client, DeleteVoiceboxAppDocument, variables, headers)(),
      options
    );
export const DeleteVoiceboxConversationDocument = `
    mutation deleteVoiceboxConversation($conversation_id: ID!) {
  deleteVoiceboxConversation(conversation_id: $conversation_id) {
    success
    error
  }
}
    `;
export const useDeleteVoiceboxConversationMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<DeleteVoiceboxConversationMutation, TError, DeleteVoiceboxConversationMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<DeleteVoiceboxConversationMutation, TError, DeleteVoiceboxConversationMutationVariables, TContext>(
      ['deleteVoiceboxConversation'],
      (variables?: DeleteVoiceboxConversationMutationVariables) => fetcher<DeleteVoiceboxConversationMutation, DeleteVoiceboxConversationMutationVariables>(client, DeleteVoiceboxConversationDocument, variables, headers)(),
      options
    );
export const EditConnectionDocument = `
    mutation editConnection($input: EditConnectionInput!) {
  editConnection(input: $input) {
    id
    index
    name
    endpoint
    internalEndpoint
    username
    token
    useBrowserAuth
    useSSO
    ssoTokenExchangeScope
    usesOrgSso
  }
}
    `;
export const useEditConnectionMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<EditConnectionMutation, TError, EditConnectionMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<EditConnectionMutation, TError, EditConnectionMutationVariables, TContext>(
      ['editConnection'],
      (variables?: EditConnectionMutationVariables) => fetcher<EditConnectionMutation, EditConnectionMutationVariables>(client, EditConnectionDocument, variables, headers)(),
      options
    );
export const EditMyOrganizationConnectionDocument = `
    mutation editMyOrganizationConnection($input: EditMyOrgConnectionInput!) {
  editMyOrganizationConnection(input: $input) {
    id
    index
    name
    endpoint
    internalEndpoint
    username
    token
    useBrowserAuth
    useSSO
  }
}
    `;
export const useEditMyOrganizationConnectionMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<EditMyOrganizationConnectionMutation, TError, EditMyOrganizationConnectionMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<EditMyOrganizationConnectionMutation, TError, EditMyOrganizationConnectionMutationVariables, TContext>(
      ['editMyOrganizationConnection'],
      (variables?: EditMyOrganizationConnectionMutationVariables) => fetcher<EditMyOrganizationConnectionMutation, EditMyOrganizationConnectionMutationVariables>(client, EditMyOrganizationConnectionDocument, variables, headers)(),
      options
    );
export const EditOrganizationDocument = `
    mutation editOrganization($org_domain: String!, $input: EditOrganizationInput!) {
  editOrganization(org_domain: $org_domain, input: $input) {
    id
    name
    description
    domain
    role
  }
}
    `;
export const useEditOrganizationMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<EditOrganizationMutation, TError, EditOrganizationMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<EditOrganizationMutation, TError, EditOrganizationMutationVariables, TContext>(
      ['editOrganization'],
      (variables?: EditOrganizationMutationVariables) => fetcher<EditOrganizationMutation, EditOrganizationMutationVariables>(client, EditOrganizationDocument, variables, headers)(),
      options
    );
export const EditVoiceboxConversationDocument = `
    mutation editVoiceboxConversation($input: EditVoiceboxConversationInput!) {
  editVoiceboxConversation(input: $input) {
    success
    error
  }
}
    `;
export const useEditVoiceboxConversationMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<EditVoiceboxConversationMutation, TError, EditVoiceboxConversationMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<EditVoiceboxConversationMutation, TError, EditVoiceboxConversationMutationVariables, TContext>(
      ['editVoiceboxConversation'],
      (variables?: EditVoiceboxConversationMutationVariables) => fetcher<EditVoiceboxConversationMutation, EditVoiceboxConversationMutationVariables>(client, EditVoiceboxConversationDocument, variables, headers)(),
      options
    );
export const GenerateConfigurationDocument = `
    mutation generateConfiguration($endpoint: String!) {
  generateConfiguration(endpoint: $endpoint) {
    id
    jwt_config
    properties
  }
}
    `;
export const useGenerateConfigurationMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<GenerateConfigurationMutation, TError, GenerateConfigurationMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<GenerateConfigurationMutation, TError, GenerateConfigurationMutationVariables, TContext>(
      ['generateConfiguration'],
      (variables?: GenerateConfigurationMutationVariables) => fetcher<GenerateConfigurationMutation, GenerateConfigurationMutationVariables>(client, GenerateConfigurationDocument, variables, headers)(),
      options
    );
export const GenerateConnectionTokenDocument = `
    query generateConnectionToken($connectionId: ID!, $forceRefresh: Boolean) {
  generateConnectionToken(
    connectionId: $connectionId
    forceRefresh: $forceRefresh
  ) {
    access_token
    user {
      username
    }
  }
}
    `;
export const useGenerateConnectionTokenQuery = <
      TData = GenerateConnectionTokenQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GenerateConnectionTokenQueryVariables,
      options?: UseQueryOptions<GenerateConnectionTokenQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GenerateConnectionTokenQuery, TError, TData>(
      ['generateConnectionToken', variables],
      fetcher<GenerateConnectionTokenQuery, GenerateConnectionTokenQueryVariables>(client, GenerateConnectionTokenDocument, variables, headers),
      options
    );
useGenerateConnectionTokenQuery.document = GenerateConnectionTokenDocument;


useGenerateConnectionTokenQuery.getKey = (variables: GenerateConnectionTokenQueryVariables) => ['generateConnectionToken', variables];
;

export const GenerateTokenDocument = `
    query generateToken($endpoint: String!) {
  generateToken(endpoint: $endpoint) {
    access_token
    user {
      username
    }
  }
}
    `;
export const useGenerateTokenQuery = <
      TData = GenerateTokenQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GenerateTokenQueryVariables,
      options?: UseQueryOptions<GenerateTokenQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GenerateTokenQuery, TError, TData>(
      ['generateToken', variables],
      fetcher<GenerateTokenQuery, GenerateTokenQueryVariables>(client, GenerateTokenDocument, variables, headers),
      options
    );
useGenerateTokenQuery.document = GenerateTokenDocument;


useGenerateTokenQuery.getKey = (variables: GenerateTokenQueryVariables) => ['generateToken', variables];
;

export const GenerateVoiceboxResponseReportDocument = `
    query generateVoiceboxResponseReport($input: GenerateVoiceboxResponseReportInput!) {
  generateVoiceboxResponseReport(input: $input) {
    filename
    csv
  }
}
    `;
export const useGenerateVoiceboxResponseReportQuery = <
      TData = GenerateVoiceboxResponseReportQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GenerateVoiceboxResponseReportQueryVariables,
      options?: UseQueryOptions<GenerateVoiceboxResponseReportQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GenerateVoiceboxResponseReportQuery, TError, TData>(
      ['generateVoiceboxResponseReport', variables],
      fetcher<GenerateVoiceboxResponseReportQuery, GenerateVoiceboxResponseReportQueryVariables>(client, GenerateVoiceboxResponseReportDocument, variables, headers),
      options
    );
useGenerateVoiceboxResponseReportQuery.document = GenerateVoiceboxResponseReportDocument;


useGenerateVoiceboxResponseReportQuery.getKey = (variables: GenerateVoiceboxResponseReportQueryVariables) => ['generateVoiceboxResponseReport', variables];
;

export const GetCloudConnectionMovePreviewDocument = `
    query getCloudConnectionMovePreview($cloud_id: ID!) {
  getCloudConnectionMovePreview(cloud_id: $cloud_id) {
    eligible
    ineligible_reason
    other_connections
    access {
      email
      accepted
      owns_separate_connection
      is_cloud_owner
    }
  }
}
    `;
export const useGetCloudConnectionMovePreviewQuery = <
      TData = GetCloudConnectionMovePreviewQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetCloudConnectionMovePreviewQueryVariables,
      options?: UseQueryOptions<GetCloudConnectionMovePreviewQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetCloudConnectionMovePreviewQuery, TError, TData>(
      ['getCloudConnectionMovePreview', variables],
      fetcher<GetCloudConnectionMovePreviewQuery, GetCloudConnectionMovePreviewQueryVariables>(client, GetCloudConnectionMovePreviewDocument, variables, headers),
      options
    );
useGetCloudConnectionMovePreviewQuery.document = GetCloudConnectionMovePreviewDocument;


useGetCloudConnectionMovePreviewQuery.getKey = (variables: GetCloudConnectionMovePreviewQueryVariables) => ['getCloudConnectionMovePreview', variables];
;

export const GetCloudReportDocument = `
    query getCloudReport($filters: CloudFilters) {
  getCloudReport(filters: $filters) {
    clouds {
      id
      name
      status
      endpoint
      created
      connection_in_personal_org
      move_available
      cleanup_available
      transfer_available
      flavor {
        name
      }
      owner {
        username
        last_login
      }
      validation
    }
    stats {
      totalAllocated
      totalInactive
      resultCount
      resultInactiveCount
    }
    queueCounts {
      micro_count
      small_vbx_count
      medium_count
    }
  }
}
    `;
export const useGetCloudReportQuery = <
      TData = GetCloudReportQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetCloudReportQueryVariables,
      options?: UseQueryOptions<GetCloudReportQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetCloudReportQuery, TError, TData>(
      variables === undefined ? ['getCloudReport'] : ['getCloudReport', variables],
      fetcher<GetCloudReportQuery, GetCloudReportQueryVariables>(client, GetCloudReportDocument, variables, headers),
      options
    );
useGetCloudReportQuery.document = GetCloudReportDocument;


useGetCloudReportQuery.getKey = (variables?: GetCloudReportQueryVariables) => variables === undefined ? ['getCloudReport'] : ['getCloudReport', variables];
;

export const GetCloudSduLifetimeDocument = `
    query getCloudSduLifetime($cloud_ids: [ID!]!) {
  getCloudSduLifetime(cloud_ids: $cloud_ids) {
    cloudId
    totalUnitsConsumed
    status
  }
}
    `;
export const useGetCloudSduLifetimeQuery = <
      TData = GetCloudSduLifetimeQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetCloudSduLifetimeQueryVariables,
      options?: UseQueryOptions<GetCloudSduLifetimeQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetCloudSduLifetimeQuery, TError, TData>(
      ['getCloudSduLifetime', variables],
      fetcher<GetCloudSduLifetimeQuery, GetCloudSduLifetimeQueryVariables>(client, GetCloudSduLifetimeDocument, variables, headers),
      options
    );
useGetCloudSduLifetimeQuery.document = GetCloudSduLifetimeDocument;


useGetCloudSduLifetimeQuery.getKey = (variables: GetCloudSduLifetimeQueryVariables) => ['getCloudSduLifetime', variables];
;

export const GetCloudSduUsageDocument = `
    query getCloudSduUsage($cloud_id: ID!) {
  getCloudSduUsage(cloud_id: $cloud_id) {
    date
    totalUnitsConsumed
  }
}
    `;
export const useGetCloudSduUsageQuery = <
      TData = GetCloudSduUsageQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetCloudSduUsageQueryVariables,
      options?: UseQueryOptions<GetCloudSduUsageQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetCloudSduUsageQuery, TError, TData>(
      ['getCloudSduUsage', variables],
      fetcher<GetCloudSduUsageQuery, GetCloudSduUsageQueryVariables>(client, GetCloudSduUsageDocument, variables, headers),
      options
    );
useGetCloudSduUsageQuery.document = GetCloudSduUsageDocument;


useGetCloudSduUsageQuery.getKey = (variables: GetCloudSduUsageQueryVariables) => ['getCloudSduUsage', variables];
;

export const GetCloudTransferPreviewDocument = `
    query getCloudTransferPreview($cloud_id: ID!) {
  getCloudTransferPreview(cloud_id: $cloud_id) {
    connection_name
    endpoint
    eligible
    ineligible_reason
    other_connections
    carried_access {
      email
      stardog_roles
      accepted
    }
    other_access {
      email
      stardog_roles
      accepted
    }
  }
}
    `;
export const useGetCloudTransferPreviewQuery = <
      TData = GetCloudTransferPreviewQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetCloudTransferPreviewQueryVariables,
      options?: UseQueryOptions<GetCloudTransferPreviewQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetCloudTransferPreviewQuery, TError, TData>(
      ['getCloudTransferPreview', variables],
      fetcher<GetCloudTransferPreviewQuery, GetCloudTransferPreviewQueryVariables>(client, GetCloudTransferPreviewDocument, variables, headers),
      options
    );
useGetCloudTransferPreviewQuery.document = GetCloudTransferPreviewDocument;


useGetCloudTransferPreviewQuery.getKey = (variables: GetCloudTransferPreviewQueryVariables) => ['getCloudTransferPreview', variables];
;

export const GetCloudTransferTargetDocument = `
    query getCloudTransferTarget($cloud_id: ID!, $email: String!) {
  getCloudTransferTarget(cloud_id: $cloud_id, email: $email) {
    user_exists
    candidates {
      connection_id
      connection_name
    }
  }
}
    `;
export const useGetCloudTransferTargetQuery = <
      TData = GetCloudTransferTargetQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetCloudTransferTargetQueryVariables,
      options?: UseQueryOptions<GetCloudTransferTargetQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetCloudTransferTargetQuery, TError, TData>(
      ['getCloudTransferTarget', variables],
      fetcher<GetCloudTransferTargetQuery, GetCloudTransferTargetQueryVariables>(client, GetCloudTransferTargetDocument, variables, headers),
      options
    );
useGetCloudTransferTargetQuery.document = GetCloudTransferTargetDocument;


useGetCloudTransferTargetQuery.getKey = (variables: GetCloudTransferTargetQueryVariables) => ['getCloudTransferTarget', variables];
;

export const GetConnectionByIdDocument = `
    query getConnectionById($id: String!, $org_domain: String) {
  connection: getConnectionById(id: $id, org_domain: $org_domain) {
    id
    index
    name
    endpoint
  }
}
    `;
export const useGetConnectionByIdQuery = <
      TData = GetConnectionByIdQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetConnectionByIdQueryVariables,
      options?: UseQueryOptions<GetConnectionByIdQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetConnectionByIdQuery, TError, TData>(
      ['getConnectionById', variables],
      fetcher<GetConnectionByIdQuery, GetConnectionByIdQueryVariables>(client, GetConnectionByIdDocument, variables, headers),
      options
    );
useGetConnectionByIdQuery.document = GetConnectionByIdDocument;


useGetConnectionByIdQuery.getKey = (variables: GetConnectionByIdQueryVariables) => ['getConnectionById', variables];
;

export const GetConnectionByIndexDocument = `
    query getConnectionByIndex($index: Int!, $org_domain: String) {
  connection: getConnectionByIndex(index: $index, org_domain: $org_domain) {
    id
    index
    name
    cloud {
      id
      flavor {
        name
      }
      owner {
        id
        email
        username
      }
    }
    endpoint
    internalEndpoint
    username
    token
    useBrowserAuth
    useSSO
    useConnectionSSO
    ssoTokenExchangeScope
    usesOrgSso
    access {
      id
      user {
        id
        username
      }
      organization {
        id
        name
        orgType
      }
      stardog_roles
      organization_is_enabled
      user_is_private
    }
    organization {
      id
      name
      orgType
      owner {
        id
        first_name
        last_name
        username
      }
    }
    isStardogFree
    isStardogCloud
    isAllocating
    shouldShowDesigner
    stripeSubscription {
      url
      status
      isWaitingForPayment
    }
    stripeSubscriptionOrder {
      payment_system
      trial_days_remaining
      trial_days_total
    }
    ssoProvider {
      isValid
      clientId
      providerName
      providerType
    }
  }
}
    `;
export const useGetConnectionByIndexQuery = <
      TData = GetConnectionByIndexQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetConnectionByIndexQueryVariables,
      options?: UseQueryOptions<GetConnectionByIndexQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetConnectionByIndexQuery, TError, TData>(
      ['getConnectionByIndex', variables],
      fetcher<GetConnectionByIndexQuery, GetConnectionByIndexQueryVariables>(client, GetConnectionByIndexDocument, variables, headers),
      options
    );
useGetConnectionByIndexQuery.document = GetConnectionByIndexDocument;


useGetConnectionByIndexQuery.getKey = (variables: GetConnectionByIndexQueryVariables) => ['getConnectionByIndex', variables];
;

export const GetCustomerSsoSettingsDocument = `
    query getCustomerSsoSettings {
  customerSsoSettings {
    azureProviders {
      customerName
    }
    pingProviders {
      customerName
    }
    oktaProviders {
      customerName
    }
  }
}
    `;
export const useGetCustomerSsoSettingsQuery = <
      TData = GetCustomerSsoSettingsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetCustomerSsoSettingsQueryVariables,
      options?: UseQueryOptions<GetCustomerSsoSettingsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetCustomerSsoSettingsQuery, TError, TData>(
      variables === undefined ? ['getCustomerSsoSettings'] : ['getCustomerSsoSettings', variables],
      fetcher<GetCustomerSsoSettingsQuery, GetCustomerSsoSettingsQueryVariables>(client, GetCustomerSsoSettingsDocument, variables, headers),
      options
    );
useGetCustomerSsoSettingsQuery.document = GetCustomerSsoSettingsDocument;


useGetCustomerSsoSettingsQuery.getKey = (variables?: GetCustomerSsoSettingsQueryVariables) => variables === undefined ? ['getCustomerSsoSettings'] : ['getCustomerSsoSettings', variables];
;

export const GetInvitationDocument = `
    query getInvitation($id: ID!) {
  getInvitation(id: $id) {
    id
    email
    endpoint
    connection {
      id
      name
      endpoint
    }
    organization {
      id
      name
      domain
    }
    created
    expires
    accepted
    sender {
      email
      first_name
      last_name
    }
    existing_user {
      email
      first_name
      last_name
    }
  }
}
    `;
export const useGetInvitationQuery = <
      TData = GetInvitationQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetInvitationQueryVariables,
      options?: UseQueryOptions<GetInvitationQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetInvitationQuery, TError, TData>(
      ['getInvitation', variables],
      fetcher<GetInvitationQuery, GetInvitationQueryVariables>(client, GetInvitationDocument, variables, headers),
      options
    );
useGetInvitationQuery.document = GetInvitationDocument;


useGetInvitationQuery.getKey = (variables: GetInvitationQueryVariables) => ['getInvitation', variables];
;

export const MarketplaceSettingsDocument = `
    query marketplaceSettings {
  marketplaceSettings {
    marketplaceUsername
    marketplacePassword
    marketplaceEndpoint
    marketplaceDatabase
  }
}
    `;
export const useMarketplaceSettingsQuery = <
      TData = MarketplaceSettingsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: MarketplaceSettingsQueryVariables,
      options?: UseQueryOptions<MarketplaceSettingsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<MarketplaceSettingsQuery, TError, TData>(
      variables === undefined ? ['marketplaceSettings'] : ['marketplaceSettings', variables],
      fetcher<MarketplaceSettingsQuery, MarketplaceSettingsQueryVariables>(client, MarketplaceSettingsDocument, variables, headers),
      options
    );
useMarketplaceSettingsQuery.document = MarketplaceSettingsDocument;


useMarketplaceSettingsQuery.getKey = (variables?: MarketplaceSettingsQueryVariables) => variables === undefined ? ['marketplaceSettings'] : ['marketplaceSettings', variables];
;

export const GetOrgConnectionCleanupPreviewDocument = `
    query getOrgConnectionCleanupPreview($cloud_id: ID!) {
  getOrgConnectionCleanupPreview(cloud_id: $cloud_id) {
    connection_id
    connection_name
    endpoint
    org_name
    org_domain
    is_org_connection
    orphaned {
      connection_id
      connection_name
      owner_email
      stardog_roles
      is_org_member
      has_org_access
    }
    org_members_without_access
  }
}
    `;
export const useGetOrgConnectionCleanupPreviewQuery = <
      TData = GetOrgConnectionCleanupPreviewQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetOrgConnectionCleanupPreviewQueryVariables,
      options?: UseQueryOptions<GetOrgConnectionCleanupPreviewQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetOrgConnectionCleanupPreviewQuery, TError, TData>(
      ['getOrgConnectionCleanupPreview', variables],
      fetcher<GetOrgConnectionCleanupPreviewQuery, GetOrgConnectionCleanupPreviewQueryVariables>(client, GetOrgConnectionCleanupPreviewDocument, variables, headers),
      options
    );
useGetOrgConnectionCleanupPreviewQuery.document = GetOrgConnectionCleanupPreviewDocument;


useGetOrgConnectionCleanupPreviewQuery.getKey = (variables: GetOrgConnectionCleanupPreviewQueryVariables) => ['getOrgConnectionCleanupPreview', variables];
;

export const GetOrganizationDocument = `
    query getOrganization($org_domain: String) {
  getOrganization(org_domain: $org_domain) {
    id
    name
    description
    domain
    role
    membersHiddenFromMembers
    isSsoAllowed
    ssoConfig {
      ... on OrganizationOktaSSOConfig {
        id
        providerType
        discoveryUrl
        clientId
        hasClientSecret
        isEnabled
        idpLogoutEnabled
        loginUrl
        redirectUri
        postLogoutRedirectUri
        oktaAuthorizationServerAudience
        oktaBackendClientId
        hasOktaBackendClientSecret
        createdAt
        updatedAt
      }
      ... on OrganizationMicrosoftEntraSSOConfig {
        id
        providerType
        discoveryUrl
        clientId
        hasClientSecret
        isEnabled
        idpLogoutEnabled
        loginUrl
        redirectUri
        postLogoutRedirectUri
        createdAt
        updatedAt
      }
    }
    ssoIdentity {
      isLinked
      idpSubject
      linkedAt
    }
  }
}
    `;
export const useGetOrganizationQuery = <
      TData = GetOrganizationQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetOrganizationQueryVariables,
      options?: UseQueryOptions<GetOrganizationQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetOrganizationQuery, TError, TData>(
      variables === undefined ? ['getOrganization'] : ['getOrganization', variables],
      fetcher<GetOrganizationQuery, GetOrganizationQueryVariables>(client, GetOrganizationDocument, variables, headers),
      options
    );
useGetOrganizationQuery.document = GetOrganizationDocument;


useGetOrganizationQuery.getKey = (variables?: GetOrganizationQueryVariables) => variables === undefined ? ['getOrganization'] : ['getOrganization', variables];
;

export const GetOrganizationInvitationsDocument = `
    query getOrganizationInvitations($org_domain: String) {
  getOrganizationInvitations(org_domain: $org_domain) {
    id
    email
    organization_role
    created
    expired
    accepted
  }
}
    `;
export const useGetOrganizationInvitationsQuery = <
      TData = GetOrganizationInvitationsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetOrganizationInvitationsQueryVariables,
      options?: UseQueryOptions<GetOrganizationInvitationsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetOrganizationInvitationsQuery, TError, TData>(
      variables === undefined ? ['getOrganizationInvitations'] : ['getOrganizationInvitations', variables],
      fetcher<GetOrganizationInvitationsQuery, GetOrganizationInvitationsQueryVariables>(client, GetOrganizationInvitationsDocument, variables, headers),
      options
    );
useGetOrganizationInvitationsQuery.document = GetOrganizationInvitationsDocument;


useGetOrganizationInvitationsQuery.getKey = (variables?: GetOrganizationInvitationsQueryVariables) => variables === undefined ? ['getOrganizationInvitations'] : ['getOrganizationInvitations', variables];
;

export const GetOrganizationMembersDocument = `
    query getOrganizationMembers($org_domain: String) {
  getOrganizationMembers(org_domain: $org_domain) {
    user {
      id
      email
      first_name
      last_name
    }
    role
  }
}
    `;
export const useGetOrganizationMembersQuery = <
      TData = GetOrganizationMembersQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetOrganizationMembersQueryVariables,
      options?: UseQueryOptions<GetOrganizationMembersQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetOrganizationMembersQuery, TError, TData>(
      variables === undefined ? ['getOrganizationMembers'] : ['getOrganizationMembers', variables],
      fetcher<GetOrganizationMembersQuery, GetOrganizationMembersQueryVariables>(client, GetOrganizationMembersDocument, variables, headers),
      options
    );
useGetOrganizationMembersQuery.document = GetOrganizationMembersDocument;


useGetOrganizationMembersQuery.getKey = (variables?: GetOrganizationMembersQueryVariables) => variables === undefined ? ['getOrganizationMembers'] : ['getOrganizationMembers', variables];
;

export const GetOrganizationMoveTargetDocument = `
    query getOrganizationMoveTarget($domain: String!) {
  getOrganizationMoveTarget(domain: $domain) {
    valid
    members {
      email
      role
    }
  }
}
    `;
export const useGetOrganizationMoveTargetQuery = <
      TData = GetOrganizationMoveTargetQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetOrganizationMoveTargetQueryVariables,
      options?: UseQueryOptions<GetOrganizationMoveTargetQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetOrganizationMoveTargetQuery, TError, TData>(
      ['getOrganizationMoveTarget', variables],
      fetcher<GetOrganizationMoveTargetQuery, GetOrganizationMoveTargetQueryVariables>(client, GetOrganizationMoveTargetDocument, variables, headers),
      options
    );
useGetOrganizationMoveTargetQuery.document = GetOrganizationMoveTargetDocument;


useGetOrganizationMoveTargetQuery.getKey = (variables: GetOrganizationMoveTargetQueryVariables) => ['getOrganizationMoveTarget', variables];
;

export const GetProductsDocument = `
    query getProducts {
  getStripePrices {
    id
    nickname
    amount
    stardog_billing_type
    product_info {
      name
      description
      metadata {
        flavor
      }
    }
  }
  checkCloudQueue {
    small_count
    medium_count
    micro_count
  }
  profile {
    has_stardog_free
    is_staff
    is_blocked_email
    stripe_customer {
      cloud_quota {
        total
        available
      }
      is_cloud_quota_breached
    }
  }
}
    `;
export const useGetProductsQuery = <
      TData = GetProductsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetProductsQueryVariables,
      options?: UseQueryOptions<GetProductsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetProductsQuery, TError, TData>(
      variables === undefined ? ['getProducts'] : ['getProducts', variables],
      fetcher<GetProductsQuery, GetProductsQueryVariables>(client, GetProductsDocument, variables, headers),
      options
    );
useGetProductsQuery.document = GetProductsDocument;


useGetProductsQuery.getKey = (variables?: GetProductsQueryVariables) => variables === undefined ? ['getProducts'] : ['getProducts', variables];
;

export const GetSsoConnectionRegistryDocument = `
    query getSSOConnectionRegistry {
  getSSOConnectionRegistry {
    display_provider_name
    provider_name
    stardog_endpoint
    stardog_internal_endpoint
  }
}
    `;
export const useGetSsoConnectionRegistryQuery = <
      TData = GetSsoConnectionRegistryQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetSsoConnectionRegistryQueryVariables,
      options?: UseQueryOptions<GetSsoConnectionRegistryQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetSsoConnectionRegistryQuery, TError, TData>(
      variables === undefined ? ['getSSOConnectionRegistry'] : ['getSSOConnectionRegistry', variables],
      fetcher<GetSsoConnectionRegistryQuery, GetSsoConnectionRegistryQueryVariables>(client, GetSsoConnectionRegistryDocument, variables, headers),
      options
    );
useGetSsoConnectionRegistryQuery.document = GetSsoConnectionRegistryDocument;


useGetSsoConnectionRegistryQuery.getKey = (variables?: GetSsoConnectionRegistryQueryVariables) => variables === undefined ? ['getSSOConnectionRegistry'] : ['getSSOConnectionRegistry', variables];
;

export const GetShareByShortHashDocument = `
    query getShareByShortHash($shortHash: String!) {
  getShareByShortHash(shortHash: $shortHash) {
    target_path
    endpoint
    org_domain
    connection_id
    service
    last_accessed
  }
}
    `;
export const useGetShareByShortHashQuery = <
      TData = GetShareByShortHashQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetShareByShortHashQueryVariables,
      options?: UseQueryOptions<GetShareByShortHashQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetShareByShortHashQuery, TError, TData>(
      ['getShareByShortHash', variables],
      fetcher<GetShareByShortHashQuery, GetShareByShortHashQueryVariables>(client, GetShareByShortHashDocument, variables, headers),
      options
    );
useGetShareByShortHashQuery.document = GetShareByShortHashDocument;


useGetShareByShortHashQuery.getKey = (variables: GetShareByShortHashQueryVariables) => ['getShareByShortHash', variables];
;

export const GetStripeSessionUrlDocument = `
    mutation getStripeSessionUrl {
  getStripeSessionUrl {
    url
  }
}
    `;
export const useGetStripeSessionUrlMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<GetStripeSessionUrlMutation, TError, GetStripeSessionUrlMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<GetStripeSessionUrlMutation, TError, GetStripeSessionUrlMutationVariables, TContext>(
      ['getStripeSessionUrl'],
      (variables?: GetStripeSessionUrlMutationVariables) => fetcher<GetStripeSessionUrlMutation, GetStripeSessionUrlMutationVariables>(client, GetStripeSessionUrlDocument, variables, headers)(),
      options
    );
export const GetTotalUnitUsageDocument = `
    query getTotalUnitUsage($connectionId: ID, $org_domain: String) {
  getTotalUnitUsage(connectionId: $connectionId, org_domain: $org_domain) {
    totalUnitsConsumed
  }
}
    `;
export const useGetTotalUnitUsageQuery = <
      TData = GetTotalUnitUsageQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetTotalUnitUsageQueryVariables,
      options?: UseQueryOptions<GetTotalUnitUsageQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetTotalUnitUsageQuery, TError, TData>(
      variables === undefined ? ['getTotalUnitUsage'] : ['getTotalUnitUsage', variables],
      fetcher<GetTotalUnitUsageQuery, GetTotalUnitUsageQueryVariables>(client, GetTotalUnitUsageDocument, variables, headers),
      options
    );
useGetTotalUnitUsageQuery.document = GetTotalUnitUsageDocument;


useGetTotalUnitUsageQuery.getKey = (variables?: GetTotalUnitUsageQueryVariables) => variables === undefined ? ['getTotalUnitUsage'] : ['getTotalUnitUsage', variables];
;

export const GetUnitUsageDocument = `
    query getUnitUsage($connectionId: ID, $startDate: Date, $endDate: Date, $org_domain: String, $modules: [String], $timeGrain: TimeGrain) {
  getUnitUsage(
    connectionId: $connectionId
    startDate: $startDate
    endDate: $endDate
    org_domain: $org_domain
    modules: $modules
    timeGrain: $timeGrain
  ) {
    date
    year
    month
    week
    quarter
    module
    endpoint
    totalUnitsConsumed
    remarks
  }
}
    `;
export const useGetUnitUsageQuery = <
      TData = GetUnitUsageQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetUnitUsageQueryVariables,
      options?: UseQueryOptions<GetUnitUsageQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetUnitUsageQuery, TError, TData>(
      variables === undefined ? ['getUnitUsage'] : ['getUnitUsage', variables],
      fetcher<GetUnitUsageQuery, GetUnitUsageQueryVariables>(client, GetUnitUsageDocument, variables, headers),
      options
    );
useGetUnitUsageQuery.document = GetUnitUsageDocument;


useGetUnitUsageQuery.getKey = (variables?: GetUnitUsageQueryVariables) => variables === undefined ? ['getUnitUsage'] : ['getUnitUsage', variables];
;

export const GetUserCurrentPartnerConnectionDocument = `
    query getUserCurrentPartnerConnection {
  profile {
    first_name
    last_name
    email
    username
  }
  getUserCurrentPartnerConnection {
    databricks_workspace_id
    jdbc_url
    workspace_url
    user_email
    connection_id
    user_first_name
    is_configured_resources
    databricks_connection_name
    stardog_server_connection {
      name
      id
      isStardogCloud
      index
      endpoint
    }
    databricks_personal_token_id
    cluster_id
  }
}
    `;
export const useGetUserCurrentPartnerConnectionQuery = <
      TData = GetUserCurrentPartnerConnectionQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: GetUserCurrentPartnerConnectionQueryVariables,
      options?: UseQueryOptions<GetUserCurrentPartnerConnectionQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetUserCurrentPartnerConnectionQuery, TError, TData>(
      variables === undefined ? ['getUserCurrentPartnerConnection'] : ['getUserCurrentPartnerConnection', variables],
      fetcher<GetUserCurrentPartnerConnectionQuery, GetUserCurrentPartnerConnectionQueryVariables>(client, GetUserCurrentPartnerConnectionDocument, variables, headers),
      options
    );
useGetUserCurrentPartnerConnectionQuery.document = GetUserCurrentPartnerConnectionDocument;


useGetUserCurrentPartnerConnectionQuery.getKey = (variables?: GetUserCurrentPartnerConnectionQueryVariables) => variables === undefined ? ['getUserCurrentPartnerConnection'] : ['getUserCurrentPartnerConnection', variables];
;

export const GetUserInfoDocument = `
    query getUserInfo($user_id: String!) {
  getUser(user_id: $user_id) {
    company
    email
    first_name
    has_stardog_free
    id
    is_databricks_user
    is_staff
    is_designer_storage_enabled
    is_voicebox_enabled
    is_static_voicebox
    is_voicebox_api_access_enabled
    is_voicebox_think_mode_enabled
    is_voicebox_powered_suggestions_enabled
    is_voicebox_four_enabled
    is_collaboration_enabled
    is_verified
    is_authenticated
    last_login
    last_name
    phone
    title
    use_case
    date_joined
  }
  getUserConnections(user_id: $user_id) {
    id
    name
    endpoint
    useSSO
    type
  }
  getUserClouds(user_id: $user_id) {
    created
    endpoint
    flavor {
      name
    }
    id
    name
    status
    region
    updated
    payment_ref
  }
  getUserArchivedClouds(user_id: $user_id) {
    created
    endpoint
    flavor
    id
    name
    payment_ref
    region
  }
  grafanaHighLevelDashboardSettings {
    id
    slug
  }
}
    `;
export const useGetUserInfoQuery = <
      TData = GetUserInfoQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetUserInfoQueryVariables,
      options?: UseQueryOptions<GetUserInfoQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetUserInfoQuery, TError, TData>(
      ['getUserInfo', variables],
      fetcher<GetUserInfoQuery, GetUserInfoQueryVariables>(client, GetUserInfoDocument, variables, headers),
      options
    );
useGetUserInfoQuery.document = GetUserInfoDocument;


useGetUserInfoQuery.getKey = (variables: GetUserInfoQueryVariables) => ['getUserInfo', variables];
;

export const LeaveOrganizationDocument = `
    mutation leaveOrganization($org_domain: String!) {
  leaveOrganization(org_domain: $org_domain) {
    success
    error
  }
}
    `;
export const useLeaveOrganizationMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<LeaveOrganizationMutation, TError, LeaveOrganizationMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<LeaveOrganizationMutation, TError, LeaveOrganizationMutationVariables, TContext>(
      ['leaveOrganization'],
      (variables?: LeaveOrganizationMutationVariables) => fetcher<LeaveOrganizationMutation, LeaveOrganizationMutationVariables>(client, LeaveOrganizationDocument, variables, headers)(),
      options
    );
export const ListApiTokensDocument = `
    query listApiTokens($app_id: ID, $paging: PagingInput) {
  listApiTokens(app_id: $app_id, paging: $paging) {
    created
    expires
    id
    last_used
    name
  }
  apiTokenCount(app_id: $app_id) {
    count
  }
}
    `;
export const useListApiTokensQuery = <
      TData = ListApiTokensQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: ListApiTokensQueryVariables,
      options?: UseQueryOptions<ListApiTokensQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListApiTokensQuery, TError, TData>(
      variables === undefined ? ['listApiTokens'] : ['listApiTokens', variables],
      fetcher<ListApiTokensQuery, ListApiTokensQueryVariables>(client, ListApiTokensDocument, variables, headers),
      options
    );
useListApiTokensQuery.document = ListApiTokensDocument;


useListApiTokensQuery.getKey = (variables?: ListApiTokensQueryVariables) => variables === undefined ? ['listApiTokens'] : ['listApiTokens', variables];
;

export const ListConnectionUsersDocument = `
    query listConnectionUsers($id: ID!) {
  listUserConnectionAccess(id: $id) {
    id
    user {
      id
      email
      first_name
      last_name
    }
    stardog_roles
  }
  listUserConnectionInvitations(id: $id) {
    id
    email
    connection_roles
    created
    expired
    accepted
  }
}
    `;
export const useListConnectionUsersQuery = <
      TData = ListConnectionUsersQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ListConnectionUsersQueryVariables,
      options?: UseQueryOptions<ListConnectionUsersQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListConnectionUsersQuery, TError, TData>(
      ['listConnectionUsers', variables],
      fetcher<ListConnectionUsersQuery, ListConnectionUsersQueryVariables>(client, ListConnectionUsersDocument, variables, headers),
      options
    );
useListConnectionUsersQuery.document = ListConnectionUsersDocument;


useListConnectionUsersQuery.getKey = (variables: ListConnectionUsersQueryVariables) => ['listConnectionUsers', variables];
;

export const ListConnectionsByEndpointDocument = `
    query listConnectionsByEndpoint($endpoint: String!) {
  listConnectionsByEndpoint(endpoint: $endpoint) {
    id
    index
    name
    endpoint
    cloud {
      id
    }
    username
    token
    useBrowserAuth
    useSSO
    isStardogFree
    isStardogCloud
    isAllocating
    stripeSubscription {
      url
      status
      isWaitingForPayment
      isExpired
    }
  }
}
    `;
export const useListConnectionsByEndpointQuery = <
      TData = ListConnectionsByEndpointQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ListConnectionsByEndpointQueryVariables,
      options?: UseQueryOptions<ListConnectionsByEndpointQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListConnectionsByEndpointQuery, TError, TData>(
      ['listConnectionsByEndpoint', variables],
      fetcher<ListConnectionsByEndpointQuery, ListConnectionsByEndpointQueryVariables>(client, ListConnectionsByEndpointDocument, variables, headers),
      options
    );
useListConnectionsByEndpointQuery.document = ListConnectionsByEndpointDocument;


useListConnectionsByEndpointQuery.getKey = (variables: ListConnectionsByEndpointQueryVariables) => ['listConnectionsByEndpoint', variables];
;

export const ListOrganizationConnectionAccessDocument = `
    query listOrganizationConnectionAccess($id: ID!, $org_domain: String!) {
  listOrganizationConnectionAccess(id: $id, org_domain: $org_domain) {
    id
    user {
      id
      email
      first_name
      last_name
    }
    organization {
      id
      name
    }
    stardog_roles
    organization_is_enabled
    user_is_private
  }
}
    `;
export const useListOrganizationConnectionAccessQuery = <
      TData = ListOrganizationConnectionAccessQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ListOrganizationConnectionAccessQueryVariables,
      options?: UseQueryOptions<ListOrganizationConnectionAccessQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListOrganizationConnectionAccessQuery, TError, TData>(
      ['listOrganizationConnectionAccess', variables],
      fetcher<ListOrganizationConnectionAccessQuery, ListOrganizationConnectionAccessQueryVariables>(client, ListOrganizationConnectionAccessDocument, variables, headers),
      options
    );
useListOrganizationConnectionAccessQuery.document = ListOrganizationConnectionAccessDocument;


useListOrganizationConnectionAccessQuery.getKey = (variables: ListOrganizationConnectionAccessQueryVariables) => ['listOrganizationConnectionAccess', variables];
;

export const ListOrganizationConnectionsDocument = `
    query listOrganizationConnections($org_domain: String!) {
  listConnections(org_domain: $org_domain) {
    id
    index
    name
    endpoint
    username
    token
    useSSO
    ssoTokenExchangeScope
    usesOrgSso
    access {
      id
      user {
        id
        username
      }
      organization {
        id
        name
        orgType
      }
      stardog_roles
      organization_is_enabled
      user_is_private
    }
    isStardogFree
    isStardogCloud
  }
  listDefaultOrganizationConnectionsAccess(org_domain: $org_domain) {
    id
    connection {
      id
    }
    stardog_roles
  }
}
    `;
export const useListOrganizationConnectionsQuery = <
      TData = ListOrganizationConnectionsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: ListOrganizationConnectionsQueryVariables,
      options?: UseQueryOptions<ListOrganizationConnectionsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListOrganizationConnectionsQuery, TError, TData>(
      ['listOrganizationConnections', variables],
      fetcher<ListOrganizationConnectionsQuery, ListOrganizationConnectionsQueryVariables>(client, ListOrganizationConnectionsDocument, variables, headers),
      options
    );
useListOrganizationConnectionsQuery.document = ListOrganizationConnectionsDocument;


useListOrganizationConnectionsQuery.getKey = (variables: ListOrganizationConnectionsQueryVariables) => ['listOrganizationConnections', variables];
;

export const ListOrganizationsDocument = `
    query listOrganizations {
  listOrganizations {
    id
    name
    description
    domain
    role
  }
}
    `;
export const useListOrganizationsQuery = <
      TData = ListOrganizationsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: ListOrganizationsQueryVariables,
      options?: UseQueryOptions<ListOrganizationsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListOrganizationsQuery, TError, TData>(
      variables === undefined ? ['listOrganizations'] : ['listOrganizations', variables],
      fetcher<ListOrganizationsQuery, ListOrganizationsQueryVariables>(client, ListOrganizationsDocument, variables, headers),
      options
    );
useListOrganizationsQuery.document = ListOrganizationsDocument;


useListOrganizationsQuery.getKey = (variables?: ListOrganizationsQueryVariables) => variables === undefined ? ['listOrganizations'] : ['listOrganizations', variables];
;

export const ListVoiceboxAppsDocument = `
    query listVoiceboxApps {
  listVoiceboxApps {
    id
    name
    connection_id
    database
    model
    named_graphs
    reasoning
  }
}
    `;
export const useListVoiceboxAppsQuery = <
      TData = ListVoiceboxAppsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: ListVoiceboxAppsQueryVariables,
      options?: UseQueryOptions<ListVoiceboxAppsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListVoiceboxAppsQuery, TError, TData>(
      variables === undefined ? ['listVoiceboxApps'] : ['listVoiceboxApps', variables],
      fetcher<ListVoiceboxAppsQuery, ListVoiceboxAppsQueryVariables>(client, ListVoiceboxAppsDocument, variables, headers),
      options
    );
useListVoiceboxAppsQuery.document = ListVoiceboxAppsDocument;


useListVoiceboxAppsQuery.getKey = (variables?: ListVoiceboxAppsQueryVariables) => variables === undefined ? ['listVoiceboxApps'] : ['listVoiceboxApps', variables];
;

export const ListVoiceboxConversationsDocument = `
    query listVoiceboxConversations($paging: PagingInput, $filterInput: VoiceboxConversationsFilterInput) {
  listVoiceboxConversations(paging: $paging, filterInput: $filterInput) {
    id
    name
    created
    number_user_messages
    first_user_message {
      content
      user_message_context {
        app
      }
    }
    last_user_message {
      content
      created
      user_message_context {
        connection_id
        database
      }
    }
  }
  voiceboxConversationCount(filterInput: $filterInput) {
    count
  }
}
    `;
export const useListVoiceboxConversationsQuery = <
      TData = ListVoiceboxConversationsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: ListVoiceboxConversationsQueryVariables,
      options?: UseQueryOptions<ListVoiceboxConversationsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ListVoiceboxConversationsQuery, TError, TData>(
      variables === undefined ? ['listVoiceboxConversations'] : ['listVoiceboxConversations', variables],
      fetcher<ListVoiceboxConversationsQuery, ListVoiceboxConversationsQueryVariables>(client, ListVoiceboxConversationsDocument, variables, headers),
      options
    );
useListVoiceboxConversationsQuery.document = ListVoiceboxConversationsDocument;


useListVoiceboxConversationsQuery.getKey = (variables?: ListVoiceboxConversationsQueryVariables) => variables === undefined ? ['listVoiceboxConversations'] : ['listVoiceboxConversations', variables];
;

export const MoveCloudConnectionToOrgDocument = `
    mutation moveCloudConnectionToOrg($input: MoveCloudConnectionToOrgInput!) {
  moveCloudConnectionToOrg(input: $input) {
    success
  }
}
    `;
export const useMoveCloudConnectionToOrgMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<MoveCloudConnectionToOrgMutation, TError, MoveCloudConnectionToOrgMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<MoveCloudConnectionToOrgMutation, TError, MoveCloudConnectionToOrgMutationVariables, TContext>(
      ['moveCloudConnectionToOrg'],
      (variables?: MoveCloudConnectionToOrgMutationVariables) => fetcher<MoveCloudConnectionToOrgMutation, MoveCloudConnectionToOrgMutationVariables>(client, MoveCloudConnectionToOrgDocument, variables, headers)(),
      options
    );
export const ProfileDocument = `
    query profile {
  profile {
    id
    is_superuser
    can_manage_orgs
    is_staff
    has_updated_profile
    is_ephemeral
    is_authenticated
    is_verified
    is_designer_storage_enabled
    is_voicebox_enabled
    is_static_voicebox
    is_voicebox_api_access_enabled
    is_voicebox_think_mode_enabled
    is_voicebox_powered_suggestions_enabled
    is_voicebox_four_enabled
    is_legacy_customer_sso
    username
    first_name
    last_name
    email
    company
    title
    phone
    use_case
    stripe_customer {
      customer_id
    }
    is_databricks_user
    userflow_signature
    date_joined
    familiarity_with_kgs
    best_describes_role
    industry
    best_describes_company
  }
}
    `;
export const useProfileQuery = <
      TData = ProfileQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: ProfileQueryVariables,
      options?: UseQueryOptions<ProfileQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<ProfileQuery, TError, TData>(
      variables === undefined ? ['profile'] : ['profile', variables],
      fetcher<ProfileQuery, ProfileQueryVariables>(client, ProfileDocument, variables, headers),
      options
    );
useProfileQuery.document = ProfileDocument;


useProfileQuery.getKey = (variables?: ProfileQueryVariables) => variables === undefined ? ['profile'] : ['profile', variables];
;

export const ReauthenticateSsoConnectionDocument = `
    mutation reauthenticateSSOConnection($input: ReauthenticateSSOConnectionInput!) {
  reauthenticateSSOConnection(input: $input) {
    redirect_url
  }
}
    `;
export const useReauthenticateSsoConnectionMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ReauthenticateSsoConnectionMutation, TError, ReauthenticateSsoConnectionMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ReauthenticateSsoConnectionMutation, TError, ReauthenticateSsoConnectionMutationVariables, TContext>(
      ['reauthenticateSSOConnection'],
      (variables?: ReauthenticateSsoConnectionMutationVariables) => fetcher<ReauthenticateSsoConnectionMutation, ReauthenticateSsoConnectionMutationVariables>(client, ReauthenticateSsoConnectionDocument, variables, headers)(),
      options
    );
export const RemoveMySharedConnectionDocument = `
    mutation removeMySharedConnection($input: RemoveMySharedConnectionInput!) {
  removeMySharedConnection(input: $input) {
    success
    error
  }
}
    `;
export const useRemoveMySharedConnectionMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RemoveMySharedConnectionMutation, TError, RemoveMySharedConnectionMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RemoveMySharedConnectionMutation, TError, RemoveMySharedConnectionMutationVariables, TContext>(
      ['removeMySharedConnection'],
      (variables?: RemoveMySharedConnectionMutationVariables) => fetcher<RemoveMySharedConnectionMutation, RemoveMySharedConnectionMutationVariables>(client, RemoveMySharedConnectionDocument, variables, headers)(),
      options
    );
export const RemoveOrganizationMembersDocument = `
    mutation removeOrganizationMembers($org_domain: String!, $emails: [String!]!) {
  removeOrganizationMembers(org_domain: $org_domain, emails: $emails) {
    results {
      email
      success
      error
    }
    error
  }
}
    `;
export const useRemoveOrganizationMembersMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RemoveOrganizationMembersMutation, TError, RemoveOrganizationMembersMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RemoveOrganizationMembersMutation, TError, RemoveOrganizationMembersMutationVariables, TContext>(
      ['removeOrganizationMembers'],
      (variables?: RemoveOrganizationMembersMutationVariables) => fetcher<RemoveOrganizationMembersMutation, RemoveOrganizationMembersMutationVariables>(client, RemoveOrganizationMembersDocument, variables, headers)(),
      options
    );
export const RemovePartnerConnectionDocument = `
    mutation removePartnerConnection($input: RemovePartnerConnectionInput!) {
  removePartnerConnection(input: $input) {
    success
    error
  }
}
    `;
export const useRemovePartnerConnectionMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RemovePartnerConnectionMutation, TError, RemovePartnerConnectionMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RemovePartnerConnectionMutation, TError, RemovePartnerConnectionMutationVariables, TContext>(
      ['removePartnerConnection'],
      (variables?: RemovePartnerConnectionMutationVariables) => fetcher<RemovePartnerConnectionMutation, RemovePartnerConnectionMutationVariables>(client, RemovePartnerConnectionDocument, variables, headers)(),
      options
    );
export const RenameMySharedConnectionDocument = `
    mutation renameMySharedConnection($input: RenameMySharedConnectionInput!) {
  renameMySharedConnection(input: $input) {
    success
    error
  }
}
    `;
export const useRenameMySharedConnectionMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RenameMySharedConnectionMutation, TError, RenameMySharedConnectionMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RenameMySharedConnectionMutation, TError, RenameMySharedConnectionMutationVariables, TContext>(
      ['renameMySharedConnection'],
      (variables?: RenameMySharedConnectionMutationVariables) => fetcher<RenameMySharedConnectionMutation, RenameMySharedConnectionMutationVariables>(client, RenameMySharedConnectionDocument, variables, headers)(),
      options
    );
export const ResendEmailDocument = `
    mutation resendEmail {
  resendEmail {
    success
    error
  }
}
    `;
export const useResendEmailMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ResendEmailMutation, TError, ResendEmailMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ResendEmailMutation, TError, ResendEmailMutationVariables, TContext>(
      ['resendEmail'],
      (variables?: ResendEmailMutationVariables) => fetcher<ResendEmailMutation, ResendEmailMutationVariables>(client, ResendEmailDocument, variables, headers)(),
      options
    );
export const ResolveOrphanedConnectionsDocument = `
    mutation resolveOrphanedConnections($input: ResolveOrphanedConnectionsInput!) {
  resolveOrphanedConnections(input: $input) {
    success
    removed
    migrated
    left
  }
}
    `;
export const useResolveOrphanedConnectionsMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<ResolveOrphanedConnectionsMutation, TError, ResolveOrphanedConnectionsMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<ResolveOrphanedConnectionsMutation, TError, ResolveOrphanedConnectionsMutationVariables, TContext>(
      ['resolveOrphanedConnections'],
      (variables?: ResolveOrphanedConnectionsMutationVariables) => fetcher<ResolveOrphanedConnectionsMutation, ResolveOrphanedConnectionsMutationVariables>(client, ResolveOrphanedConnectionsDocument, variables, headers)(),
      options
    );
export const RevokeMemberConnectionRolesDocument = `
    mutation revokeMemberConnectionRoles($input: RevokeMemberConnectionRolesInput!) {
  revokeMemberConnectionRoles(input: $input) {
    error
    results {
      email
      error
      success
    }
  }
}
    `;
export const useRevokeMemberConnectionRolesMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RevokeMemberConnectionRolesMutation, TError, RevokeMemberConnectionRolesMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RevokeMemberConnectionRolesMutation, TError, RevokeMemberConnectionRolesMutationVariables, TContext>(
      ['revokeMemberConnectionRoles'],
      (variables?: RevokeMemberConnectionRolesMutationVariables) => fetcher<RevokeMemberConnectionRolesMutation, RevokeMemberConnectionRolesMutationVariables>(client, RevokeMemberConnectionRolesDocument, variables, headers)(),
      options
    );
export const RevokePersonalConnectionAccessDocument = `
    mutation revokePersonalConnectionAccess($input: RevokePersonalConnectionAccessInput!) {
  revokePersonalConnectionAccess(input: $input) {
    error
    results {
      email
      error
      success
    }
  }
}
    `;
export const useRevokePersonalConnectionAccessMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<RevokePersonalConnectionAccessMutation, TError, RevokePersonalConnectionAccessMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<RevokePersonalConnectionAccessMutation, TError, RevokePersonalConnectionAccessMutationVariables, TContext>(
      ['revokePersonalConnectionAccess'],
      (variables?: RevokePersonalConnectionAccessMutationVariables) => fetcher<RevokePersonalConnectionAccessMutation, RevokePersonalConnectionAccessMutationVariables>(client, RevokePersonalConnectionAccessDocument, variables, headers)(),
      options
    );
export const SavedConnectionsDocument = `
    query savedConnections($org_domain: String) {
  listConnections(org_domain: $org_domain) {
    id
    index
    name
    endpoint
    internalEndpoint
    cloud {
      id
      owner {
        id
        email
        username
      }
      flavor {
        name
      }
    }
    username
    token
    useBrowserAuth
    useSSO
    useConnectionSSO
    ssoTokenExchangeScope
    usesOrgSso
    access {
      id
      user {
        id
        username
      }
      organization {
        id
        name
        orgType
      }
      stardog_roles
      organization_is_enabled
      user_is_private
    }
    organization {
      id
      name
      orgType
      owner {
        id
        first_name
        last_name
        username
      }
    }
    isStardogFree
    isStardogCloud
    isAllocating
    stripeSubscription {
      url
      status
      isWaitingForPayment
      isExpired
    }
    ssoProvider {
      isValid
      clientId
      providerName
      providerType
    }
  }
}
    `;
export const useSavedConnectionsQuery = <
      TData = SavedConnectionsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: SavedConnectionsQueryVariables,
      options?: UseQueryOptions<SavedConnectionsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<SavedConnectionsQuery, TError, TData>(
      variables === undefined ? ['savedConnections'] : ['savedConnections', variables],
      fetcher<SavedConnectionsQuery, SavedConnectionsQueryVariables>(client, SavedConnectionsDocument, variables, headers),
      options
    );
useSavedConnectionsQuery.document = SavedConnectionsDocument;


useSavedConnectionsQuery.getKey = (variables?: SavedConnectionsQueryVariables) => variables === undefined ? ['savedConnections'] : ['savedConnections', variables];
;

export const GetUserSearchResultsDocument = `
    query getUserSearchResults($token: String!, $filters: UserSearchFiltersInput, $offset: Int!, $limit: Int!) {
  searchUsers(token: $token, filters: $filters, offset: $offset, limit: $limit) {
    company
    email
    first_name
    has_stardog_free
    id
    is_databricks_user
    is_staff
    is_designer_storage_enabled
    is_voicebox_enabled
    is_static_voicebox
    is_voicebox_api_access_enabled
    is_voicebox_think_mode_enabled
    is_voicebox_powered_suggestions_enabled
    is_voicebox_four_enabled
    is_verified
    last_login
    last_name
    title
  }
  getUserSearchDetails(token: $token, filters: $filters) {
    total
  }
}
    `;
export const useGetUserSearchResultsQuery = <
      TData = GetUserSearchResultsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables: GetUserSearchResultsQueryVariables,
      options?: UseQueryOptions<GetUserSearchResultsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<GetUserSearchResultsQuery, TError, TData>(
      ['getUserSearchResults', variables],
      fetcher<GetUserSearchResultsQuery, GetUserSearchResultsQueryVariables>(client, GetUserSearchResultsDocument, variables, headers),
      options
    );
useGetUserSearchResultsQuery.document = GetUserSearchResultsDocument;


useGetUserSearchResultsQuery.getKey = (variables: GetUserSearchResultsQueryVariables) => ['getUserSearchResults', variables];
;

export const SetMemberConnectionRolesDocument = `
    mutation setMemberConnectionRoles($input: SetMemberConnectionRolesInput!) {
  setMemberConnectionRoles(input: $input) {
    error
    results {
      email
      error
      success
    }
  }
}
    `;
export const useSetMemberConnectionRolesMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SetMemberConnectionRolesMutation, TError, SetMemberConnectionRolesMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SetMemberConnectionRolesMutation, TError, SetMemberConnectionRolesMutationVariables, TContext>(
      ['setMemberConnectionRoles'],
      (variables?: SetMemberConnectionRolesMutationVariables) => fetcher<SetMemberConnectionRolesMutation, SetMemberConnectionRolesMutationVariables>(client, SetMemberConnectionRolesDocument, variables, headers)(),
      options
    );
export const SetOrganizationConnectionVisibilityDocument = `
    mutation setOrganizationConnectionVisibility($input: SetOrgConnectionVisibilityInput!) {
  setOrganizationConnectionVisibility(input: $input) {
    success
    error
  }
}
    `;
export const useSetOrganizationConnectionVisibilityMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<SetOrganizationConnectionVisibilityMutation, TError, SetOrganizationConnectionVisibilityMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<SetOrganizationConnectionVisibilityMutation, TError, SetOrganizationConnectionVisibilityMutationVariables, TContext>(
      ['setOrganizationConnectionVisibility'],
      (variables?: SetOrganizationConnectionVisibilityMutationVariables) => fetcher<SetOrganizationConnectionVisibilityMutation, SetOrganizationConnectionVisibilityMutationVariables>(client, SetOrganizationConnectionVisibilityDocument, variables, headers)(),
      options
    );
export const SettingsDocument = `
    query settings {
  settings {
    auth0Auth
    azureAuth
    baseURL
    explorerVersion
    designerVersion
    friendlyName
    googleAuth
    kerberosAuth
    oktaAuth
    duoAuth
    pingAuth
    portal
    openidAuth
    sharedUserAuth
    stardogEndpoint
    studioVersion
    dataMarketplace
    homeFooterLinks
    copyConnectionTokenButtonEnabled
    requireSsoConnections
  }
}
    `;
export const useSettingsQuery = <
      TData = SettingsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: SettingsQueryVariables,
      options?: UseQueryOptions<SettingsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<SettingsQuery, TError, TData>(
      variables === undefined ? ['settings'] : ['settings', variables],
      fetcher<SettingsQuery, SettingsQueryVariables>(client, SettingsDocument, variables, headers),
      options
    );
useSettingsQuery.document = SettingsDocument;


useSettingsQuery.getKey = (variables?: SettingsQueryVariables) => variables === undefined ? ['settings'] : ['settings', variables];
;

export const TrackEventDocument = `
    mutation trackEvent($input: TrackEventInput!) {
  trackEvent(input: $input) {
    success
    error
  }
}
    `;
export const useTrackEventMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<TrackEventMutation, TError, TrackEventMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<TrackEventMutation, TError, TrackEventMutationVariables, TContext>(
      ['trackEvent'],
      (variables?: TrackEventMutationVariables) => fetcher<TrackEventMutation, TrackEventMutationVariables>(client, TrackEventDocument, variables, headers)(),
      options
    );
export const TransferCloudToUserDocument = `
    mutation transferCloudToUser($input: TransferCloudToUserInput!) {
  transferCloudToUser(input: $input) {
    success
  }
}
    `;
export const useTransferCloudToUserMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<TransferCloudToUserMutation, TError, TransferCloudToUserMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<TransferCloudToUserMutation, TError, TransferCloudToUserMutationVariables, TContext>(
      ['transferCloudToUser'],
      (variables?: TransferCloudToUserMutationVariables) => fetcher<TransferCloudToUserMutation, TransferCloudToUserMutationVariables>(client, TransferCloudToUserDocument, variables, headers)(),
      options
    );
export const TransferOrganizationOwnershipDocument = `
    mutation transferOrganizationOwnership($org_domain: String!, $email: String!) {
  transferOrganizationOwnership(org_domain: $org_domain, email: $email) {
    success
    error
  }
}
    `;
export const useTransferOrganizationOwnershipMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<TransferOrganizationOwnershipMutation, TError, TransferOrganizationOwnershipMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<TransferOrganizationOwnershipMutation, TError, TransferOrganizationOwnershipMutationVariables, TContext>(
      ['transferOrganizationOwnership'],
      (variables?: TransferOrganizationOwnershipMutationVariables) => fetcher<TransferOrganizationOwnershipMutation, TransferOrganizationOwnershipMutationVariables>(client, TransferOrganizationOwnershipDocument, variables, headers)(),
      options
    );
export const UpdateOrganizationMembersRoleDocument = `
    mutation updateOrganizationMembersRole($org_domain: String!, $emails: [String!]!, $new_role: String!) {
  updateOrganizationMembersRole(
    org_domain: $org_domain
    emails: $emails
    new_role: $new_role
  ) {
    results {
      email
      success
      error
    }
    error
  }
}
    `;
export const useUpdateOrganizationMembersRoleMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateOrganizationMembersRoleMutation, TError, UpdateOrganizationMembersRoleMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateOrganizationMembersRoleMutation, TError, UpdateOrganizationMembersRoleMutationVariables, TContext>(
      ['updateOrganizationMembersRole'],
      (variables?: UpdateOrganizationMembersRoleMutationVariables) => fetcher<UpdateOrganizationMembersRoleMutation, UpdateOrganizationMembersRoleMutationVariables>(client, UpdateOrganizationMembersRoleDocument, variables, headers)(),
      options
    );
export const UpdateOrganizationMicrosoftEntraSsoConfigDocument = `
    mutation updateOrganizationMicrosoftEntraSSOConfig($domain: String!, $input: UpdateOrganizationMicrosoftEntraSSOConfigInput!) {
  updateOrganizationMicrosoftEntraSSOConfig(domain: $domain, input: $input) {
    id
    providerType
    discoveryUrl
    clientId
    hasClientSecret
    isEnabled
    idpLogoutEnabled
    loginUrl
    redirectUri
    postLogoutRedirectUri
    createdAt
    updatedAt
  }
}
    `;
export const useUpdateOrganizationMicrosoftEntraSsoConfigMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateOrganizationMicrosoftEntraSsoConfigMutation, TError, UpdateOrganizationMicrosoftEntraSsoConfigMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateOrganizationMicrosoftEntraSsoConfigMutation, TError, UpdateOrganizationMicrosoftEntraSsoConfigMutationVariables, TContext>(
      ['updateOrganizationMicrosoftEntraSSOConfig'],
      (variables?: UpdateOrganizationMicrosoftEntraSsoConfigMutationVariables) => fetcher<UpdateOrganizationMicrosoftEntraSsoConfigMutation, UpdateOrganizationMicrosoftEntraSsoConfigMutationVariables>(client, UpdateOrganizationMicrosoftEntraSsoConfigDocument, variables, headers)(),
      options
    );
export const UpdateOrganizationOktaSsoConfigDocument = `
    mutation updateOrganizationOktaSSOConfig($domain: String!, $input: UpdateOrganizationOktaSSOConfigInput!) {
  updateOrganizationOktaSSOConfig(domain: $domain, input: $input) {
    id
    providerType
    discoveryUrl
    clientId
    hasClientSecret
    isEnabled
    idpLogoutEnabled
    loginUrl
    redirectUri
    postLogoutRedirectUri
    oktaAuthorizationServerAudience
    oktaBackendClientId
    hasOktaBackendClientSecret
    createdAt
    updatedAt
  }
}
    `;
export const useUpdateOrganizationOktaSsoConfigMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateOrganizationOktaSsoConfigMutation, TError, UpdateOrganizationOktaSsoConfigMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateOrganizationOktaSsoConfigMutation, TError, UpdateOrganizationOktaSsoConfigMutationVariables, TContext>(
      ['updateOrganizationOktaSSOConfig'],
      (variables?: UpdateOrganizationOktaSsoConfigMutationVariables) => fetcher<UpdateOrganizationOktaSsoConfigMutation, UpdateOrganizationOktaSsoConfigMutationVariables>(client, UpdateOrganizationOktaSsoConfigDocument, variables, headers)(),
      options
    );
export const UpdatePartnerConnectionDocument = `
    mutation updatePartnerConnection($input: UpdatePartnerConnectionInput!) {
  updatePartnerConnection(input: $input) {
    success
    error
  }
}
    `;
export const useUpdatePartnerConnectionMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdatePartnerConnectionMutation, TError, UpdatePartnerConnectionMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdatePartnerConnectionMutation, TError, UpdatePartnerConnectionMutationVariables, TContext>(
      ['updatePartnerConnection'],
      (variables?: UpdatePartnerConnectionMutationVariables) => fetcher<UpdatePartnerConnectionMutation, UpdatePartnerConnectionMutationVariables>(client, UpdatePartnerConnectionDocument, variables, headers)(),
      options
    );
export const UpdatePersonalConnectionAccessDocument = `
    mutation updatePersonalConnectionAccess($input: UpdatePersonalConnectionAccessInput!) {
  updatePersonalConnectionAccess(input: $input) {
    results {
      email
      success
      error
    }
    error
  }
}
    `;
export const useUpdatePersonalConnectionAccessMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdatePersonalConnectionAccessMutation, TError, UpdatePersonalConnectionAccessMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdatePersonalConnectionAccessMutation, TError, UpdatePersonalConnectionAccessMutationVariables, TContext>(
      ['updatePersonalConnectionAccess'],
      (variables?: UpdatePersonalConnectionAccessMutationVariables) => fetcher<UpdatePersonalConnectionAccessMutation, UpdatePersonalConnectionAccessMutationVariables>(client, UpdatePersonalConnectionAccessDocument, variables, headers)(),
      options
    );
export const UpdateProfileDocument = `
    mutation updateProfile($input: ProfileInput!) {
  updateProfile(input: $input) {
    id
    username
    is_authenticated
    title
    company
    phone
    use_case
    email
    familiarity_with_kgs
    best_describes_role
    industry
    best_describes_company
  }
}
    `;
export const useUpdateProfileMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateProfileMutation, TError, UpdateProfileMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateProfileMutation, TError, UpdateProfileMutationVariables, TContext>(
      ['updateProfile'],
      (variables?: UpdateProfileMutationVariables) => fetcher<UpdateProfileMutation, UpdateProfileMutationVariables>(client, UpdateProfileDocument, variables, headers)(),
      options
    );
export const UpdateUserFeaturesDocument = `
    mutation updateUserFeatures($user_id: ID!, $input: UserFeaturesInput!) {
  updateUserFeatures(user_id: $user_id, input: $input) {
    id
    is_designer_storage_enabled
    is_voicebox_enabled
    is_static_voicebox
    is_voicebox_api_access_enabled
    is_voicebox_four_enabled
    is_collaboration_enabled
  }
}
    `;
export const useUpdateUserFeaturesMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateUserFeaturesMutation, TError, UpdateUserFeaturesMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateUserFeaturesMutation, TError, UpdateUserFeaturesMutationVariables, TContext>(
      ['updateUserFeatures'],
      (variables?: UpdateUserFeaturesMutationVariables) => fetcher<UpdateUserFeaturesMutation, UpdateUserFeaturesMutationVariables>(client, UpdateUserFeaturesDocument, variables, headers)(),
      options
    );
export const UpdateVoiceboxAppDocument = `
    mutation updateVoiceboxApp($input: UpdateVoiceboxAppInput!) {
  updateVoiceboxApp(input: $input) {
    success
    error
  }
}
    `;
export const useUpdateVoiceboxAppMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpdateVoiceboxAppMutation, TError, UpdateVoiceboxAppMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpdateVoiceboxAppMutation, TError, UpdateVoiceboxAppMutationVariables, TContext>(
      ['updateVoiceboxApp'],
      (variables?: UpdateVoiceboxAppMutationVariables) => fetcher<UpdateVoiceboxAppMutation, UpdateVoiceboxAppMutationVariables>(client, UpdateVoiceboxAppDocument, variables, headers)(),
      options
    );
export const UpgradeCloudDocument = `
    mutation upgradeCloud($item: CheckoutLineItem!, $connectionId: ID!) {
  upgradeCloud(item: $item, connectionId: $connectionId) {
    url
  }
}
    `;
export const useUpgradeCloudMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<UpgradeCloudMutation, TError, UpgradeCloudMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<UpgradeCloudMutation, TError, UpgradeCloudMutationVariables, TContext>(
      ['upgradeCloud'],
      (variables?: UpgradeCloudMutationVariables) => fetcher<UpgradeCloudMutation, UpgradeCloudMutationVariables>(client, UpgradeCloudDocument, variables, headers)(),
      options
    );
export const UserPartnerConnectionsDocument = `
    query userPartnerConnections {
  profile {
    first_name
    last_name
    email
    username
  }
  userPartnerConnections {
    databricks_workspace_id
    jdbc_url
    workspace_url
    user_email
    connection_id
    user_first_name
    is_configured_resources
    databricks_connection_name
    stardog_server_connection {
      name
      id
      isStardogCloud
      index
      endpoint
    }
    databricks_personal_token_id
    http_path
    cluster_id
  }
}
    `;
export const useUserPartnerConnectionsQuery = <
      TData = UserPartnerConnectionsQuery,
      TError = unknown
    >(
      client: GraphQLClient,
      variables?: UserPartnerConnectionsQueryVariables,
      options?: UseQueryOptions<UserPartnerConnectionsQuery, TError, TData>,
      headers?: RequestInit['headers']
    ) =>
    useQuery<UserPartnerConnectionsQuery, TError, TData>(
      variables === undefined ? ['userPartnerConnections'] : ['userPartnerConnections', variables],
      fetcher<UserPartnerConnectionsQuery, UserPartnerConnectionsQueryVariables>(client, UserPartnerConnectionsDocument, variables, headers),
      options
    );
useUserPartnerConnectionsQuery.document = UserPartnerConnectionsDocument;


useUserPartnerConnectionsQuery.getKey = (variables?: UserPartnerConnectionsQueryVariables) => variables === undefined ? ['userPartnerConnections'] : ['userPartnerConnections', variables];
;

export const VerifyInvitationDocument = `
    mutation verifyInvitation($input: InvitationFlagInput!) {
  verifyInvitation(input: $input) {
    success
    error
  }
}
    `;
export const useVerifyInvitationMutation = <
      TError = unknown,
      TContext = unknown
    >(
      client: GraphQLClient,
      options?: UseMutationOptions<VerifyInvitationMutation, TError, VerifyInvitationMutationVariables, TContext>,
      headers?: RequestInit['headers']
    ) =>
    useMutation<VerifyInvitationMutation, TError, VerifyInvitationMutationVariables, TContext>(
      ['verifyInvitation'],
      (variables?: VerifyInvitationMutationVariables) => fetcher<VerifyInvitationMutation, VerifyInvitationMutationVariables>(client, VerifyInvitationDocument, variables, headers)(),
      options
    );